const everythingBundleDataCache = {
  "bundle": {
    "bundle": [
      {
        "cursor": "eyJsYXN0X2lkIjo4NTI4ODYxMDM2ODExLCJsYXN0X3ZhbHVlIjo4NTI4ODYxMDM2ODExLCJvZmZzZXQiOjY3fQ==",
        "node": {
          "title": "Ableton Live Presets Bundle",
          "handle": "ableton-live-presets-bundle",
          "createdAt": "2024-03-27T00:25:03Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "6+ Ableton Packs including 600+ Presets & 600+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/ableton_presets_ph_700x.png?v=1711499287"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Ableton_Presets_Bundle_Collection_Preview128.mp3?v=1711632806"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Including over 500+ Professionally Designed Ableton Presets and 500+ MIDI files for instant inspiration!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NjkzNzAwMzI5NzM5LCJsYXN0X3ZhbHVlIjo4NjkzNzAwMzI5NzM5LCJvZmZzZXQiOjU2fQ==",
        "node": {
          "title": "Academy Bundle",
          "handle": "pml-academy-bundle",
          "createdAt": "2024-07-01T14:58:26Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "6 Full Length PML Academies"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Academy_bundleBox_700x.png?v=1720534348"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DJ_Set_MTA_5.mp3?v=1680789680"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Level up your music with the full Start to Finish Academies packed with production techniques, music business tips, and professional genre sound libraries. You'll learn from music industry professionals how to produce label ready music in a variety of genres and get the sounds to jump start your next track!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjM3Mjk1ODYyMDI3LCJsYXN0X3ZhbHVlIjo4MjM3Mjk1ODYyMDI3LCJvZmZzZXQiOjEwN30=",
        "node": {
          "title": "Acoustic Melodic House Themes Bundle",
          "handle": "acoustic-melodic-house-themes-bundle",
          "createdAt": "2023-05-04T11:30:40Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "Acoustic Melodic House Themes Vol. 1-5"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/OT-bundle3_700x.png?v=1683201662"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Demo_AcousticVol2.mp3?v=1669126416"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This bundle includes the best orchestral samples meeting contemporary Melodic House & Techno producers - the result is a collection of melody, tonal percussion and song starter loops, that will spark infinite ideas!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4Njk4NjAzMzQwMDQzLCJsYXN0X3ZhbHVlIjo4Njk4NjAzMzQwMDQzLCJvZmZzZXQiOjU1fQ==",
        "node": {
          "title": "Afro House Bundle",
          "handle": "afro-house-bundle",
          "createdAt": "2024-07-03T11:52:29Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "1500+ Samples, 170+ Serum Presets, 17+ Ableton Templates"
          },
          "enhancedDescription": {
            "value": "Here's your next Afro House track. This bundle includes 3 Afro House Style Sound packs that include over 1000+ samples, 100+ Serum Presets and MIDIs, 12 Fully Produced Ableton project files to get you going."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/afro_house_bundle_v1_700x.png?v=1720022279"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Afro_House_-_Wonder__Live_11.1___Serum.mp3?v=1719305455"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Here's your next Afro House track. This bundle includes 4 Afro House Style Sound packs that include over 1500+ samples, 170+ Serum Presets and MIDIs, 17 Fully Produced Ableton project files and more."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDk4OTc1MTg2LCJsYXN0X3ZhbHVlIjo4NDk4OTc1MTg2LCJvZmZzZXQiOjM4NX0=",
        "node": {
          "title": "All Courses Bundle - Complete Music Production Academy",
          "handle": "complete-courses-bundle",
          "createdAt": "2016-11-21T23:13:01Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "All Ableton Courses"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/AllAbletonCoursesEdition1_700x.png?v=1641502062"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "30+ Courses in 4 Different Modules from Beginner to Advance in easy, step by step instructions. Everything you need to fast track your development to making professional quality music."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NjM2MDU3NjkwMTc3LCJsYXN0X3ZhbHVlIjo2NjM2MDU3NjkwMTc3LCJvZmZzZXQiOjE5N30=",
        "node": {
          "title": "All Sounds Bundle - Edition 2025",
          "handle": "all-sounds-bundle",
          "createdAt": "2021-10-18T10:10:06Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "All Sounds Released On PML through the End of the Year"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/AllSoundsBundleEdition1_700x.png?v=1641501822"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "You get all of the sounds in the PML store including all fully produced Ableton templates, Artist/\"In The Style\" of packs, professionally produced samples presets for various Synths, MIDI packs and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxODgxODQwMDU4NDMzLCJsYXN0X3ZhbHVlIjoxODgxODQwMDU4NDMzLCJvZmZzZXQiOjMxM30=",
        "node": {
          "title": "Classics: Harmony Bundle - Learn Melody, Chords and Arrangement for Electronic Music",
          "handle": "harmony-bundle",
          "createdAt": "2018-11-18T20:44:44Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "4 Courses on Harmony"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/harmony-bundle_700x.png?v=1649418279"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Take your productions to the next level! Learn the foundations of music theory with 3 different courses covering chords, melody and arrangement. BONUS: Get 950+ professional Midi files to inspire and speed up your workflow!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjUwMzkzODk0OTc3LCJsYXN0X3ZhbHVlIjo0NjUwMzkzODk0OTc3LCJvZmZzZXQiOjIyOX0=",
        "node": {
          "title": "Deep Premium Drum Pack Bundle",
          "handle": "deep-premium-drum-pack-bundle",
          "createdAt": "2021-01-28T10:22:12Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "All Versions of our Deep Premium Drum Sample Series"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/dpbundle_700x.png?v=1649261884"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DPV6-collection-Demo.mp3?v=1650562484"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "8000+ Royalty Free Pro Drum Samples, Loops and Midi. Get Every Edition of Our Flagship Drum Sample Packs!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4Mjc2NzIyMjIxMzIzLCJsYXN0X3ZhbHVlIjo4Mjc2NzIyMjIxMzIzLCJvZmZzZXQiOjk3fQ==",
        "node": {
          "title": "Diva Presets Bundle",
          "handle": "diva-presets-bundle",
          "createdAt": "2023-06-27T15:18:34Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "20+ Diva Preset Packs including 1500+ Presets & 1000 MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/divabundle2.4newpreliminary1_eebc465f-688d-47c7-a488-4ac2f6790753_700x.png?v=1707755998"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Diva_Bundle_Demo_Mix.mp3?v=1697468780"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Including over 1000+ Professionally Designed Diva Presets and MIDI files for instant inspiration!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDY2MzIzNTQ2Mzc5LCJsYXN0X3ZhbHVlIjo4MDY2MzIzNTQ2Mzc5LCJvZmZzZXQiOjEyN30=",
        "node": {
          "title": "Everything Bundle - Collector's Edition 2022",
          "handle": "everything-bundle-collectors-edition-2022",
          "createdAt": "2022-12-30T13:01:58Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "All courses and sound packs in the store released in 2022 and before."
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/everythingbundlecollectorsedition22_700x.png?v=1676541819"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DivaCercleVol2_demo.mp3?v=1623751767"
          },
          "musicPersists": {
            "value": "0"
          },
          "seo": {
            "description": "Complete step-by-step music production lessons, melody and chord writing, sound design, start to finish sessions, mixing and mastering and all sound packs."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDE4MjE0MTE3NjQzLCJsYXN0X3ZhbHVlIjo4NDE4MjE0MTE3NjQzLCJvZmZzZXQiOjc3fQ==",
        "node": {
          "title": "Everything Bundle - Collector's Edition 2023",
          "handle": "everything-bundle-collectors-edition-2023",
          "createdAt": "2024-01-02T14:10:11Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "All courses and sound packs in the store released in 2023 and before."
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/EVB-CE23-red-band-2023-edition_700x.png?v=1705921707"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/ebcey23.mp3?v=1683631308"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Complete step-by-step music production lessons, melody and chord writing, sound design, start to finish sessions, mixing and mastering and all sound packs."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDY2NDk5NTEwNTM5LCJsYXN0X3ZhbHVlIjo4MDY2NDk5NTEwNTM5LCJvZmZzZXQiOjEyNn0=",
        "node": {
          "title": "Everything Bundle - Year Edition (All Courses  & All Sound Packs of 2023)",
          "handle": "everything-bundle-year-2023",
          "createdAt": "2022-12-30T16:38:54Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "All courses and sound packs released in 2023. "
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/products-EVBYearEdition_700x.png?v=1691063124"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Solanca_TogetherAgain_demo.mp3?v=1654257598"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Save years of your life by starting with the right sounds and instructions. Start to Finish Courses & Masterclasses: learn from professional producers working with top labels. Also: 5 full albums of (50+) fully editable Ableton Templates, brand new Collections of Serum & Diva Presets with signature sounds."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDE5MDUwNzgyOTg3LCJsYXN0X3ZhbHVlIjo4NDE5MDUwNzgyOTg3LCJvZmZzZXQiOjc2fQ==",
        "node": {
          "title": "Everything Bundle - Year Edition (All Courses  & All Sound Packs of 2024)",
          "handle": "everything-bundle-year-edition-2024",
          "createdAt": "2024-01-03T15:17:28Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "All courses and sound packs released in 2024."
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/EVB-YE-24-REDBANNER24_700x.png?v=1735995908"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Melodic_Techno_-_005_-_Exhale__Live_11_and_Serum.mp3?v=1709637083"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Save years of your life by starting with the right sounds and instructions. Get all products from PML released in 2024."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTU2OTc4OTg3Mjc1LCJsYXN0X3ZhbHVlIjo4OTU2OTc4OTg3Mjc1LCJvZmZzZXQiOjM3fQ==",
        "node": {
          "title": "Everything Bundle - Year Edition (All Courses & All Sound Packs of 2025)",
          "handle": "everything-bundle-year-edition-2025",
          "createdAt": "2024-12-20T12:42:14Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "All courses and sound packs released in 2025."
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/EVB_YE_25_700x.png?v=1734698610"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Mystique-MT-DemoMix2.mp3?v=1736433287"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Save years of your life by starting with the right sounds and instructions. Get all products from PML released in 2025."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTU3OTE2NjQ3NjkxLCJsYXN0X3ZhbHVlIjo3OTU3OTE2NjQ3NjkxLCJvZmZzZXQiOjE2NX0=",
        "node": {
          "title": "Full Melodic House - Bundle Vol.1",
          "handle": "full-melodic-house-bundle",
          "createdAt": "2022-05-09T14:57:26Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "3 Courses, 3 Style Guide Packs, 2 Sample Packs, 3 Diva Preset Packs, 2 Serum Preset Packs, 15+ Full Templates"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/MELODIC-TECH-ACC_700x.png?v=1678260795"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/BenBohmerStyleMelodicDeepSoundPack.mp3?v=1623673056"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The Perfect Bundle for Music Producers who want to take it to the next level. 3 Full Online Courses and a Premium Selection of Sound Packs, Sample Packs, and Preset Packs. Get enabled and inspired, invest in your Music Career - Let's Get Started"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTU3OTE3NTMyNDI3LCJsYXN0X3ZhbHVlIjo3OTU3OTE3NTMyNDI3LCJvZmZzZXQiOjE2NH0=",
        "node": {
          "title": "Full Techno Accelerator Bundle Vol.1",
          "handle": "techno-producer-bundle",
          "createdAt": "2022-05-09T14:58:32Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "3 Full Online Courses, 2 Style Guide Packs, 2 Samples Packs, 1 Diva Preset Pack, 2 Serum Preset Packs, 12+ Ableton Templates"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PMLbundlesTechnoAcceleratorbg2_700x.png?v=1716978995"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_Darkside_FknSrs_01.mp3?3127669378200489135"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The Perfect Bundle for Music Producers who want to take it to the next level. 3 Full Online Courses and a Premium Selection of Sound Packs, Sample Packs, and Preset Packs. Get enabled and inspired, invest in your Music Career - Let's Get Started"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTU3OTE1OTkyMzMxLCJsYXN0X3ZhbHVlIjo3OTU3OTE1OTkyMzMxLCJvZmZzZXQiOjE2Nn0=",
        "node": {
          "title": "Melodic Techno Accelerator Vol.1",
          "handle": "full-melodic-techno-bundle",
          "createdAt": "2022-05-09T14:56:43Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "2 Courses, 3 Artist Packs, 2 Sample Packs, 2 Serum Packs, 19+ Templates"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PMLbundlesMelodicTechnoAcceleratorbgbet1_700x.png?v=1708958576"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/pre_sample_pack_joao.mp3?17386132699230783354"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The Perfect Bundle for Music Producers who want to take it to the next level. 2 Full Online Courses and a Premium Selection of Sound Packs, Sample Packs, and Preset Packs. Get enabled and inspired, invest in your Music Career - Let's Get Started"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NDYxMjQyMDU2NzY5LCJsYXN0X3ZhbHVlIjo0NDYxMjQyMDU2NzY5LCJvZmZzZXQiOjI1NX0=",
        "node": {
          "title": "Mixing and Mastering Bundle",
          "handle": "mixing-and-mastering-courses",
          "createdAt": "2020-05-03T11:31:21Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "4 Full Length Mixing and Mastering Courses"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/MixingandMasteringBundlenew_700x.png?v=1652189958"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": null
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MTkwMDk4ODAwOTA3LCJsYXN0X3ZhbHVlIjo4MTkwMDk4ODAwOTA3LCJvZmZzZXQiOjExM30=",
        "node": {
          "title": "Organic Sounds Bundle",
          "handle": "organic-sounds-bundle",
          "createdAt": "2023-03-22T15:57:50Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "3000+ Organic Sounds, 140+ Diva Presets, 8+ Ableton Templates"
          },
          "enhancedDescription": {
            "value": "This wonderfully unique bundle includes 7 Organic Style Sound packs that include over 3000+ samples, 140+ Diva Presets, 12 Fully Produced Ableton project files and is full of surprising problem solvers."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/organicsoundsbundlebox1_700x.png?v=1729680591"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Organica3_Preview.mp3?v=1679410026"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This bundle includes 7 Organic Style Sound packs that include over 3000+ samples, 140+ Diva Presets, 8 Fully Produced Ableton style sound packs and more."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzcwNzU1NjY1OTg1LCJsYXN0X3ZhbHVlIjo2NzcwNzU1NjY1OTg1LCJvZmZzZXQiOjE3M30=",
        "node": {
          "title": "PML Samples Bundle",
          "handle": "samples-bundle",
          "createdAt": "2022-03-23T17:04:44Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "20,000+ Royalty-Free Samples from Various Packs. No 3rd Party Software Required."
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/samples4_700x.png?v=1648055215"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DeepPremium4Demo.mp3?v=1623765504"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "20,000+ Royalty Free Samples professionally crafted and ready-to-use! Melodic, Deep, House, Techno, Organic and Underground music. No software additional software required, use with any DAW. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzIyOTI4OTAyNDExLCJsYXN0X3ZhbHVlIjo4MzIyOTI4OTAyNDExLCJvZmZzZXQiOjg4fQ==",
        "node": {
          "title": "Serum Presets Bundle",
          "handle": "serum-preset-bundle",
          "createdAt": "2023-09-12T13:32:08Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "18 Serum Preset Packs including 1400+ Serum Presets & 950+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/serum-bundle-updated1and2-sm_700x.png?v=1742381546"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/SerumTechnoVol3Playbutton.mp3?v=1693583716"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Including over 1000+ Professionally Designed Serum Presets and MIDI files for instant inspiration!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4Mjk5ODMxMzI5MDM1LCJsYXN0X3ZhbHVlIjo4Mjk5ODMxMzI5MDM1LCJvZmZzZXQiOjkyfQ==",
        "node": {
          "title": "Sound Design Bundle",
          "handle": "pml-sound-design-bundle",
          "createdAt": "2023-08-04T14:26:30Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "3 Sound Design Courses, 3 Preset Packs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/SoundDesignBundle_700x.png?v=1691161388"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pigments_CoursePreview.mp3?v=1670933261"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This bundle comes packed with the presets and knowledge to create the sounds of modern EDM with today's top synthesizers. You get 3 different courses and 3 preset packs designed by professional producers."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTY3MTcyNDkzNTc5LCJsYXN0X3ZhbHVlIjo3OTY3MTcyNDkzNTc5LCJvZmZzZXQiOjE1OX0=",
        "node": {
          "title": "Vital Presets Bundle",
          "handle": "vital-presets-bundle",
          "createdAt": "2022-06-01T13:59:32Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "360+ Vital Presets and 290+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/vitalbundle_700x.png?v=1654097428"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Vital_Presets_Bundle.mp3?v=1654252016"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "364 Vital Presets, professionally produced, for Melodic, Deep, House, Techno and Underground music. 292 MIDI files, ready-to-use, and tailored made for these presets"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NTgyMjk3MjU2MjAzLCJsYXN0X3ZhbHVlIjo4NTgyMjk3MjU2MjAzLCJvZmZzZXQiOjYyfQ==",
        "node": {
          "title": "Vocals Bundle",
          "handle": "vocals-bundle",
          "createdAt": "2024-05-08T10:52:59Z",
          "pmlProductCategory": {
            "value": "bundle--bundle"
          },
          "catalogDescription": {
            "value": "1900+ Vocal Samples - Royalty free, keylabeled and ready-to-use"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/vocals-bundle-4_700x.png?v=1715165826"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Vocals_Bundle_Playbutton.mp3?v=1715171222"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Get instant pro vocals! This bundle includes 2000+ professionally recorded and produced dry/wet vocal samples, key labeled, royalty-free, and ready to inspire your next track! "
          }
        }
      }
    ]
  },
  "course": {
    "masterclasses": [
      {
        "cursor": "eyJsYXN0X2lkIjo0NTkyNjAwNTQ3MzkzLCJsYXN0X3ZhbHVlIjo0NTkyNjAwNTQ3MzkzLCJvZmZzZXQiOjI0NH0=",
        "node": {
          "title": "Ableton Session View Masterclass",
          "handle": "ableton-session-view-masterclass",
          "createdAt": "2020-10-02T16:18:04Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "In this updated Masterclass on the Ableton Live Session View, you will learn everything about clips, scenes, loops and eventually recording your ideas to full tracks into the Live 11 Arrangement View. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/session_700x.png?v=1649419126"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Welcome to the all new Session View Masterclass! You will learn everything about clips, scenes, loops and eventually recording your ideas to full tracks into the Arrangement View. This course has been updated for Ableton Live 11"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0Mzk1NzgyMTQ0MDY1LCJsYXN0X3ZhbHVlIjo0Mzk1NzgyMTQ0MDY1LCJvZmZzZXQiOjI1OH0=",
        "node": {
          "title": "Analog meets Digital",
          "handle": "analog-meets-digital",
          "createdAt": "2020-02-07T17:40:05Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/25-AnalogmeetsDigitalBoxv3_700x.png?v=1651581486"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "This course shows you step by step how to integrate your Analog gear, such as Eurorack synths, MOOG synths and more, into Ableton Live for a seamless workflow. Sync audio and Midi from your entire studio inside Ableton!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5MDM2Nzc2OTk3MTMxLCJsYXN0X3ZhbHVlIjo5MDM2Nzc2OTk3MTMxLCJvZmZzZXQiOjMxfQ==",
        "node": {
          "title": "Arrangement Academy",
          "handle": "arrangement-academy",
          "createdAt": "2025-02-11T10:27:00Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "6 Step Full Length Course Program designed to teach Arrangement of Melodic House, Techno, Tech House, Melodic Techno and more!"
          },
          "enhancedDescription": {
            "value": "Turn your loops into finished tracks with the Arrangement Academy. Analyze pro tracks, master hands-on techniques, and apply proven strategies for real results."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/ArrangementAcademyBox_Square_700x.png?v=1739271284"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/ArrangmentAcademyTopAudio_01.mp3?v=1739273042"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Turn your loops into finished tracks with the Arrangement Academy. Analyze pro tracks, master hands-on techniques, and apply proven strategies for real results."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NzkyMDU4Mzk2OTM5LCJsYXN0X3ZhbHVlIjo4NzkyMDU4Mzk2OTM5LCJvZmZzZXQiOjUzfQ==",
        "node": {
          "title": "Complete Afro House Start to Finish Academy",
          "handle": "complete-afro-house-start-to-finish-academy",
          "createdAt": "2024-08-29T11:52:19Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "12h+ Hours of Content including 6 Full Length Course Program, 8+ Sound Packs, 12+ Ableton Project Files, Serum Presets and more"
          },
          "enhancedDescription": {
            "value": "A full Start to Finish course that Includes the Afro House vocal samples you need for vibe, signature percussive sounds, full 6-step lessons program, presets, MIDIs and a full album of editable project files. Learn from professional artists and engineers working with top labels."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/AFRO_AHA_Final_Box_Satur_700x.png?v=1724932383"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/AfroHouse_DJ_Mix_AHA_Shorter.mp3?v=1724932155"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A complete program for Afro House, including a 6 step course program, sample libraries, preset packs, Ableton Templates and more by professional producers."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDE1MzY1Njc0NjI1MSwibGFzdF92YWx1ZSI6MTAxNTM2NTY3NDYyNTEsIm9mZnNldCI6MjB9",
        "node": {
          "title": "Complete Classic House Start to Finish Academy",
          "handle": "complete-classic-house-start-to-finish-academy",
          "createdAt": "2025-04-28T10:20:43Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "12h+ Hours of Content including 6 Full Length Course Program, 8+ Sound Packs, 12+ Ableton Project Files, Serum Presets and more"
          },
          "enhancedDescription": {
            "value": "A full Start to Finish program that Includes the Classic House vocal samples you need for vibe, signature percussive sounds, full 6-step lessons program, presets, MIDIs and a full album of editable project files. Learn from professional artists and engineers working with top labels."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/ClasssicHouseAcademy_Box_700x.png?v=1745835781"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DJ_Mix2.mp3?v=1745942526"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A complete program for Classic House, including a 6 step course program, sample libraries, preset packs, Ableton Templates and more by professional producers."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MTY2NDY0NzgyNjAzLCJsYXN0X3ZhbHVlIjo4MTY2NDY0NzgyNjAzLCJvZmZzZXQiOjExNn0=",
        "node": {
          "title": "Complete Melodic House Start to Finish Academy",
          "handle": "pml-melodic-house-start-to-finish-academy",
          "createdAt": "2023-03-02T16:28:46Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "25h+ Hours of Content including 9 Full Length Courses, 6+ Sound Packs, 10+ Ableton Project Files, 90+ Diva Presets and more"
          },
          "enhancedDescription": {
            "value": "This Start to Finish course program, including an extensive sound pack library, is built for every Melodic House producer that wants to take the next step and sign with a label. Five different tutors will show their production techniques and 2 label A&Rs (Anjunadeep & Sekora) tell you how to increase your chances of getting signed."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/MelodicHouseStartToFinishAcademy_700x.png?v=1677847616"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Tides_Master.mp3?v=1678195721"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This is the most complete program for Melodic House on PML - seriously.\nRoadmap from an empty Ableton project to the do’s and don’ts of applying to Melodic House labels like Anjunadeep or Sekora.\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjA0OTgyNDUyNDkxLCJsYXN0X3ZhbHVlIjo4MjA0OTgyNDUyNDkxLCJvZmZzZXQiOjExMX0=",
        "node": {
          "title": "Complete Melodic Techno Start to Finish Academy",
          "handle": "complete-melodic-techno-start-to-finish-academy",
          "createdAt": "2023-04-03T15:52:18Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "17h+ Hours of Content including 13 Full Length Courses, 6+ Sound Packs, 10+ Ableton Project Files, Serum Presets and more"
          },
          "enhancedDescription": {
            "value": "Time to level up your Melodic Techno productions with 10+ fully produced tracks as Ableton Project files, Serum soundbank with MIDI Song starters, a massive Drum Library and a step by step Start to Finish Course Program with signature sound. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/Melodic-House-Academy_1_700x.png?v=1688122316"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DJ_Set_MTA_5.mp3?v=1680789680"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This is the most complete program for Melodic Techno on PML - seriously. Learn from professional producers and engineers working with today's top Melodic Techno Labels."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDczNTAxNDM0MTIzLCJsYXN0X3ZhbHVlIjo4NDczNTAxNDM0MTIzLCJvZmZzZXQiOjcxfQ==",
        "node": {
          "title": "Complete Melodic Techno Start to Finish Academy Vol.2",
          "handle": "complete-melodic-techno-start-to-finish-academy-vol-2",
          "createdAt": "2024-02-19T16:26:32Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "15h+ Hours of Content including 7 Step Course Program, 5+ Sound Packs, 15+ Ableton Project Files, Serum Presets and more"
          },
          "enhancedDescription": {
            "value": "The Melodic Techno Start To Finish Vol.2 (all new content) will take you through the entire process of producing, mixing, mastering your track and submitting to the labels. Jump start your next Melodic Techno Track with included professional samples, presets and a full album of templates!"
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/mta2_v1_reduce_700x.png?v=1711709615"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/MTA2_Collection.mp3?v=1709661397"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The follow up to the Complete Melodic Techno Academy. Includes ALL BRAND NEW CONTENT: courses, samples, presets, MIDI and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NzUyMjE3NzUxODE5LCJsYXN0X3ZhbHVlIjo4NzUyMjE3NzUxODE5LCJvZmZzZXQiOjU0fQ==",
        "node": {
          "title": "Complete Tech House Start to Finish Academy",
          "handle": "complete-tech-house-academy-to-finish-academy",
          "createdAt": "2024-07-29T13:17:52Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "10h+ Hours of Content including 4 Full Length Course Program, 4+ Sound Packs, 10+ Ableton Project Files, Serum Presets and more"
          },
          "enhancedDescription": {
            "value": "A full Start to Finish 4-step program for Tech House, multiple Tech House drum and vocal sample libraries, Serum preset packs and MIDIs, and a fully arranged editable album of Ableton Templates. Learn from professional producers, artists like Fab Massimo and Marten Hørger, and engineers working with today's top labels."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/THAMainBox-adjust-darker_700x.png?v=1722352916"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/THA_Demo_Mix_2.mp3?v=1722356120"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This is the most complete program for Tech House on PML, including a 4 step course program, multiple Tech House sample libraries, preset packs, Ableton Templates and more. Learn from professional producers, artists, and engineers working with today's top labels."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NjAzMjEzNTk0ODkxLCJsYXN0X3ZhbHVlIjo4NjAzMjEzNTk0ODkxLCJvZmZzZXQiOjYxfQ==",
        "node": {
          "title": "Complete Techno Start to Finish Academy",
          "handle": "complete-techno-start-to-finish-academy",
          "createdAt": "2024-05-24T14:12:34Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "13h+ Hours of Content including 6 Full Length Course Program, 6+ Sound Packs, 8+ Ableton Project Files, Serum Presets and more"
          },
          "enhancedDescription": {
            "value": "Take your Techno tracks to the next level from start to finish learning from tutors like Raveyard and Drumcode releasing artists like Heerhorst and Weska. Included is a massive Techno Sound Library, Presets and 8+ fully produced Ableton Project files as song starters. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/MainBoxFinal_700x.png?v=1716798721"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/TechnoAcademyPlaybutton.mp3?v=1716894367"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This is the most complete program for Techno on PML - seriously. Learn from professional producers, artists, and engineers working with today's top Techno Labels."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTkyMTYzNjc2MjI1LCJsYXN0X3ZhbHVlIjo2NTkyMTYzNjc2MjI1LCJvZmZzZXQiOjIwM30=",
        "node": {
          "title": "Masterclass: Ben Böhmer - In The Studio",
          "handle": "ben-bohmer-master-class",
          "createdAt": "2021-08-24T14:54:34Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "Follow Ben explaining how his track \"Beyond Beliefs\" came together - from the first idea to the final mix while talking idea generation, production process, favourite effects and processing techniques as well as how Ben selects sounds & samples before taking on arrangement & mixing."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/ben-masterclass-NEW2_700x.png?v=1653990852"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1752679716912.9958-DJ_Mix_2_Sunset_Vibes.mp3"
          },
          "musicPersists": {
            "value": "0"
          },
          "seo": {
            "description": "Ben Böhmer Style  Sound Pack for Ableton. MIDIs, Samples and More"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTg1OTcyMzE0Mzc5LCJsYXN0X3ZhbHVlIjo3OTg1OTcyMzE0Mzc5LCJvZmZzZXQiOjE1NH0=",
        "node": {
          "title": "Masterclass: Cioz - How to Remix (Diplo, Damian Lazarus, Jungle: Don’t Be Afraid)",
          "handle": "masterclass-cioz-how-to-remix-diplo-damian-lazarus-jungle-don-t-be-afraid",
          "createdAt": "2022-07-25T11:09:45Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "Stil vor Talent artist Cioz walks you through his process of remixing a track step by step and in close detail. Learn how he worked around and with original stems from Diplo, Damian Lazarus & Jungle’s cooperation in “Don’t be afraid”."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/CiozPB_700x.png?v=1658764399"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PMLXSVTxCioz-_Cioz_FlowState.mp3?v=1637315313"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Stil vor Talent artist Cioz walks you through his process of remixing a track step by step and in close detail. You will see all original stems from Diplo, Damian Lazarus & Jungle’s cooperation in “Don’t be afraid”.\n\n“I will show you exactly how I did this remix and open all files for you!” - Cioz"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTYwNDMyOTY3OTQ3LCJsYXN0X3ZhbHVlIjo3OTYwNDMyOTY3OTQ3LCJvZmZzZXQiOjE2M30=",
        "node": {
          "title": "Masterclass: Creative Sound Design with the Moog Sub37",
          "handle": "masterclass-creative-sound-design-with-the-moog-sub37",
          "createdAt": "2022-05-12T09:19:57Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course with Sound Files"
          },
          "enhancedDescription": {
            "value": "Berlin-based Organic House artist Yannek Maunz, will enable you to be more proficient, professional and creative in your sound design - on analog AND digital synths! Demonstrated on the Sub37, Yannek shows you hacks & tricks to achieve any sound faster & better."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/yannek-moog12_700x.png?v=1652868474"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Sub37_Patches_Demo_01.mp3?v=1654249137"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "After this class with Berlin-based Organic House artist Yannek Maunz, you will be more proficient, professional and creative in your sound design - on analog AND digital synths! Demonstrated on the Sub37, Yannek shows you hacks & tricks to achieve any sound faster & better."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDIxMTIwMDkwMzc5LCJsYXN0X3ZhbHVlIjo4MDIxMTIwMDkwMzc5LCJvZmZzZXQiOjEzMn0=",
        "node": {
          "title": "Masterclass: Jimi Jules",
          "handle": "masterclass-jimi-jules",
          "createdAt": "2022-11-14T11:35:51Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "In this Masterclass, Jimi Jules provides a complete shift of perspective by focusing on his workflow of carving ideas out of what first seems to be a chaotic musical mess. Truly inspiring."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PACK_JIMIJULES-masterclass_700x.png?v=1668507992"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/JJ_Playbutton_Masterclass.mp3?v=1668516086"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "In this Masterclass, Jimi Jules provides a complete shift of perspective by focusing on the creative process and his workflow of carving ideas out of what first seems to be a chaotic musical mess.\n“With me you’ll learn to listen to your ideas rather than specific EQ settings” - Jimmy Jules"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDIwNzY2MzUxNjI3LCJsYXN0X3ZhbHVlIjo4NDIwNzY2MzUxNjI3LCJvZmZzZXQiOjc1fQ==",
        "node": {
          "title": "Masterclass: Julia Borelli - Mixing and Mastering",
          "handle": "masterclass-julia-borelli-mixing-and-mastering",
          "createdAt": "2024-01-05T12:25:43Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "Discover the art of mixing and mastering with Julia Borelli, a leading engineer in the industry (mixed for Afterlife, Armada, Anjunadeep and many more), as she shares the techniques and secrets she uses when mixing and mastering today's top artists."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Masterclass-MixingandMasteringbyJuliaBorelli_700x.png?v=1704468213"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/JuliaBorelli_Playbutton.mp3?v=1704806545"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Discover the art of mixing and mastering with Julia Borelli, a leading engineer in the industry, as she shares the techniques and secrets she uses to mix and master today's top artists!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NjkwODA4MjAxMjgxLCJsYXN0X3ZhbHVlIjo2NjkwODA4MjAxMjgxLCJvZmZzZXQiOjE5Mn0=",
        "node": {
          "title": "Masterclass: Melodic Techno with Jonas Saalbach",
          "handle": "jonas-saalbach-masterclass",
          "createdAt": "2021-12-10T09:17:19Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/jonas-masterclass2_700x.png?v=1649673420"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/BenBohmerStyleMelodicDeepSoundPack.mp3?v=1623673056"
          },
          "musicPersists": {
            "value": "0"
          },
          "seo": {
            "description": "Jonas invited PML to his studio in Berlin Funkhaus to share an intimate look in his production process and the outboard gear he uses. He opens up EVERY midi, audio and effect setting walking through his track “Transformation”."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzgyNzY3MzAwODc1LCJsYXN0X3ZhbHVlIjo4MzgyNzY3MzAwODc1LCJvZmZzZXQiOjc4fQ==",
        "node": {
          "title": "Masterclass: Super Flu",
          "handle": "masterclass-super-flu",
          "createdAt": "2023-11-29T14:37:54Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "In this Masterclass, Super Flu shows their creative process and workflow in the studio with Ableton Live. Discover arrangement hacks used by pros to create evolving tracks that keep your listeners engaged. This is for: everybody who wants to create their signature sound!"
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Masterclass-SuperFlu_PML312_700x.png?v=1701269141"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Super_Flu_-_Snippet_for_Playbutton.mp3?v=1684162381"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "In this Masterclass, Super Flu shows their creative process and workflow in the studio with Ableton Live."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjozNDgyNzMxNDEzNTY5LCJsYXN0X3ZhbHVlIjozNDgyNzMxNDEzNTY5LCJvZmZzZXQiOjI4Nn0=",
        "node": {
          "title": "Push 2 Masterclass",
          "handle": "push-2-masterclass",
          "createdAt": "2019-04-18T13:52:26Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "From unboxing to your first Track - this course will teach you how to use Ableton Push. All features, all layers, and all settings. Follow along the full production process using Ableton Live 10 (or higher) and Push 2 with tutor Attila. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/13-push2_700x.png?v=1651058538"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "From unboxing to your first Track - this course will teach you how to use Push 2. All features, all layers, and all settings. Follow along the full production process using Push 2. Ableton Live 10 + Push 2. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4Mjg5MzI1Mjg1NjQzLCJsYXN0X3ZhbHVlIjo4Mjg5MzI1Mjg1NjQzLCJvZmZzZXQiOjk1fQ==",
        "node": {
          "title": "Tech House Masterclass - Start To Finish with Fab Massimo",
          "handle": "tech-house-masterclass-start-to-finish-with-fab-massimo",
          "createdAt": "2023-07-17T11:19:20Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/fab-mas-final_1_700x.png?v=1689771196"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/FabMassimo_STF_snippet.mp3?v=1689605835"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Starting from nothing, see Fab Massimo produce an entire Tech House track, explaining each step fully along the way, from programming drums and layer synths, to mixing and doing the final master!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NDEzMDUxMDExMTM3LCJsYXN0X3ZhbHVlIjo0NDEzMDUxMDExMTM3LCJvZmZzZXQiOjI1Nn0=",
        "node": {
          "title": "Techno Masterclass",
          "handle": "techno-masterclass",
          "createdAt": "2020-03-13T11:20:43Z",
          "pmlProductCategory": {
            "value": "course--masterclasses"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/35-JohannesTechnoMasterclass_700x.png?v=1651583528"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/TechnoMasterclass.mp3?v=1623753957"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Your Berlin based tutor Johannes Menzel gives you an exclusive look into his production process, shares his tips, tricks and project files and guides you from your first kick to a mastered Techno track as if you were sitting side by side in the studio."
          }
        }
      }
    ],
    "startToFinish": [
      {
        "cursor": "eyJsYXN0X2lkIjo2NTM3NjY2MDY4NTQ1LCJsYXN0X3ZhbHVlIjo2NTM3NjY2MDY4NTQ1LCJvZmZzZXQiOjIyMX0=",
        "node": {
          "title": "Beginners Course: Ableton Live 11 - Making A Track From Start To Finish",
          "handle": "beginners-course-ableton-live-11-making-a-track-from-start-to-finish",
          "createdAt": "2021-03-05T12:02:22Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/start-to-finish_700x.png?v=1649419098"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/BeginnersCourseAbletonLive11Demo.mp3?v=1623422698"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Full Ableton Live Intro - How to Produce a Deep House Track Step by Step. Tutorial Series explaining Everything for Beginners. Includes Free Project File Download."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDE3Mjk1OTQ0MiwibGFzdF92YWx1ZSI6MTAxNzI5NTk0NDIsIm9mZnNldCI6MzU4fQ==",
        "node": {
          "title": "Classics: Course - Analog Melodic Techno Track from Start To Finish",
          "handle": "course-analog-melodic-techno-track-from-start-to-finish",
          "createdAt": "2017-07-28T14:09:30Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Using Ableton Live and Arturia MINI, we’re starting from nothing, creating drums, sounds, fx, chords, arrangements, until finishing with a ready-to-release master in this 4h+ full Online Course including samples, presets and Project Files."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/analogmelodictechno_a8ea49a6-a357-4207-91f5-a18c10e9b9b0_700x.png?v=1648670992"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_Analog_Rooms_-_Template.mp3?14887017311874516038"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing an \"Analog\" Melodic Techno Track Start To Finish using Ableton Live. Starting from nothing we are creating drums, sounds, fx, chords, arrangements, until finishing with a ready-to-release master. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjE2MDM2OTM3LCJsYXN0X3ZhbHVlIjo4MjE2MDM2OTM3LCJvZmZzZXQiOjQwMH0=",
        "node": {
          "title": "Classics: Course - Deep House Track from Start To Finish",
          "handle": "course-deep-house-track-from-start-to-finish",
          "createdAt": "2016-10-26T16:40:13Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Producing step by step with Ableton Live, all necessary files included, follow along the complete production process first hand. Starting from nothing we are creating drums, sounds, fx, chords, arrangements, until we have a finished, mixed & mastered track."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/15-deephouse_700x.png?v=1651058404"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_deepness.mp3?3921179628798817583"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "How to produce a Professional Deep House Track step by step with Ableton Live and NI MASSIVE - In this tutorial series we are showing you exactly what to do."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoyMTA4ODI0NDUzMTg1LCJsYXN0X3ZhbHVlIjoyMTA4ODI0NDUzMTg1LCJvZmZzZXQiOjI5MH0=",
        "node": {
          "title": "Classics: Course - High Tech Minimal Track from Start To Finish",
          "handle": "course-high-tech-minimal-track-from-start-to-finish",
          "createdAt": "2019-03-21T12:08:27Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Producing a High Tech Minimal Techno track (Intermediate Level). A complete start-to-finish production course from a blank project to a fully arranged master including all files. Watch all tutorials at your own pace, as many times as you want with lifetime access."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/36-HighTechMinimal_700x.png?v=1651582800"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_Darkside_FknSrs_01.mp3?3127669378200489135"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing A High Tech Minimal Techno Track from Start To Finish (Intermediate Level) A complete start-to-finish production course from a blank project to a fully arranged master. Watch all tutorials at your own pace, as many times as you want with lifetime access!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NTc4ODk1MzY0MTYxLCJsYXN0X3ZhbHVlIjo0NTc4ODk1MzY0MTYxLCJvZmZzZXQiOjI0OH0=",
        "node": {
          "title": "Classics: Course - Melodic Progressive House Start to Finish",
          "handle": "production-session-vol-1-start-to-finish-course-melodic-progressive-house",
          "createdAt": "2020-09-07T14:57:19Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/34-btdmelodicprogressive-new_700x.png?v=1651592969"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/ProductionSessionVol1StartToFinishMelodicProgressiveHouseDemo.mp3?v=1623672401"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Your tutor Julian from Bound to Divide teaches you to produce harmonically rich and melodically advanced Progressive House tracks."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDk0MDEwMjQ5LCJsYXN0X3ZhbHVlIjo4MDk0MDEwMjQ5LCJvZmZzZXQiOjQwM30=",
        "node": {
          "title": "Classics: Course - Melodic Techno Track from Start To Finish",
          "handle": "melodic-techno-track-start-to-finish-ableton",
          "createdAt": "2016-10-14T08:25:27Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Producing a Professional Melodic Techno track with Ableton Live (Intermediate Level), you're getting all files used and the complete start-to-finish production course to watch all tutorials at your own pace, as many times as you want and then use the techniques for your own productions"
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/2.2melodictechno-starttofinish_700x.png?v=1648670894"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_Giants.mp3?7690710370681891083"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing A Professional Melodic Techno Track with Ableton Live 9 Standard + NI MASSIVE (1.3.xx) (Intermediate Level) Watch Promo: What you're getting: Basic Course Pack - Contents: A complete start-to-finish production course, watch all tutorials at your own pace, as many times as you want and then use the techniques "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4Nzk2MTY2NzM4LCJsYXN0X3ZhbHVlIjo4Nzk2MTY2NzM4LCJvZmZzZXQiOjM4MX0=",
        "node": {
          "title": "Classics: Course - Pop Track from Start To Finish (Chainsmoking Style)",
          "handle": "course-pop-track-from-start-to-finish-chainsmoking-style",
          "createdAt": "2017-02-01T10:08:44Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Learn the complete Pop production process starting from a blank Ableton project file to a fully arranged and mastered track. Every step is explained in detail along the way. The fully produced Ableton project file comes included with the course."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/28-POPTrackalternative-v2_700x.png?v=1651605896"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_ChainClosers.mp3?14197613194075668983"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Learn the complete Pop production process starting from a blank Ableton project file to a fully arranged and mastered track. Every step is explained in detail along the way. Watch lessons as many times as you want with lifetime access. The fully produced Ableton project file comes included with the course!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDY2MDEwOTY4MDkwNywibGFzdF92YWx1ZSI6MTA2NjAxMDk2ODA5MDcsIm9mZnNldCI6NX0=",
        "node": {
          "title": "Course: Afro House from Start to Finish",
          "handle": "course-afro-house-from-start-to-finish",
          "createdAt": "2025-08-04T15:05:22Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/AfroHouseStartToFinish_700x.png?v=1754323007"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1754320675969-PML_-_Afro_House_-_Course_Track.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing a professional Afro House track with Ableton Live 11 + Serum 2, inspired by Jazzy, Kilimanjaro,  Keinemusik. A complete start-to-finish production course (Beginner to Intermediate Level), watch all tutorials at your own pace, as many times as you want, and apply the techniques to your own productions immediately."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzgxMDczODgzMjAxLCJsYXN0X3ZhbHVlIjo2NzgxMDczODgzMjAxLCJvZmZzZXQiOjE3MH0=",
        "node": {
          "title": "Course: Beginner to Advanced in Ableton Live - Music Production from Start To Finish",
          "handle": "course-music-production-in-ableton-live",
          "createdAt": "2022-04-08T14:31:32Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "9h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/xxbeginnertoadvancedabc_700x.png?v=1652098228"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Get an intensive deep dive into one of the best music production tools out there, Ableton Live! After this class you can finally focus on making music, because you know Ableton inside out."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NTI5MDAyMDM3NTE1LCJsYXN0X3ZhbHVlIjo4NTI5MDAyMDM3NTE1LCJvZmZzZXQiOjY2fQ==",
        "node": {
          "title": "Course: Beginner to Advanced in Ableton Live 12 - Start to Finish",
          "handle": "course-beginner-to-advanced-start-to-finish-in-ableton-live-12",
          "createdAt": "2024-03-27T02:07:37Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "6h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "A beginner-friendly intensive deep dive together with PML Tutors Matt and Guido. You will produce a track from start to finish and learn mixing and mastering techniques. After this class you can finally focus on making music, because we share all our knowledge - so you will be familiar with the techniques professional producers use."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/beginner_to_advanced_12_700x.png?v=1711505298"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_BTA12_-_Do_You_Remember_26330951-94ed-4580-91a8-edfc31767097.mp3?v=1711555647"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Get an intensive deep dive into one of the best music production tools out there, Ableton Live! After this class you can finally focus on making music, you'll know Ableton inside out."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjozOTU1NTM1ODM5Mjk3LCJsYXN0X3ZhbHVlIjozOTU1NTM1ODM5Mjk3LCJvZmZzZXQiOjI3MH0=",
        "node": {
          "title": "Course: Melodic House Track from Start To Finish (Ben Böhmer Style)",
          "handle": "course-melodic-house-track-from-start-to-finish",
          "createdAt": "2019-08-31T18:42:56Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "A complete start-to-finish production course in Ableton Live (Intermediate Level), starting from nothing we are creating drums, sounds, fx, chords, arrangements, until we have a finished, mixed & mastered track."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/vol_1_700x.png?v=1650977139"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/2019_PML_-_Anjuna_Vibes_pre.mp3?3058"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing A Professional Melodic House Track with Ableton Live 10 + Wavetable (included in Ableton Suite). A complete start-to-finish production course (Intermediate Level), watch all tutorials at your own pace, as many times as you want and then use the techniques on your own productions right away."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDUzNjEwMjE2Njc5NSwibGFzdF92YWx1ZSI6MTA1MzYxMDIxNjY3OTUsIm9mZnNldCI6MTF9",
        "node": {
          "title": "Course: Melodic House Track from Start to Finish",
          "handle": "course-melodic-house-track-from-start-to-finish-pml379",
          "createdAt": "2025-06-27T11:16:57Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "6h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Learn how to produce a full Melodic House track from scratch in this in-depth, start-to-finish course. Using Ableton Live 11.1+ and Serum 2. Watch at your own pace and immediately apply the techniques to your own productions."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/BoxV4_700x.png?v=1751023360"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1751294444188-PML_-_Melodic_House_-_Start_to_Finish_Track.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Learn how to produce a full Melodic House track from scratch in this in-depth, start-to-finish course. Using Ableton Live 11.1+ and Serum 2."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTYzMDk3MTgyMjczLCJsYXN0X3ZhbHVlIjo2NTYzMDk3MTgyMjczLCJvZmZzZXQiOjIxM30=",
        "node": {
          "title": "Course: Melodic House Vol. 2 - Track from Start To Finish",
          "handle": "course-melodic-house-track-from-start-to-finish-vol-2",
          "createdAt": "2021-06-02T10:11:08Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/vol_2_700x.png?v=1650977081"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/MelodicHouseVol2StartToFinish_Demo.mp3?v=1623421762"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Watch the Entire Production Process Starting from a blank project to a fully produced, mixed and mastered Melodic House track. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDEyMjE1NDA0OTgwMywibGFzdF92YWx1ZSI6MTAxMjIxNTQwNDk4MDMsIm9mZnNldCI6MjN9",
        "node": {
          "title": "Course: Melodic Techno Track from Start to Finish",
          "handle": "course-melodic-techno-track-from-start-to-finish",
          "createdAt": "2025-04-08T11:25:22Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "6h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Producing a professional Melodic Techno track with Ableton Live + Serum. A complete start-to-finish production course by Colorize artist Leo Lauretti (Intermediate Level to Advanced Level), everything will be explained in detail as we go through all important stages of the production."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MelodicTechno-StarttoFinishCourse_PML368_700x.png?v=1744111672"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_MT_STF_6.6_Full_Project.mp3?v=1744111332"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing a professional Melodic Techno track with Ableton Live 11 + Serum inspired by Artbat, Vintage Culture and more. A complete start-to-finish production course (Beginner to Intermediate Level), watch all tutorials at your own pace, as many times as you want and then use the techniques on your own productions right away."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDAzODg3MTM3MDM1LCJsYXN0X3ZhbHVlIjo4MDAzODg3MTM3MDM1LCJvZmZzZXQiOjE0Mn0=",
        "node": {
          "title": "Course: Melodic Techno Track from Start to Finish Vol. 2",
          "handle": "course-melodic-techno-track-from-start-to-finish-vol-2",
          "createdAt": "2022-09-22T08:28:50Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Producing a professional Melodic Techno track with Ableton Live + Serum. A complete start-to-finish production course by Anjunadeep artist Matt Lar (Beginner to Intermediate Level), everything will be explained in detail as we go through all important stages of the production."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PACK_LAR-STF_v8_700x.png?v=1664192831"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MelodicTechno-_PREVIEW_73348ac3-3e73-46bc-83f0-907e12f4e265.mp3?v=1664284875"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing a professional Melodic Techno track with Ableton Live 11 + Serum. \nA complete start-to-finish production course (Beginner to Intermediate Level), watch all tutorials at your own pace, as many times as you want and then use the techniques on your own productions right away."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTkxMDg5NjkyOTM5LCJsYXN0X3ZhbHVlIjo3OTkxMDg5NjkyOTM5LCJvZmZzZXQiOjE1MX0=",
        "node": {
          "title": "Course: Organic House Track from Start to Finish",
          "handle": "course-organic-house-track-from-start-to-finish",
          "createdAt": "2022-08-15T13:32:57Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Producing a professional Organic House Track with Ableton Live and DIVA together with touring artist and producer Yannek Maunz. Starting from nothing we are creating drums, sounds, fx, chords, arrangements, until we have a finished, mixed & mastered track."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/yannek_700x.png?v=1660575844"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Preview_Play_Button_Horizon_Organic_House_Yannek.mp3?v=1661863442"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing a professional Organic House Track with Ableton Live 11 + DIVA. \nA complete start-to-finish production course (Beginner to Intermediate Level), watch all tutorials at your own pace, as many times as you want and then use the techniques on your own productions right away.\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzU4NDMzODgyMzc5LCJsYXN0X3ZhbHVlIjo4MzU4NDMzODgyMzc5LCJvZmZzZXQiOjgzfQ==",
        "node": {
          "title": "Course: Organic House Track from Start to Finish Vol.2",
          "handle": "course-organic-house-track-from-start-to-finish-vol-2",
          "createdAt": "2023-11-03T14:21:00Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "2.5h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Together with tutor Yannek Maunz, you’re starting from scratch, creating drums, pads and melodic themes. Dive deep into strategic layering, kick processing, sound design, arrangement and mixing and mastering techniques."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-OrganicHouseVol.2-StarttoFinishCourse_700x.png?v=1699021317"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/organicHouse_STF_Vol2.mp3?v=1699273692"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing a professional Organic House Track with Ableton Live 11 + DIVA. \nA complete start-to-finish production course (Beginner to Intermediate Level), watch all tutorials at your own pace, as many times as you want and then use the techniques on your own productions right away.\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDAyOTgyOTY5NjExLCJsYXN0X3ZhbHVlIjo4MDAyOTgyOTY5NjExLCJvZmZzZXQiOjE0M30=",
        "node": {
          "title": "Course: Percussive House Track from Start to Finish",
          "handle": "course-percussive-house-track-from-start-to-finish",
          "createdAt": "2022-09-20T11:01:15Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "After having taken this class with tutor Yannek Maunz, you'll have seen a complete production process first hand. Starting from nothing we are creating drums, sounds, fx, chords and arrangement, until we have a finished, mixed & mastered track."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PACK_Melodic-House-Yannek_v8_700x.png?v=1663674869"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-PercussiveHouse_PREVIEW.mp3?v=1663679586"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing a professional Percussive House Track with Ableton Live 11 + DIVA. \nA complete start-to-finish production course (Beginner to Intermediate Level), watch all tutorials at your own pace, as many times as you want and then use the techniques on your own productions right away.\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDEzMzI1NDE0NDI2NywibGFzdF92YWx1ZSI6MTAxMzMyNTQxNDQyNjcsIm9mZnNldCI6MjF9",
        "node": {
          "title": "Course: Serum 2 and Sound Design",
          "handle": "course-serum-2",
          "createdAt": "2025-04-14T15:39:35Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "6h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/CourseSerum2MattTinkler_700x.png?v=1744645252"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Serum2CourseDemo.mp3?v=1744723761"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A complete deep dive into Serum 2. Discover all new features with Matt Tinkler. Full 6 hour course to unlock Serum 2’s full potential."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNTUyMTIzMTY2Nzg1LCJsYXN0X3ZhbHVlIjoxNTUyMTIzMTY2Nzg1LCJvZmZzZXQiOjMxNX0=",
        "node": {
          "title": "Course: Techno Track from Start To Finish with Ableton Live 10",
          "handle": "course-techno-track-from-start-to-finish",
          "createdAt": "2018-10-25T17:25:13Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Together with PML tutor Francois, you’re starting from nothing, creating drums, sounds, fx, chords, arrangements, until we have a finished, mixed & mastered track. All samples, presets and project files are included as with all start to finish courses."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/technotrack-test_c2ce8618-180d-4e88-ab10-098b2be5e1d2_700x.png?v=1650977104"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_PML_Amelie_Techno_Template.mp3?2629716106244060684"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing A Professional Techno Track with Ableton Live 10 + optional Serum (Intermediate Level). A complete start-to-finish techno, acid production course, watch all tutorials at your own pace, as many times as you want and then use the techniques on your own production, save time and get better results! "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDIxNzIyODIwNjM0NywibGFzdF92YWx1ZSI6MTAyMTcyMjgyMDYzNDcsIm9mZnNldCI6MTZ9",
        "node": {
          "title": "Course: Techno Track from Start to Finish",
          "handle": "course-techno-track-from-start-to-finish-pml374",
          "createdAt": "2025-06-02T13:44:34Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "6h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Producing a professional Melodic Techno track with Ableton Live + Serum. A complete start-to-finish production course by Colorize artist Leo Lauretti (Intermediate Level to Advanced Level), everything will be explained in detail as we go through all important stages of the production."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-TechnoStarttoFinishCourse_PML374_700x.png?v=1748877267"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Techno_-_Ascend__Live_11.1_and_Serum.mp3?v=1747667918"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Producing a professional Techno track with Ableton Live 11.1 + Serum.  \nInspired by Space 92, Enrico Sanguiliano, and more. A complete start-to-finish course."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzAwNDA4NTY5OTIxLCJsYXN0X3ZhbHVlIjo2NzAwNDA4NTY5OTIxLCJvZmZzZXQiOjE5MX0=",
        "node": {
          "title": "Masterclass: Lo-Fi House Track from Start to Finish (with Misc.Inc)",
          "handle": "lo-fi-house-masterclass-with-misc-inc",
          "createdAt": "2021-12-17T12:21:54Z",
          "pmlProductCategory": {
            "value": "course--startToFinish"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": {
            "value": "Chillout & Lo-Fi producer Misc.Inc starts with an empty Ableton project and shows you his whole process of creating your own retro samples for idea generation, writing chords & melodies and sample selection to designing sounds from scratch and arranging your ideas to a dynamic full length song."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/misc-inc_700x.png?v=1639743735"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/BenBohmerStyleMelodicDeepSoundPack.mp3?v=1623673056"
          },
          "musicPersists": {
            "value": "0"
          },
          "seo": {
            "description": "Your tutor Misc.Inc, known for his Ambient & Chill Out tunes throughout the best Spotify playlists, shows you how to create a Lo-Fi House track from scratch."
          }
        }
      }
    ],
    "songwriting": [
      {
        "cursor": "eyJsYXN0X2lkIjoxNTQwNDIyNjMxNDg5LCJsYXN0X3ZhbHVlIjoxNTQwNDIyNjMxNDg5LCJvZmZzZXQiOjMxOH0=",
        "node": {
          "title": "Classics: Arrangement Course",
          "handle": "arrangement-course",
          "createdAt": "2018-10-18T11:55:26Z",
          "pmlProductCategory": {
            "value": "course--songwriting"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "Learn how to escape an 8-bar loop and how to structure your songs so that you can turn your ideas into full songs by using concepts like tension & release, contrast, proportions, subtraction, verses, construction, bridges, build ups and drops."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/arrangement-2_700x.png?v=1649424778"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": null
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjE2MjU2NjQ5LCJsYXN0X3ZhbHVlIjo4MjE2MjU2NjQ5LCJvZmZzZXQiOjM5Nn0=",
        "node": {
          "title": "Classics: Course - Harmony and Chord Progressions",
          "handle": "course-harmony-and-chord-progressions",
          "createdAt": "2016-10-26T17:13:23Z",
          "pmlProductCategory": {
            "value": "course--songwriting"
          },
          "catalogDescription": {
            "value": "5h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "Write chords. Starting with basics of harmony & chord progressions, you'll learn how to write awesome chord progressions for your own music. Practical. This course is made for electronic music producers, offering many practical examples and writing sessions for different styles."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/harmony-2_700x.png?v=1649424828"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Harmony1pre.mp3?3056"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Learn how to come up with awesome chord progressions for your productions, starting with basics of harmony &amp; chord progressions &amp; music theory. - Step-by-step online course- Watch whenever YOU have the time- One time payment, lifetime access Watch Promo: What you will learn: Principles of western harmony Founda"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDQyMjY3NzI2NiwibGFzdF92YWx1ZSI6MTA0MjI2NzcyNjYsIm9mZnNldCI6MzU1fQ==",
        "node": {
          "title": "Classics: Course - How to Write Melodies",
          "handle": "course-how-to-write-melodies",
          "createdAt": "2017-08-20T11:29:38Z",
          "pmlProductCategory": {
            "value": "course--songwriting"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/melody-2_700x.png?v=1649424834"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Write Better Melodies, Make Better Music: This is a comprehensive step by step course teaching the techniques for writing catchy, memorable melodies."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoyMTE1NzgwOTY4NTEzLCJsYXN0X3ZhbHVlIjoyMTE1NzgwOTY4NTEzLCJvZmZzZXQiOjI4OH0=",
        "node": {
          "title": "Course: Groove and Rhythm",
          "handle": "groove-course",
          "createdAt": "2019-03-25T15:30:39Z",
          "pmlProductCategory": {
            "value": "course--songwriting"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/16_-_groove_and_rhythm_700x.png?v=1651069695"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "This course is entirely dedicated to building professional sounding drum loops for modern electronic music! "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjI1ODEzODIzNzU1LCJsYXN0X3ZhbHVlIjo4MjI1ODEzODIzNzU1LCJvZmZzZXQiOjExMH0=",
        "node": {
          "title": "Music Theory for Melodic Techno and House",
          "handle": "music-theory-for-melodic-techno-and-house",
          "createdAt": "2023-04-19T15:26:11Z",
          "pmlProductCategory": {
            "value": "course--songwriting"
          },
          "catalogDescription": {
            "value": "15h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "This is the ultimate practical guide to understanding the inner workings of melodic house and techno. Through a combination of theoretical concepts and practical application, you'll learn essential theory/harmony concepts and tricks to use in everyday production."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/music-theory-3-new_700x.png?v=1682007124"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Duo_120bpm_Gmin1.mp3?v=1682100755"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Take your productions to the next level with the most in-depth course on Music Theory for Melodic Techno and House on PML!"
          }
        }
      }
    ],
    "legacyCourses": [
      {
        "cursor": "eyJsYXN0X2lkIjo5MTU1MTk2ODgyLCJsYXN0X3ZhbHVlIjo5MTU1MTk2ODgyLCJvZmZzZXQiOjM2OX0=",
        "node": {
          "title": "Classics: Beginners Course - Making A Track from Start To Finish in Ableton Live",
          "handle": "course-track-from-start-to-finish-beginners-2017",
          "createdAt": "2017-04-02T14:02:13Z",
          "pmlProductCategory": {
            "value": "course--legacyCourses"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/26-beginnerslive9-120BPM_ffc7117b-0652-4ba0-aa8d-d6707b451999_700x.png?v=1651593845"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre-Beginners-Start-To-Finish.mp3?13451536669021869529"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Full Ableton Live Intro - How to Produce a Deep House Track Start To finish. Tutorial Series explaining Everything for Beginners. Includes Free Project File Download."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjE2MDY5ODMzLCJsYXN0X3ZhbHVlIjo4MjE2MDY5ODMzLCJvZmZzZXQiOjM5OX0=",
        "node": {
          "title": "Classics: Course - Future Bass Track from Start To Finish",
          "handle": "future-bass-track-from-start-to-finish",
          "createdAt": "2016-10-26T16:43:55Z",
          "pmlProductCategory": {
            "value": "course--legacyCourses"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/27-futurebass-new_700x.png?v=1651592802"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_FutureBassRiot.mp3?10588300226373159052"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Learn to produce a Future Bass track starting from a blank Ableton project file to a fully produced, mixed and mastered track. Every step of the production process is explained in detail. Watch lessons at your own pace as many times as you want!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjE2MTgyNDA5LCJsYXN0X3ZhbHVlIjo4MjE2MTgyNDA5LCJvZmZzZXQiOjM5N30=",
        "node": {
          "title": "Classics: Course - MASSIVE + Sound Design",
          "handle": "course-massive-sound-design",
          "createdAt": "2016-10-26T17:01:53Z",
          "pmlProductCategory": {
            "value": "course--legacyCourses"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/20-massivenew_700x.png?v=1651592898"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Learning synthesis and sound design with NI MASSIVE (1.3.xx) (Beginner & Intermediate Level). Learn Massive's interface, signal flow, Massive Wavetable oscillators, Modulation oscillators, Noise generators, the basics of synthesis and more! Massive presets are included with the course!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjE1OTEyMjY1LCJsYXN0X3ZhbHVlIjo4MjE1OTEyMjY1LCJvZmZzZXQiOjQwMX0=",
        "node": {
          "title": "Classics: Course - Producing A Modern Track from Start To Finish (Beginners 90 BPM)",
          "handle": "course-producing-a-track-from-start-to-finish-beginners",
          "createdAt": "2016-10-26T16:25:49Z",
          "pmlProductCategory": {
            "value": "course--legacyCourses"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/32-beginnerscourse-90bpm_700x.png?v=1651592917"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": null
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNTM4MTE5Nzk0NzUzLCJsYXN0X3ZhbHVlIjoxNTM4MTE5Nzk0NzUzLCJvZmZzZXQiOjMxOX0=",
        "node": {
          "title": "Classics: Masterclass - Mixing & Mastering A Future Bass Track From Start To Finish",
          "handle": "masterclass-mixing-mastering-a-future-bass-track-from-start-to-finish",
          "createdAt": "2018-10-16T13:33:21Z",
          "pmlProductCategory": {
            "value": "course--legacyCourses"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/37-Masterclassfuturebass_700x.png?v=1651585284"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Masterclass: Mixing & Mastering A Future Bass Track From Start To Finish. Learn from professional mixing and master engineer, Guido Werner. Download the before and after Ableton project files included with the course to analyze and deconstruct the mix. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTk2NjEyNDM0LCJsYXN0X3ZhbHVlIjo4OTk2NjEyNDM0LCJvZmZzZXQiOjM3NX0=",
        "node": {
          "title": "Course: Progressive House Track from Start To Finish",
          "handle": "progressive-house-track-from-start-to-finish",
          "createdAt": "2017-03-10T16:03:27Z",
          "pmlProductCategory": {
            "value": "course--legacyCourses"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/14-progressivehouse_700x.png?v=1651058424"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_EDM_Spinning_Template_V1.mp3?6075143621847580947"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Learn how to produce Progressive House starting from a blank Ableton project to a fully produced, mixed and mastered track. Each step of the production process is explained in detail all the way to a ready-to-release master. Watch lessons at your own pace as many times as you want with full, lifetime access!  "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NDkyNzgyMDQzMjAxLCJsYXN0X3ZhbHVlIjo0NDkyNzgyMDQzMjAxLCJvZmZzZXQiOjI1NH0=",
        "node": {
          "title": "Hard Trap from Start to Finish in Ableton",
          "handle": "hard-trap-from-start-to-finish-in-ableton",
          "createdAt": "2020-05-24T13:56:25Z",
          "pmlProductCategory": {
            "value": "course--legacyCourses"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/31-HardTrapv2_bfadcb2c-555a-4160-861a-5028202d7ca6_700x.png?v=1651586312"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": null
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0MzkwNjkxOTMwMTc3LCJsYXN0X3ZhbHVlIjo0MzkwNjkxOTMwMTc3LCJvZmZzZXQiOjI2MH0=",
        "node": {
          "title": "INSTAnt Inspiration Course",
          "handle": "instant-inspiration-course",
          "createdAt": "2020-02-01T12:15:50Z",
          "pmlProductCategory": {
            "value": "course--legacyCourses"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/inspiration-2_700x.png?v=1649424839"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": null
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NTc3NTczOTI5MDI1LCJsYXN0X3ZhbHVlIjo0NTc3NTczOTI5MDI1LCJvZmZzZXQiOjI0OX0=",
        "node": {
          "title": "Tech House from Start to Finish Course in Ableton Live",
          "handle": "tech-house-from-start-to-finish-course-in-ableton-live",
          "createdAt": "2020-09-04T13:19:32Z",
          "pmlProductCategory": {
            "value": "course--legacyCourses"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/24-techhouse-new_700x.png?v=1651593288"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": null
          }
        }
      }
    ],
    "soundDesign": [
      {
        "cursor": "eyJsYXN0X2lkIjo4ODkzMzc5MDI2LCJsYXN0X3ZhbHVlIjo4ODkzMzc5MDI2LCJvZmZzZXQiOjM4MH0=",
        "node": {
          "title": "Classics: Course - Sylenth1 + Sound Design",
          "handle": "course-sylenth1-sound-design",
          "createdAt": "2017-02-18T13:29:19Z",
          "pmlProductCategory": {
            "value": "course--soundDesign"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/21-sylenth1new_700x.png?v=1651592929"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Learn sound design with Sylenth1 (3.xx) (Beginner & Intermediate Level). Watch all tutorials at your own pace, as many times as you want and use the techniques for your music. 30+ Studio sessions with Francois / PML"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDY1NDkxMDEyMDIwMywibGFzdF92YWx1ZSI6MTA2NTQ5MTAxMjAyMDMsIm9mZnNldCI6N30=",
        "node": {
          "title": "Course: Advanced Sound Design with Serum 2",
          "handle": "course-advanced-sound-design-with-serum-2",
          "createdAt": "2025-07-30T14:05:32Z",
          "pmlProductCategory": {
            "value": "course--soundDesign"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course with Serum 2 Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Advanced_Sound_Design_-_Serum_2_Course_by_Jack_Willard_PML383_700x.png?v=1753887809"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1754398000387-PML383_DJ_Mix2.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A complete deep dive into Serum 2. Learn advanced sound design techniques and master all the new features in this 2-hour course with sound designer Jack Willard. Unlock the full creative power of Serum 2 for your own productions."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5OTk2OTQwMTE0LCJsYXN0X3ZhbHVlIjo5OTk2OTQwMTE0LCJvZmZzZXQiOjM1OX0=",
        "node": {
          "title": "Course: How To and 'Analog' Sound Design with Arturia MINI V3",
          "handle": "course-arturia-mini-v3-how-to-sound-design",
          "createdAt": "2017-07-16T16:23:09Z",
          "pmlProductCategory": {
            "value": "course--soundDesign"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/18-arturianew_700x.png?v=1651592884"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Learn how to achieve great \"analog\" style sound design with Arturia MINI V3 Learn how to make sounds that fit perfectly into your own tracks The sound design videos are focussed on Deep / Melodic / Techno. Learn Synthesis & 'Analog' Sound Design with Arturia MINI."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzY3Mjk4NjQyMTg3LCJsYXN0X3ZhbHVlIjo4MzY3Mjk4NjQyMTg3LCJvZmZzZXQiOjgxfQ==",
        "node": {
          "title": "Course: Serum Sound Design - Modern Melodic Techno",
          "handle": "course-serum-sound-design-modern-melodic-techno",
          "createdAt": "2023-11-14T07:56:24Z",
          "pmlProductCategory": {
            "value": "course--soundDesign"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Presets"
          },
          "enhancedDescription": {
            "value": "Sound Design expert Andrea Viscardi shares how to make sounds with Serum that fit perfectly into your own melodic techno tracks, develop original presets and sound unique. Follow along the full sound design process in this 4h+ Full Online Course with Presets. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-SerumCourse-MelodicTechnobyAndreaViscardi_PML310_700x.png?v=1699949443"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/CoursePML_Serum_Sound_Design_Example_4_Modern_ArpLead.mp3?v=1699968645"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "You will learn how to make sounds with Serum that fit perfectly into your own melodic techno tracks, develop original presets and sound unique. Follow along the full sound design process. Everything will be explained in detail while going through all important stages of creating sounds. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDQ1NzYwMDIwNzQ3LCJsYXN0X3ZhbHVlIjo4MDQ1NzYwMDIwNzQ3LCJvZmZzZXQiOjEyOX0=",
        "node": {
          "title": "Course: Sound Design Beginner to Advanced (with Pigments)",
          "handle": "course-learn-sound-design-with-arturia-pigments",
          "createdAt": "2022-12-12T09:13:29Z",
          "pmlProductCategory": {
            "value": "course--soundDesign"
          },
          "catalogDescription": {
            "value": "7h+ Full Online Course with Presets"
          },
          "enhancedDescription": {
            "value": "Learning synthesis and sound design with Arturia Pigments (Beginner to Advanced Level). You will build a solid foundational understanding of sound design and synthesis so you feel confident knowing what tools to reach for to find the sound you imagine."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/pigmentscoursesounddesign_700x.png?v=1691142194"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pigments_CoursePreview.mp3?v=1670933261"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Learning synthesis and sound design with Arturia Pigments (Beginner to Advanced Level). You will learn the foundations of synthesis using Pigment's 4 unique sound engines, Pigment's interface, signal flow, effects + Much More. See below!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDk4MDY0MjEwLCJsYXN0X3ZhbHVlIjo4NDk4MDY0MjEwLCJvZmZzZXQiOjM4Nn0=",
        "node": {
          "title": "Course: Xfer SERUM + Sound Design",
          "handle": "course-serum-sound-design",
          "createdAt": "2016-11-21T20:50:35Z",
          "pmlProductCategory": {
            "value": "course--soundDesign"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/19-serumnew_700x.png?v=1651592957"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Starting with the basics, you will learn how to make sounds that fit perfectly into your own tracks, develop your own presets and sound unique. Follow along the full sound design process. Everything will be explained in detail while going through all important stages of creating sounds. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjAyMTE2NjAzOTY5LCJsYXN0X3ZhbHVlIjo0NjAyMTE2NjAzOTY5LCJvZmZzZXQiOjI0M30=",
        "node": {
          "title": "Course: u-he Diva + Sound Design",
          "handle": "course-u-he-diva-sound-design",
          "createdAt": "2020-10-19T16:55:31Z",
          "pmlProductCategory": {
            "value": "course--soundDesign"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Presets"
          },
          "enhancedDescription": {
            "value": "Learning synthesis and sound design with U-he Diva (Beginner & Intermediate Level). You will learn the basics of synthesis with DIVA Wavetable oscillators, Diva's interface, signal flow, modulation oscillators, noise generators filtering / filter types Effects and practical sessions."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/17-divacoursenew_700x.png?v=1651592942"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Learning synthesis and sound design with Uhe Diva (Beginner & Intermediate Level). You will learn the basics of synthesis with DIVA Wavetable oscillators, Diva's interface, signal flow,  modulation oscillators, noise generators filtering / filter types Effects + Much More. See below!"
          }
        }
      }
    ],
    "mixingAndMastering": [
      {
        "cursor": "eyJsYXN0X2lkIjoxOTI4NTAxMzYyNzUzLCJsYXN0X3ZhbHVlIjoxOTI4NTAxMzYyNzUzLCJvZmZzZXQiOjI5OX0=",
        "node": {
          "title": "Classics: How to Mix a Track with the Best Plugins available",
          "handle": "how-to-mix-a-track-with-the-best-plugins-available",
          "createdAt": "2018-12-22T22:52:58Z",
          "pmlProductCategory": {
            "value": "course--mixingAndMastering"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Sound Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/33-mixingwithplugins_700x.png?v=1651579149"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Learn From A Professional Engineer Starting from a blank project to a fully produced, mixed and mastered track. Mixing Engineer Guido Werner takes our track \"Desert\" and performs professional mixing and mastering on it using the best plugins for the job. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDM2MzE2NjIyNiwibGFzdF92YWx1ZSI6MTAzNjMxNjYyMjYsIm9mZnNldCI6MzU2fQ==",
        "node": {
          "title": "Classics: Masterclass - Mixing & Mastering A Melodic Techno Track",
          "handle": "course-mixing-masterclass",
          "createdAt": "2017-08-14T16:11:18Z",
          "pmlProductCategory": {
            "value": "course--mixingAndMastering"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course with Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/38-MasterclassmelodicTechno_d9bd1079-c266-45f7-8283-6a20e14129ae_700x.png?v=1651585355"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "See step by step instructions how to mix and master melodic techno from professional mixing engineer, Guido Werner."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjQzOTczNjg1NTE1LCJsYXN0X3ZhbHVlIjo4MjQzOTczNjg1NTE1LCJvZmZzZXQiOjEwNH0=",
        "node": {
          "title": "Course - Mastering from Start To Finish",
          "handle": "course-mastering-from-start-to-finish",
          "createdAt": "2023-05-12T14:17:33Z",
          "pmlProductCategory": {
            "value": "course--mixingAndMastering"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Sound Files"
          },
          "enhancedDescription": {
            "value": "Learn essential and practical techniques for professional level productions. Covering loudness, EQ, and dynamic range control, and tricks from a professional mastering engineer. You'll learn how to use specialized mastering plugins, optimize your tracks for different listening environments, and create final masters that are ready for distribution."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MasteringCourse_700x.png?v=1683901139"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Learn how to master Start to Finish using Ableton Live 11. In this course we will show the FULL process for mastering multiple tracks in Melodic Techno and Melodic House."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjQzOTM1Mzc5NzIzLCJsYXN0X3ZhbHVlIjo4MjQzOTM1Mzc5NzIzLCJvZmZzZXQiOjEwNX0=",
        "node": {
          "title": "Course - Mixing from Start To Finish",
          "handle": "course-mixing-from-start-to-finish",
          "createdAt": "2023-05-12T13:30:59Z",
          "pmlProductCategory": {
            "value": "course--mixingAndMastering"
          },
          "catalogDescription": {
            "value": "8h+ Full Online Course with Sound Files"
          },
          "enhancedDescription": {
            "value": "In this course we will show the FULL process for mixing multiple tracks in Melodic Techno and Melodic House. Covering EQ, compression, and reverb, as well as more advanced techniques and tricks from professional mixing engineers. By the end of the course, you'll have the skills and knowledge to confidently mix your own tracks and bring your unique sound to life."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MixingCourse_700x.png?v=1683898311"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Learn how to mix Start to Finish using Ableton Live 11. In this course we will show the FULL process for mixing multiple tracks in Melodic Techno and Melodic House."
          }
        }
      }
    ],
    "musicBusiness": [
      {
        "cursor": "eyJsYXN0X2lkIjo2NTkyMTY1NDQ1Njk3LCJsYXN0X3ZhbHVlIjo2NTkyMTY1NDQ1Njk3LCJvZmZzZXQiOjIwMn0=",
        "node": {
          "title": "Course: How I Built My Home Studio",
          "handle": "course-how-i-built-my-home-studio",
          "createdAt": "2021-08-24T14:58:40Z",
          "pmlProductCategory": {
            "value": "course--musicBusiness"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "In this course Attila (PML Tutor) will show you the full process of building this Home Studio from the ground up, while going through a ton of important knowledge about building and operating a home studio."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/HowIBuiltMyHomeStudio_700x.png?v=1632827207"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "In this course Attila (PML Tutor) will show you the full process of building this Home Studio from the ground up, while going through a ton of important knowledge about building and operating a Home Studio. Everything is explained in deep detail."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTc4OTE1NjcyMTI5LCJsYXN0X3ZhbHVlIjo2NTc4OTE1NjcyMTI5LCJvZmZzZXQiOjIwNX0=",
        "node": {
          "title": "Course: How To Make A Sample Pack",
          "handle": "how-to-make-a-sample-pack",
          "createdAt": "2021-07-27T15:15:51Z",
          "pmlProductCategory": {
            "value": "course--musicBusiness"
          },
          "catalogDescription": {
            "value": "2h+ Full Online Course"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/sample-pack-simple-7_700x.png?v=1628171271"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/ProductionSessionVol1StartToFinishMelodicProgressiveHouseDemo.mp3?v=1623672401"
          },
          "musicPersists": {
            "value": "0"
          },
          "seo": {
            "description": "This course is for creators interested in making samples and sounds that producers want to buy. Producer Bound to Divide shares his knowledge with you. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDcyMDI2NjIwMTcxLCJsYXN0X3ZhbHVlIjo4MDcyMDI2NjIwMTcxLCJvZmZzZXQiOjEyNX0=",
        "node": {
          "title": "Music Streaming Masterclass",
          "handle": "music-streaming-masterclass",
          "createdAt": "2023-01-04T11:23:42Z",
          "pmlProductCategory": {
            "value": "course--musicBusiness"
          },
          "catalogDescription": {
            "value": "3h+ Full Online Course"
          },
          "enhancedDescription": {
            "value": "Wes will take you through the entire process of releasing, promoting and monetizing your music on Spotify. Compressing years of music business, curator, label owner and artist experience into a clear and actionable course for pro level artists & labels, as well as complete beginners."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/wes-new2_700x.png?v=1673971643"
          },
          "music": null,
          "musicPersists": {
            "value": "0"
          },
          "seo": {
            "description": "Make Money with your Music on Spotify! \nIn this Music Business Masterclass Wes shows you how - with over 100 million streams to his work.\nLearn from a leading expert, get heard by more people and monetise your music.\n\n“Wes will bring you to the next level - no doubt!” Bound to Divide"
          }
        }
      }
    ]
  },
  "samplePacks": {
    "samplePacks": [
      {
        "cursor": "eyJsYXN0X2lkIjo2NjcwNTg1OTU0MzY5LCJsYXN0X3ZhbHVlIjo2NjcwNTg1OTU0MzY5LCJvZmZzZXQiOjE5M30=",
        "node": {
          "title": "Acoustic Melodic House Themes",
          "handle": "acoustic-melodic-house-themes",
          "createdAt": "2021-11-24T10:25:30Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "550+ Pro Main Theme Samples"
          },
          "enhancedDescription": {
            "value": "For one of the most inspiring sound packs, Orchestral Tools and PML teamed up with 5 of their favourite contemporary producers, gave them full access to all available OT sample libraries and let them create 550+ tonal & atonal percussion loops, atmospheres, melodic / harmonic themes, sounds you instantly want to work with. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/final_1_700x.png?v=1637766493"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Yannek_Maunz_-_OT_Demo_01.mp3?v=1637850807"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "In his first pack ever he was able to capture that fluffy, groovy feeling in over 210 loops. You will instantly want to start a track. All loops are set to 122BPM and all melodic / harmonic loops are in A Minor: everything matches with everything for endless creativity!\n\nThe included “Big Drum Rack” is Cioz finest selection of samples all built into one single tool - with everything perfectly compressed, EQed & side chained plus creative FX for playing live and fast production. You get Cioz's complete workflow!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDI0NTA1MjU0MTU1LCJsYXN0X3ZhbHVlIjo4MDI0NTA1MjU0MTU1LCJvZmZzZXQiOjEzMH0=",
        "node": {
          "title": "Acoustic Melodic House Themes - Vol.2",
          "handle": "acoustic-melodic-house-themes-2",
          "createdAt": "2022-11-18T16:14:31Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "580+ Pro Main Theme Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PMLxOrchestralTools-AcousticMelodicHouse2_700x.png?v=1668788111"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Demo_AcousticVol2.mp3?v=1669126416"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The best orchestral samples meet contemporary Melodic House & Techno producers - the result is a collection of melody, tonal percussion and song starter loops, that will spark infinite ideas! 580+ Royalty-Free Main theme loops!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjM2MjQyMzA1MjkxLCJsYXN0X3ZhbHVlIjo4MjM2MjQyMzA1MjkxLCJvZmZzZXQiOjEwOH0=",
        "node": {
          "title": "Acoustic Melodic House Themes - Vol.3",
          "handle": "acoustic-melodic-house-themes-vol-3",
          "createdAt": "2023-05-03T13:43:38Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "510+ Pro Main Theme Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-AcousticVol.3_700x.png?v=1683121499"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/AcousticMelodicHouseVol3_PLaysnippet.mp3?v=1683211207"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This is probably the most versatile edition yet - Acoustic Melodic House Themes Vol. 3! The best orchestral samples meet contemporary Melodic House & Techno producers - the result is a collection of melody, tonal percussion and song starter loops, that will spark infinite ideas!\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4Mzc1Mzc5MDY3MTQ3LCJsYXN0X3ZhbHVlIjo4Mzc1Mzc5MDY3MTQ3LCJvZmZzZXQiOjc5fQ==",
        "node": {
          "title": "Acoustic Melodic House Themes - Vol.4",
          "handle": "acoustic-melodic-house-themes-vol-4",
          "createdAt": "2023-11-21T11:21:31Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "530+ Pro Main Theme Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-AcousticMelodicHouseThemesVol.4_PML311_700x.png?v=1700565713"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/ot4_playbutton.mp3?v=1700663857"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Acoustic Melodic House Themes Vol. 4 is the ultimate fusion of the finest orchestral samples with today's Melodic House & Techno producers. Discover a collection of melodies, tonal percussion, and song starter loops, igniting boundless creative inspiration"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4ODgyOTY2NDYyNzMxLCJsYXN0X3ZhbHVlIjo4ODgyOTY2NDYyNzMxLCJvZmZzZXQiOjQ2fQ==",
        "node": {
          "title": "Acoustic Melodic House Themes - Vol.5",
          "handle": "acoustic-melodic-house-themes-vol-5",
          "createdAt": "2024-10-31T15:56:25Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "560+ Pro Main Theme Samples"
          },
          "enhancedDescription": {
            "value": "Created in collaboration with Orchestral tools, Vol. 5 brings you 500+ of the finest orchestral samples, main themes, enchanting tonal and atonal percussion loops, breathtaking melodies and harmonies focussed more on atmospheric textures and created by today's Melodic House & Techno producers."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/AcousticMelodicHouseVol5ProductBox_700x.png?v=1730715520"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/AcousticMelodicHouseThemeVol5_Preview.mp3?v=1730823204"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Acoustic Melodic House Themes Vol. 5 is a top-tier collection of the finest orchestral samples created by today's Melodic House & Techno producers. Discover a library of tonal percussion, textures, and song starters, designed to spark limitless creative possibilities."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDY2Njc5MzIzODc5NSwibGFzdF92YWx1ZSI6MTA2NjY3OTMyMzg3OTUsIm9mZnNldCI6NH0=",
        "node": {
          "title": "Afro House - Sample Pack - Sounds From The Cape",
          "handle": "afro-house-sample-pack-sounds-from-the-cape",
          "createdAt": "2025-08-11T10:49:39Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "160+ One Shot Samples, 160+ Loop Samples, 2 Bonus Ableton Project Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/AfroHouseSoundsCape_700x.png?v=1754923830"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1754909703407.3276-AfroHouse_SoundsFromCape_DJ_Mix.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Explore the roots and rhythms of South African house with over 320 handcrafted samples, real percussion recordings, vocal phrases, and 3 song starter kits from Cape Town’s own Pierre Johnson. This pack is your gateway to warm, organic, and groove-driven Afro House."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxOTMzNjcxNjYxNjMzLCJsYXN0X3ZhbHVlIjoxOTMzNjcxNjYxNjMzLCJvZmZzZXQiOjI5OH0=",
        "node": {
          "title": "Analog Techno Synth Shots - Sample Pack",
          "handle": "analog-techno-synth-shots-sample-pack",
          "createdAt": "2018-12-27T13:01:41Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "550+ Pro Analog Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/11synthshots_700x.png?v=1652704818"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/pre_sample_pack_joao.mp3?17386132699230783354"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Download Professional Sample Pack with 550+ one shot samples, perfect bass sounds, leads, percussions, fx, atmos, synth drums."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NDk0ODcwNjA5OTg1LCJsYXN0X3ZhbHVlIjo0NDk0ODcwNjA5OTg1LCJvZmZzZXQiOjI1M30=",
        "node": {
          "title": "Dark Techno Sample Pack",
          "handle": "dark-techno-sample-pack",
          "createdAt": "2020-05-26T11:24:09Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "380+ Pro Drum Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/10darktechno_700x.png?v=1652704850"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "The Dark Techno Pack contains professional sounding one shots, creative and ready to use loops and signature sounds to make you stand out of the rest and you will not find in any other pack. Get the perfect starting point for the sound of artists like: Umek, Amelie Lens, Charlotte de Witte, Adam Beyer, Anna or Deborah de Luca."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjozOTQ3Njg3NDExNzc3LCJsYXN0X3ZhbHVlIjozOTQ3Njg3NDExNzc3LCJvZmZzZXQiOjI3NH0=",
        "node": {
          "title": "Dark Textures and Soundscapes - Sample Pack",
          "handle": "dark-textures-and-soundscapes-for-techno-deep-underground-sample-pack-for-ambience-by-pml",
          "createdAt": "2019-08-14T18:29:58Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "100+ Pro Atmos Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/dark-textures_700x.png?v=1649693488"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_DTS_Demo_Track_preview-coll01.mp3?3031"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Dark Textures and soundscapes is a collection of 110 dusty and evolving textures and soundscapes samples / loops. Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTY5MzU0NTU5NTUzLCJsYXN0X3ZhbHVlIjo2NTY5MzU0NTU5NTUzLCJvZmZzZXQiOjIwOX0=",
        "node": {
          "title": "Deep & Tech House  Songstarters",
          "handle": "deep-house-production-suite",
          "createdAt": "2021-06-25T10:50:28Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "610+ Loops & Beat Constructions Stems"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/deep-house11-UPDATED_1_700x.png?v=1625484994"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Demo_Track_Song_Starter.mp3?v=1636736261"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This extensive loop collection from Stereo Voltage is the new go to folder for a vast variety of sounds for anything Deep House. With over 610 loops and beat construction stems you will find excellent sounding starting points, fillers or “that’s exactly what was missing” gems."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoyMTE0MTkyMTMzLCJsYXN0X3ZhbHVlIjoyMTE0MTkyMTMzLCJvZmZzZXQiOjQ4N30=",
        "node": {
          "title": "Deep Premium Vol.1 - Drum Sample Pack",
          "handle": "deep-premium-vol-1-drum-sample-pack-ableton-project-midis",
          "createdAt": "2015-09-15T10:39:14Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "750+ Pro Drum Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/dp1_700x.png?v=1742399761"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PreviewDeepPremiumVol.1.mp3?3043"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Download Professional Drum Sample Pack with 800+ one shot samples, perfect kicks, hihats, snares, percussions, fx, Drum racks, Midis."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDU2MDUyODA5LCJsYXN0X3ZhbHVlIjo4NDU2MDUyODA5LCJvZmZzZXQiOjM4OH0=",
        "node": {
          "title": "Deep Premium Vol.2 - Drum Sample Pack",
          "handle": "deep-premium-vol-2-drum-sample-pack",
          "createdAt": "2016-11-15T20:56:17Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "800+ Pro Drum Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/dp2_700x.png?v=1742399823"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/deep_premium_preview_final.mp3?10853557241381900060"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Drum Sample Pack for electronic music with 850+ one shot samples, Kicks, Hihats, Snares, Drum Loops, 808s, percussion and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoyMTA5MTAyOTgxMTg1LCJsYXN0X3ZhbHVlIjoyMTA5MTAyOTgxMTg1LCJvZmZzZXQiOjI4OX0=",
        "node": {
          "title": "Deep Premium Vol.3 - Drum Sample Pack",
          "handle": "deep-premium-vol-3-drum-sample-pack",
          "createdAt": "2019-03-21T15:29:24Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "650+ Pro Drum Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/dp3.1_700x.png?v=1742399874"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Deep_Premium_Vol_3_Demo.mp3?3044"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Drum Sample Pack for electronic music with 850+ one shot samples, Kicks, Hihats, Snares, Drum Loops, 808, percussion, loops and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NDEwNjUzNzA0MjU3LCJsYXN0X3ZhbHVlIjo0NDEwNjUzNzA0MjU3LCJvZmZzZXQiOjI1N30=",
        "node": {
          "title": "Deep Premium Vol.4 - Drum Sample Pack",
          "handle": "deep-premium-vol-4",
          "createdAt": "2020-03-09T11:41:44Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "410+ Pro Drum Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/dpv4_box_noir_700x.png?v=1742471145"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DeepPremium4Demo.mp3?v=1623765504"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Deep Premium is our flagship drum sample series! 410+ Professional Drum Samples and Loops used by professional producers and DJs around the world. Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjYwNzUzMzM0MzM3LCJsYXN0X3ZhbHVlIjo0NjYwNzUzMzM0MzM3LCJvZmZzZXQiOjIyNH0=",
        "node": {
          "title": "Deep Premium Vol.5 - Drum Sample Pack",
          "handle": "deep-premium-vol-5-drum-sample-pack",
          "createdAt": "2021-02-18T14:22:36Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "650+ Pro Drum Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/dp5_700x.png?v=1742400028"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DeepPremium5Demo.mp3?v=1623413454"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Our flagship drum sample series! A massive collection of 650+ Professional Drum Samples and Loops made for Melodic Techno, Techno, House and More. All Samples are 100% Royalty free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzkwNzc4NTg1MTUzLCJsYXN0X3ZhbHVlIjo2NzkwNzc4NTg1MTUzLCJvZmZzZXQiOjE2N30=",
        "node": {
          "title": "Deep Premium Vol.6 - Drum Sample Pack",
          "handle": "deep-premium-vol-6-drum-sample-pack",
          "createdAt": "2022-04-20T10:14:25Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "1000+ Pro Drum Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/dp6_700x.png?v=1742400106"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DPV6-collection-Demo.mp3?v=1650562484"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The most complete sample & loop collection for Deep, Melodic & Organic House and Techno tunes! 500+ loops and 500+ one shots - professionally recorded, processed, mixed & mastered. Royalty free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MTkyMTk4NjM5ODgzLCJsYXN0X3ZhbHVlIjo4MTkyMTk4NjM5ODgzLCJvZmZzZXQiOjExMn0=",
        "node": {
          "title": "Deep Premium Vol.7 - Drum Sample Pack",
          "handle": "deep-premium-vol-7-drum-sample-pack",
          "createdAt": "2023-03-24T15:41:18Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "1600+ Pro Drum Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/dp7.1_700x.png?v=1742400146"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DP7_preview.mp3?v=1680099937"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Deep Premium 7 is the biggest in the series so far! Get professional samples & loops for Deep, Melodic & Organic House and Techno tunes! 960+ loops and 660+ one shots - professionally recorded, processed, mixed & mastered. Royalty free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NTI4NjAzMDg3MTE1LCJsYXN0X3ZhbHVlIjo4NTI4NjAzMDg3MTE1LCJvZmZzZXQiOjY4fQ==",
        "node": {
          "title": "Deep Premium Vol.8 - Drum Sample Pack",
          "handle": "deep-premium-vol-8-drum-sample-pack",
          "createdAt": "2024-03-26T18:36:49Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "1300+ Pro Drum Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/dp8.1_700x.png?v=1742400177"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DP8_Playbutton_Snippet.mp3?v=1711498537"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Deep Premium 8 offers professional samples & loops for Deep, Melodic & Organic House and Techno tunes! 580+ loops and 750+ one shots - professionally recorded, processed, mixed & mastered. Royalty free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDEwNDQ0NTE3NDAyNywibGFzdF92YWx1ZSI6MTAxMDQ0NDUxNzQwMjcsIm9mZnNldCI6MjV9",
        "node": {
          "title": "Deep Premium Vol.9 - Drum Sample Pack",
          "handle": "deep-premium-vol-9-drum-sample-pack",
          "createdAt": "2025-03-31T10:59:56Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "1300+ Pro Drum Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/FinalBox_700x.png?v=1743419155"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Tracks_Made_With_Deep_Premium_Samples.mp3?v=1743418820"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The ultimate sample & loop collection for Afro, Deep, Melodic & Organic House and\nTechno! 780+ loops and 590+ one shots – professionally recorded, processed, and ready to use. 100% royalty-free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NTU1NjY2NTcxNTMxLCJsYXN0X3ZhbHVlIjo4NTU1NjY2NTcxNTMxLCJvZmZzZXQiOjY1fQ==",
        "node": {
          "title": "Kicks - Sample Pack Vol.1",
          "handle": "kick-sample-pack-vol-1",
          "createdAt": "2024-04-18T19:37:31Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "100+ Kick Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/kicksamplepackvol1_700x.png?v=1713469231"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/KicksVol1_Preview_V2.mp3?v=1741789817"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Collection of Kicks That Always Work Sometimes all your track needs is a different kick. Get 100+ Kicks genre and key labeled to anchor your next track!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5Nzg3NzM2ODUwNjk5LCJsYXN0X3ZhbHVlIjo5Nzg3NzM2ODUwNjk5LCJvZmZzZXQiOjI3fQ==",
        "node": {
          "title": "Kicks - Sample Pack Vol.2",
          "handle": "kicks-sample-pack-vol-2",
          "createdAt": "2025-03-11T11:14:00Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "122+ Kick Samples, 122+ Low End Loops, 215 Low End MIDI "
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/KicksVol2_V4_700x.png?v=1741708655"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/KicksVol2_DJMIX_V2ormore.mp3?v=1741781473"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Start with kicks that work. Get 120+ powerful, mix-ready kicks, all key and genre-labeled, plus a bonus Low End Construction Kit to lock in your bass and kick instantly."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDAxMjI1MjI4NTU1LCJsYXN0X3ZhbHVlIjo4MDAxMjI1MjI4NTU1LCJvZmZzZXQiOjE0NH0=",
        "node": {
          "title": "Main Stage Techno - Sample Pack",
          "handle": "main-stage-techno-sample-pack",
          "createdAt": "2022-09-13T08:54:04Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "310+ Pro Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-MainStageTechnoSamplePack_700x.png?v=1663059273"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Main_Stage_Techno_PREVIEW.mp3?v=1663060631"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This pack is stuffed with ready to use kick one shots and loops that will instantly build the foundation of your production.\n310+ Loops professionally crafted to bring your Techno Productions to the next level."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNDExNjM2MDY4NDE3LCJsYXN0X3ZhbHVlIjoxNDExNjM2MDY4NDE3LCJvZmZzZXQiOjMyOX0=",
        "node": {
          "title": "Melodic Techno Vol.1 - Drum Sample Pack",
          "handle": "melodic-techno-vol-1-drum-sample-pack",
          "createdAt": "2018-07-30T13:26:12Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "300+ Pro Drum Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/6melodictechnovol1_700x.png?v=1652362934"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_MTD1_preview.mp3?8619943082156659447"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Download Professional Drum Sample Pack with 300+ one shot samples, perfect kicks, hihats, snares, percussions, fx, and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTQ2OTUyNDg2OTc3LCJsYXN0X3ZhbHVlIjo2NTQ2OTUyNDg2OTc3LCJvZmZzZXQiOjIxN30=",
        "node": {
          "title": "Organica - Full Production Suite",
          "handle": "organica-full-ableton-production-suite",
          "createdAt": "2021-04-09T11:02:33Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "4 Project Files, 480+ Organic Samples, 30 Diva Presets"
          },
          "enhancedDescription": {
            "value": "This extensive collection from Yannek Maunz & Brascon provides 350+ all natural samples, percussions, loops and 30+ carefully crafted Diva presets will make your tracks feel more alive and full - and more organic! Additional 4 fully produced Ableton Project Files help you start the studio session. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/Organicabox2_700x.png?v=1617966201"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Yannek_Maunz_-_Oblique_PML_Template_Preview.mp3?v=1620722179"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Organica: 4 Fully Produced Ableton Templates produced by Yannek Maunz and Brascon. 540+ royalty free samples and loops. 30 professionally crafted Diva presets. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDAzODg3MzY2NDExLCJsYXN0X3ZhbHVlIjo4MDAzODg3MzY2NDExLCJvZmZzZXQiOjE0MX0=",
        "node": {
          "title": "Organica Vol. 2 - Full Production Suite",
          "handle": "organica-vol-2-full-production-suite",
          "createdAt": "2022-09-22T08:31:31Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "2 Project Files, 480+ Organic Samples, 60 Diva Presets"
          },
          "enhancedDescription": {
            "value": "Breathe life into your productions with 480+ professionally recorded and great sounding natural samples, percussions and loops. 60+ precisely crafted Diva presets deliver depth, richness and an unmistakable organic character to your mix, rounded up by 2 fully produced, mixed & mastered Ableton Project Files - the perfect song starter kit!"
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PACK_Organica2_v9_700x.png?v=1664875280"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Organica_2.0_ShowOff_Final_copy.mp3?v=1664971566"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Organica Vol 2: 490+ royalty free samples and loops. 60 professionally crafted Diva presets. Template Edition includes fully produced, mixed and mastered Ableton project file by Yannek Maunz."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MTg4Mjk5NTEwMDI3LCJsYXN0X3ZhbHVlIjo4MTg4Mjk5NTEwMDI3LCJvZmZzZXQiOjExNH0=",
        "node": {
          "title": "Organica Vol. 3 - Full Production Suite",
          "handle": "organica-vol-3-full-production-suite",
          "createdAt": "2023-03-21T12:21:35Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "2 Project Files, 840+ Organic Samples, 50 Diva Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-Organica3-gamm_700x.png?v=1679407765"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Organica3_playsnippet_v2.mp3?v=1679410832"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "New Edition 3! Kick off your next Organic House production! Make your tracks sound more alive and natural with over 840+ Samples including 200+ One Shots and Organic Sounds and 640+ handcrafted loops. You also get 50 professionally made Diva Presets. Organica Template Edition includes two fully produced Ableton Project Files by Yannek Maunz."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzU0ODM5NTkzMjI3LCJsYXN0X3ZhbHVlIjo4MzU0ODM5NTkzMjI3LCJvZmZzZXQiOjg0fQ==",
        "node": {
          "title": "Organica Vol. 4 - Full Production Suite",
          "handle": "organica-vol-4-full-production-suite",
          "createdAt": "2023-10-30T15:07:58Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "3 Project Files, 640+ Organic Samples, 60 Diva Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-OrganicaVol.4-FullProductionSuiteBasicEdition_PML307_700x.png?v=1698678665"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/OrganicaVol4_DemoButton2.mp3?v=1698759736"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "New Edition 4! Kick off your next Organic House production! Make your tracks sound more alive and natural with over 640+ Samples including 250+ One Shots and Organic Sounds and 390+ handcrafted loops. You also get 60 professionally made Diva Presets. Organica Template Edition includes three fully produced Ableton Project Files by Yannek Maunz."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NjM4NjE3MDU5NTk1LCJsYXN0X3ZhbHVlIjo4NjM4NjE3MDU5NTk1LCJvZmZzZXQiOjYwfQ==",
        "node": {
          "title": "Organica Vol. 5 - Full Production Suite",
          "handle": "organica-vol-5-full-production-suite",
          "createdAt": "2024-06-04T13:53:22Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "4 Project Files, 770+ Organic Samples, 100 Diva Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-OrganicaVol.5-FullProductionSuite_700x.png?v=1717509378"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Organica5Snippet.mp3?v=1717513285"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Edition 5! Kick off your next Organic House production! Make your tracks sound more alive and natural with over 770+ Samples including 270+ One Shots and Organic Sounds and 500+ handcrafted loops. You also get 100 professionally made Diva Presets. Organica Template Edition includes 4 fully produced Ableton Project Files by Yannek Maunz."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTk1NjA2NTY1MTMxLCJsYXN0X3ZhbHVlIjo3OTk1NjA2NTY1MTMxLCJvZmZzZXQiOjE0OX0=",
        "node": {
          "title": "Peak Time Bunker Vol 1 - Techno Sample Pack",
          "handle": "peak-time-bunker-vol-1-sample-pack",
          "createdAt": "2022-08-29T16:24:00Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "370+ Pro Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/pmltechnobunker_700x.png?v=1661876894"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PeakTimeTechnoBunker.mp3?v=1661863442"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This pack is stuffed with ready to use kick one shots and loops that will instantly build the foundation of your production.\n370+ Loops professionally crafted to bring your Techno Productions to the next level."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTY0Nzc1NjU3NTM3LCJsYXN0X3ZhbHVlIjo2NTY0Nzc1NjU3NTM3LCJvZmZzZXQiOjIxMH0=",
        "node": {
          "title": "Percussive House - Organic Samples & Loops",
          "handle": "percussive-house-samples-loops-by-florian-busse",
          "createdAt": "2021-06-09T13:00:52Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "600+ Ready to use Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/percussive-house-final_700x.png?v=1625490356"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Demo_Track_Percussive_House.mp3?v=1636736261"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This pack is stuffed with ready to use kick one shots and loops that will instantly build the foundation of your production.\n190+ One Shots & Loops directly from Weska’s Studios in Lisbon/Berlin will bring your Techno Productions to the next level."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4Mjg0MTY1Mzc0MjE5LCJsYXN0X3ZhbHVlIjo4Mjg0MTY1Mzc0MjE5LCJvZmZzZXQiOjk2fQ==",
        "node": {
          "title": "Percussive House Vol. 2 - Organic Samples & Loops",
          "handle": "percussive-house-vol-2-organic-samples-loops",
          "createdAt": "2023-07-11T10:29:41Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "560+ Ready to use Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-SamplePack-PercussiveHouseVol.2_700x.png?v=1689071485"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PercussiveHouseVol2_playsnippet.mp3?v=1689075404"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This pack helps you make your tracks sound more alive and professional right away! Ready to use, royalty free collection with over 560 Samples & Loops! Use with any DAW, no software required."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMjkyODAwODE5MzgsImxhc3RfdmFsdWUiOjEyOTI4MDA4MTkzOCwib2Zmc2V0IjozNDl9",
        "node": {
          "title": "Shaker Loops - Sample Pack",
          "handle": "shaker-loops",
          "createdAt": "2018-01-07T14:09:10Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "370+ Pro Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/13shaker_700x.png?v=1652706274"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Shaker_Loops_Demo.mp3?3041"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The package contains around 105+ shaker loops and percussions. You'll find the raw and unprocessed material as well as the processed one - always in 24bit. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0MzQ5MTEyMDkwNjg5LCJsYXN0X3ZhbHVlIjo0MzQ5MTEyMDkwNjg5LCJvZmZzZXQiOjI2M30=",
        "node": {
          "title": "Tech House Essentials Vol.1",
          "handle": "tech-house-drums-sample-pack",
          "createdAt": "2019-12-03T13:04:52Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "290+ Pro Loops + Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/9techhouseessentials_700x.png?v=1652704890"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_DTS_Demo_Track_preview-coll01.mp3?3031"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The Tech House Essentials is a collection of 290+ loops and samples including Hat and Top Loops, Ambience and Noise Loops and state of the art Drum Samples."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4Mjg5OTQyMTQzMjQzLCJsYXN0X3ZhbHVlIjo4Mjg5OTQyMTQzMjQzLCJvZmZzZXQiOjk0fQ==",
        "node": {
          "title": "Tech House Essentials Vol.2 - Sample Pack",
          "handle": "tech-house-essentials-vol-2",
          "createdAt": "2023-07-18T11:41:41Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "600+ Loops and One-Shots + Construction Kits"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-SamplePack-TechHouseEssentialsVol.2_700x.png?v=1689680516"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_TEV2_AXO_All_128BPM_D_min.mp3?v=1689676279"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "The most complete sample selection for TECH HOUSE. Sketch ideas and produce state of the art Tech House tracks with over 600 Loops, One Shots and construction Kits."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNTQ2ODMwMzE1NTg1LCJsYXN0X3ZhbHVlIjoxNTQ2ODMwMzE1NTg1LCJvZmZzZXQiOjMxN30=",
        "node": {
          "title": "Techno Kickdrums Vol.1 - Drum Sample Pack",
          "handle": "techno-kickdrums-vol-1-drum-sample-pack",
          "createdAt": "2018-10-22T18:56:35Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "100+ Pro Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/12technokickdrums_700x.png?v=1652704919"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_PML_Panorama.mp3?16364422811061289228"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Download Professional Drum Sample Pack with 100+ one shot samples, perfect kicks, reverbed techno kicks, kick loops and additional bonus loops."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDIwNjE3MDI1MTUzMSwibGFzdF92YWx1ZSI6MTAyMDYxNzAyNTE1MzEsIm9mZnNldCI6MTd9",
        "node": {
          "title": "Techno Underground - Sample Pack",
          "handle": "techno-underground-sample-pack",
          "createdAt": "2025-05-28T14:40:35Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "100+ One Shot Samples, 100+ Loop Samples, 20 MIDI Loops "
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Techno_Underground_Sample_Pack_Box_Logo_700x.png?v=1752055300"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Techno-SamplePack-Underground-Demo.mp3?v=1748438345"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Channel the Berlin underground. This hard-hitting sample pack delivers everything you need to create club-ready techno—dark, driving, & uncompromising.\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjYzNjAxMTkzMjI3LCJsYXN0X3ZhbHVlIjo4MjYzNjAxMTkzMjI3LCJvZmZzZXQiOjEwMX0=",
        "node": {
          "title": "Vocalized - Sample Pack",
          "handle": "vocalized-sample-pack",
          "createdAt": "2023-06-07T13:11:12Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "250+ Creative Vocal Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/vocalized5_700x.png?v=1686143495"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Vocalized_Demo_Track.mp3?v=1686568061"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "250+ Professionally produced & processed vocal samples that will inspire and add life to your tracks including stutters, textures, pads, sequences, FX and more, all made from expert recorded vocals. 100% Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NTgxMDkzNzUzMDk5LCJsYXN0X3ZhbHVlIjo4NTgxMDkzNzUzMDk5LCJvZmZzZXQiOjYzfQ==",
        "node": {
          "title": "Vocalized Vol.2 - Sample Pack",
          "handle": "vocalized-vol-2-sample-pack",
          "createdAt": "2024-05-07T14:52:11Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "200+ Creative Vocal Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-SamplePack-VocalizedVol.2_700x.png?v=1715098433"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Vocalized2-Collection-Demo.mp3?v=1715183229"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A brand new Vocalized edition with 200+ all new professionally produced & processed vocal samples that will inspire and add life to your tracks including stutters, textures, pads, sequences, FX and more, all made from expert recorded vocals. 100% Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDE3ODcwNjUxNjU5LCJsYXN0X3ZhbHVlIjo4MDE3ODcwNjUxNjU5LCJvZmZzZXQiOjEzN30=",
        "node": {
          "title": "Vocals Vol.1 - Sample Pack",
          "handle": "vocals-vol-1-sample-pack",
          "createdAt": "2022-11-07T12:28:03Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "300+ Male & Female Vocal Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/VocalVol1_700x.png?v=1667827474"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DEMO_PML_Vocal_Pack_-_Mix_V2.mp3?v=1667824750"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "300+ Professionally produced vocal samples including long and short phrases, drones, spoken words, whispers, effects, and more. All key and tempo labeled. 100% Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjUyMTAwMzEzMzU1LCJsYXN0X3ZhbHVlIjo4MjUyMTAwMzEzMzU1LCJvZmZzZXQiOjEwMn0=",
        "node": {
          "title": "Vocals Vol.2 - Sample Pack",
          "handle": "vocals-vol-2-sample-pack",
          "createdAt": "2023-05-23T08:39:47Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "500+ Pro Vocal Samples and Vocal FXs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/VocalsVol.2_700x.png?v=1684836645"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Vocals_vol2_Playbutton.mp3?v=1684831231"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "500+ Professionally produced vocal samples including long and short phrases, drones, spoken words, whispers, effects, and more. All key and tempo labeled. 100% Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NTY1OTE5MTg3MjExLCJsYXN0X3ZhbHVlIjo4NTY1OTE5MTg3MjExLCJvZmZzZXQiOjY0fQ==",
        "node": {
          "title": "Vocals Vol.3 - Sample Pack",
          "handle": "vocals-vol-3-sample-pack",
          "createdAt": "2024-04-25T15:15:49Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "400+ Pro Vocal Samples and Vocal FXs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-SamplePack-VocalsVol.3_700x.png?v=1714058452"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Vocals3_demo_Snippet.mp3?v=1714058605"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "400+ Professionally produced vocal samples including long and short phrases, drones, spoken words, whispers, effects, and more. All key and tempo labeled. 100% Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4ODM3NzQ3NzA0MDc1LCJsYXN0X3ZhbHVlIjo4ODM3NzQ3NzA0MDc1LCJvZmZzZXQiOjUwfQ==",
        "node": {
          "title": "Vocals Vol.4 - Sample Pack - Tech House",
          "handle": "vocals-vol-4-sample-pack-tech-house",
          "createdAt": "2024-09-27T15:57:31Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "400+ Pro Vocal Samples and Vocal FXs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/vocals_4_updated_tech_house_700x.png?v=1727452909"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Tech_House_-_Thunder__Ableton_11.1_and_Serum.mp3?v=1722266208"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "400+ Professionally produced vocal samples including long and short phrases, drones, spoken words, whispers, effects, and more. All key and tempo labeled. 100% Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4ODM3NzI4NjMzMDk5LCJsYXN0X3ZhbHVlIjo4ODM3NzI4NjMzMDk5LCJvZmZzZXQiOjUxfQ==",
        "node": {
          "title": "Vocals Vol.5 - Sample Pack - Afro House",
          "handle": "vocals-vol-5-sample-pack-afro-house",
          "createdAt": "2024-09-27T15:24:15Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "400+ Pro Vocal Samples and Vocal FXs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/afro_house_vocal_phrases1_700x.png?v=1727450799"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Rollin___Ableton_11.1__Grand_Piano_Version.mp3?v=1724920938"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "400+ Professionally produced vocal samples including long and short phrases, drones, spoken words, whispers, effects, and more. All key and tempo labeled. 100% Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4ODQzODc2MjM3NTc5LCJsYXN0X3ZhbHVlIjo4ODQzODc2MjM3NTc5LCJvZmZzZXQiOjQ4fQ==",
        "node": {
          "title": "Vocals Vol.6 - Sample Pack",
          "handle": "vocals-vol-6-sample-pack",
          "createdAt": "2024-10-01T15:58:13Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "400+ Pro Vocal Samples and Vocal FXs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/vocals6-VocalsforEDMRecovered_700x.png?v=1728308551"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Vocals-Vol6-Demo.mp3?v=1728311767"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "400+ Professionally produced vocal samples including long and short phrases, drones, spoken words, whispers, effects, and more. All key and tempo labeled. 100% Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjU1Nzg2NzIxMzQ1LCJsYXN0X3ZhbHVlIjo0NjU1Nzg2NzIxMzQ1LCJvZmZzZXQiOjIyN30=",
        "node": {
          "title": "Woodlands Vol. 1 - Organic House Sample Pack",
          "handle": "woodlands-vol-1",
          "createdAt": "2021-02-08T15:38:19Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "220+ Organic Samples + Loops + Midis"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/woodlands-1_700x.png?v=1645809254"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Woodlands_Demo__01.mp3?v=1634121563"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This sample pack bundle includes a broad range of totally unique sounds including organic synths and percussion, chord progresses, crunchy percussion, beautiful kicks, hats and hits."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTkyMTU4NzkzNzkzLCJsYXN0X3ZhbHVlIjo2NTkyMTU4NzkzNzkzLCJvZmZzZXQiOjIwNH0=",
        "node": {
          "title": "Woodlands Vol. 2 - Organic House Sample Pack",
          "handle": "woodlands-vol-2-organic-house-sample-pack",
          "createdAt": "2021-08-24T14:44:49Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacks"
          },
          "catalogDescription": {
            "value": "200+ Organic Samples + 8 Song Packs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/woodlands-2_700x.png?v=1645809458"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Demo_woodlands_Magnolia_Drums_123.mp3?v=1645812622"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This sample pack bundle includes a broad range of totally unique sounds including organic synths and percussion, chord progresses, crunchy percussion, beautiful kicks, hats and hits."
          }
        }
      }
    ],
    "samplePacksXArtist": [
      {
        "cursor": "eyJsYXN0X2lkIjo3OTg5ODU4OTI2ODU5LCJsYXN0X3ZhbHVlIjo3OTg5ODU4OTI2ODU5LCJvZmZzZXQiOjE1Mn0=",
        "node": {
          "title": "Afro House Production Pack - by Tim Engelhardt Vol.2",
          "handle": "tim-engelhardt-production-pack-melodic-techno-vol-2",
          "createdAt": "2022-08-08T14:59:04Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "3 Project Files, 200+ Samples, 100 Diva Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Tim_Engelhardt_-_Afro_House_Sound_Pack_Vol.2_700x.png?v=1720023743"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Tim-Engelhardtv2_Preview.mp3?v=1659971043"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Get Tim Engelhardt’s current private producer library - with samples, loops & presets. \n3 fully produced tracks as Ableton files give you a headstart for your next Melodic Techno production.\n\n“You get exactly the sounds I work with!” Tim Engelhardt"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NTc2Mjc3ODIzNTUzLCJsYXN0X3ZhbHVlIjo0NTc2Mjc3ODIzNTUzLCJvZmZzZXQiOjI1MH0=",
        "node": {
          "title": "Ben Böhmer Style - Melodic Deep Sound Pack",
          "handle": "ben-bohmer-style-melodic-deep-sound-pack",
          "createdAt": "2020-09-02T11:32:40Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "7 Project Files, 150+ Samples, 50 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/ben_new_version_blue_-_Melodci_Deep_v2_700x.png?v=1752855870"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1752679758745.874-DJ_Mix_2_Melodic_Deep.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Ben Böhmer Style  Sound Pack for Ableton. MIDIs, Samples and More"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzE2MDg4NzEzNDgzLCJsYXN0X3ZhbHVlIjo4MzE2MDg4NzEzNDgzLCJvZmZzZXQiOjkxfQ==",
        "node": {
          "title": "Fejka: Melodic & Organic Sample Pack",
          "handle": "melodic-organic-sample-pack-by-fejka",
          "createdAt": "2023-08-31T13:45:08Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "315+ Samples, Ableton Instruments and Project Files by Fejká. "
          },
          "enhancedDescription": {
            "value": "Fejká presents his organic and analog sound in this sample pack full of 300+ royalty-free and ready-to-use loops & one-shots as well as 5 Ableton Instruments, and 4 Ableton Project file construction kits!"
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/fejkav2.2_2_700x.png?v=1693834603"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Fejka_Playbutton.mp3?v=1693583871"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Fejká presents his organic and analog sample pack full of royalty-free and ready-to-use loops & one-shots as well as 5 Ableton Instruments, and 4 Ableton Project file constructor kits!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDIxMTk2MzQxNTE1LCJsYXN0X3ZhbHVlIjo4MDIxMTk2MzQxNTE1LCJvZmZzZXQiOjEzMX0=",
        "node": {
          "title": "Jimi Jules - Sample Pack",
          "handle": "jimi-jules-x-pml-artist-sample-pack",
          "createdAt": "2022-11-14T15:18:03Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "300+ Loops and One Shots"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PACK_JIMIJULES-samplepack_700x.png?v=1668507980"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/JJ_Playbutton_Sample_Pack.mp3?v=1668516084"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Jimi Jules presents his long awaited Sample Pack full of royalty-free and ready-to-use loops & one shots, that get you closer to the professional club sound he is known for."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MTA2NTA3NDY5MDY3LCJsYXN0X3ZhbHVlIjo4MTA2NTA3NDY5MDY3LCJvZmZzZXQiOjExOH0=",
        "node": {
          "title": "Jonas Saalbach - Loops & Song Starters - Melodic Techno",
          "handle": "jonas-saalbach-loops-song-starters-melodic-techno",
          "createdAt": "2023-01-27T14:04:26Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "350 Loops by Jonas Saalbach (Radikon)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/jonas-final_700x.png?v=1674828357"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/JonasSaalbachSamplesDemo.mp3?v=1676290054"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Jonas Saalbach presents his long awaited Sample Pack full of royalty-free and ready-to-use loops from 28 different song starters to jump-start your next track."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjU5MDU5MTk1OTY5LCJsYXN0X3ZhbHVlIjo0NjU5MDU5MTk1OTY5LCJvZmZzZXQiOjIyNn0=",
        "node": {
          "title": "Melodic House Drum Sample Pack - Midnight Punch",
          "handle": "midnight-punch-drums-for-melodic-house-techno",
          "createdAt": "2021-02-14T20:10:23Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "100+ Pro Drum Samples + Ableton Project"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/8midnightpunch_700x.png?v=1652704788"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/MidnightPunchBoundToDivideDemo.mp3?v=1623763602"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Drum Samples and Loops About Midnight Punch (by Bound to Divide)  Midnight Punch is a great starting point with professional sounding one shots, ready to use loops and Bound To Divide signature sounds you will not find in any other pack."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjA0NjUwNjg0NDgxLCJsYXN0X3ZhbHVlIjo0NjA0NjUwNjg0NDgxLCJvZmZzZXQiOjIzOH0=",
        "node": {
          "title": "Melodic Techno Production Pack - by Tim Engelhardt",
          "handle": "tim-engelhardt-production-pack-melodic-techno",
          "createdAt": "2020-10-23T09:07:09Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "3 Project Files, 135+ Samples, 35 MIDIs, 95 Diva Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/1timengelhardt-orange_ee15ef08-a550-4e03-875b-ce5dc21ee03e_700x.png?v=1652364590"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/TimEngelhardtProductionPackDemo.mp3?v=1623665234"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Techno Production Pack for Ableton created by Artist & Producer Tim Engelhardt. Sample Pack, DIVA Synth Presets, Midi Pack and 3 fully editable Ableton Project Files."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NjU3MDg0MzkxNDg5LCJsYXN0X3ZhbHVlIjo2NjU3MDg0MzkxNDg5LCJvZmZzZXQiOjE5NH0=",
        "node": {
          "title": "Modern Melodic Techno - Decades - Ableton Template (by Dahu)",
          "handle": "decades-modern-melodic-techno-ableton-template-by-dahu",
          "createdAt": "2021-11-11T16:15:26Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/dahu_700x.png?v=1638966555"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DEMO-PML_-_Melodic_Techno_-_Decades_by_Dahu__01.mp3?v=1636651387"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Melodic Techno Ableton Template. Download full arranged customizable mastered project file. All samples included!\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjU0NDMyNjQ5MjgxLCJsYXN0X3ZhbHVlIjo0NjU0NDMyNjQ5MjgxLCJvZmZzZXQiOjIyOH0=",
        "node": {
          "title": "Nils Hoffmann Production Pack - Melodic Techno",
          "handle": "nils-hoffmann-production-pack",
          "createdAt": "2021-02-05T10:23:13Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "2 Project Files, 120+ Samples, 60 Diva Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/2nils-2_f8ba9caa-e2e7-4c5a-8e04-f25f63866b13_700x.png?v=1652365558"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/NilsHoffmannProductionPack.mp3?v=1623421339"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Techno Production Pack for Ableton created by Artist & Producer Nils Hoffmann. Includes a Sample Pack, DIVA Synth Presets, Midi Pack and 2 fully  produced Ableton Project Files."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTkyMTcxNzM3MTUzLCJsYXN0X3ZhbHVlIjo2NTkyMTcxNzM3MTUzLCJvZmZzZXQiOjIwMX0=",
        "node": {
          "title": "Organic House Essentials - Samples & Presets by Felix Raphael",
          "handle": "organic-house-essentials",
          "createdAt": "2021-08-24T15:05:39Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "220+ Samples, 50+ Diva Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/felix_700x700_bdfa723b-78eb-4516-a965-e366c1b60a57_700x.png?v=1646310376"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Demo_Track_FelixRaphael.mp3?v=1636736261"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This pack is stuffed with ready to use kick one shots and loops that will instantly build the foundation of your production.\n190+ One Shots & Loops directly from Weska’s Studios in Lisbon/Berlin will bring your Techno Productions to the next level."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzYyMDk4NTI0MjI1LCJsYXN0X3ZhbHVlIjo2NzYyMDk4NTI0MjI1LCJvZmZzZXQiOjE3Nn0=",
        "node": {
          "title": "Peak Time Festival Track - Miombo - (Laroz - Sam Shure Cowbell Dub)",
          "handle": "miombo-peak-time-festival-track-laroz-sam-shure-cowbell-dub",
          "createdAt": "2022-03-09T05:22:58Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/sam-shure2_700x.png?v=1646803994"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/SamShure_Miombo.mp3?v=1646803900"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Peak Time Ableton Template - with all sounds, samples, FX and fully mixed & mastered. \n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTUxODE5NTgzNTUzLCJsYXN0X3ZhbHVlIjo2NTUxODE5NTgzNTUzLCJvZmZzZXQiOjIxNX0=",
        "node": {
          "title": "Peak Time Techno - Samples by WESKA",
          "handle": "peak-time-techno-samples-by-weska",
          "createdAt": "2021-04-26T14:02:38Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "190+ Ready to use Samples + Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/weska_700x.png?v=1649693473"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/WeskaDemoMix.mp3?v=1623412480"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This pack is stuffed with ready to use kick one shots and loops that will instantly build the foundation of your production.\n190+ One Shots & Loops directly from Weska’s Studios in Lisbon/Berlin will bring your Techno Productions to the next level."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MTAxMDI1MTUzMjkxLCJsYXN0X3ZhbHVlIjo4MTAxMDI1MTUzMjkxLCJvZmZzZXQiOjExOX0=",
        "node": {
          "title": "Peak Time Techno Vol. 2 - Samples by WESKA",
          "handle": "peak-time-techno-vol-2-samples-by-weska",
          "createdAt": "2023-01-23T16:42:05Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "260+ Ready to use Samples + Loops & 35 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-PeakTimeTechnoVol.2-SamplesbyWeska_700x.png?v=1674492149"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Playbutton.mp3?v=1674492237"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This pack is stuffed with ready to use kick one shots and loops that will instantly build the foundation of your production.\n240+ One Shots & Loops and 35 MIDI directly from Weska’s Studios in Lisbon/Berlin will bring your Techno Productions to the next level."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NjU2ODcxMjAyODgxLCJsYXN0X3ZhbHVlIjo2NjU2ODcxMjAyODgxLCJvZmZzZXQiOjE5NX0=",
        "node": {
          "title": "Stil vor Talent x PML Artist Pack Vol. 1 - Cioz",
          "handle": "stil-vor-talent-x-pml-artist-pack-vol-1-cioz",
          "createdAt": "2021-11-11T09:32:01Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "310+ Samples, Big Drum Rack, 7 Sound Design Tools"
          },
          "enhancedDescription": {
            "value": "In his finest selection Cioz captures his fluffy, groovy feeling in over 210 loops and 100+ one shots, while adding his best racks as well. You will instantly want to start a track, all loops are set to 122 BPM and all melodic / harmonic loops are in A Minor: everything matches with everything for endless creativity!"
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/cioz2_1_700x.png?v=1637069239"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PMLXSVTxCioz-_Cioz_FlowState.mp3?v=1637315313"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "In his first pack ever he was able to capture that fluffy, groovy feeling in over 210 loops. You will instantly want to start a track. All loops are set to 122BPM and all melodic / harmonic loops are in A Minor: everything matches with everything for endless creativity!\n\nThe included “Big Drum Rack” is Cioz finest selection of samples all built into one single tool - with everything perfectly compressed, EQed & side chained plus creative FX for playing live and fast production. You get Cioz's complete workflow!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTY1NjA2NDc4MDkxLCJsYXN0X3ZhbHVlIjo3OTY1NjA2NDc4MDkxLCJvZmZzZXQiOjE2Mn0=",
        "node": {
          "title": "Stil vor Talent x PML Artist Pack Vol. 2 - Pølaroit",
          "handle": "stil-vor-talent-x-pml-artist-pack-vol-2-polaroit",
          "createdAt": "2022-05-30T13:22:28Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "330+ Samples, Ableton Racks & Instruments"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/polaroit_1_1_2e29f4a1-778a-4f02-997d-45279d743558_700x.png?v=1662062450"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Polaroit_Demo.mp3?v=1671190618"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "210+ One-shot and 120+ Loops as Wav Files. All samples are 100% royalty-free. Bonus: 1 Chord Progression Generator, 8 Ableton Effect Racks & Instruments (Piano & Organ), Project File by Janus Rasmussen (Kiasmos), Extra 30 Minute Studio Session video."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MTQzNDM1OTU2NDkxLCJsYXN0X3ZhbHVlIjo4MTQzNDM1OTU2NDkxLCJvZmZzZXQiOjExN30=",
        "node": {
          "title": "Stil vor Talent x PML Artist Pack Vol. 3 - Oliver Koletzki",
          "handle": "stil-vor-talent-x-pml-artist-pack-oliver-koletzki",
          "createdAt": "2023-02-17T15:49:32Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "800+ Samples by Oliver Koletzki"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-SamplePack-OliverKoletzki_700x.png?v=1676649090"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Playbutton_Snippet.mp3?v=1676974791"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Get the sound of legendary producer and Stil vor Talent label founder Oliver Koletzki!\n'Now ALL of you get the chance to work with some of my original loops from tracks like “Hypnotized”, “Tankwa Town” and “A tribe called Kotori” among a huge selection of royalty-free loops and one shots.' -Oliver Koletzki"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjQ1Njg3MjU1MzA3LCJsYXN0X3ZhbHVlIjo4MjQ1Njg3MjU1MzA3LCJvZmZzZXQiOjEwM30=",
        "node": {
          "title": "Super Flu - Sample Pack",
          "handle": "super-flu-sample-pack",
          "createdAt": "2023-05-15T14:49:44Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "590+ Royalty-Free Loops and Samples from Analog Synths and Original Field Recordings"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/superflu-final_1_700x.png?v=1684324928"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Super_Flu_-_Snippet_for_Playbutton.mp3?v=1684162381"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This pack features a wide range of Super Flu’s go to sounds from their analog synths. On top you get a massive library of scrapyard field recordings produced as loops and one-shots. A toolkit loaded with organic sounds and analog warmth!\n\n“This is basically our complete sound collection” - Super Flu"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzcyMjE1NjExNjU5LCJsYXN0X3ZhbHVlIjo4MzcyMjE1NjExNjU5LCJvZmZzZXQiOjgwfQ==",
        "node": {
          "title": "Techno Production Pack - Radiation",
          "handle": "techno-production-pack-radiation",
          "createdAt": "2023-11-17T12:29:42Z",
          "pmlProductCategory": {
            "value": "samplePacks--samplePacksXArtist"
          },
          "catalogDescription": {
            "value": "4h+ Full Online Course with Project Files, Techno Sample Pack with 100+ One-Shots and Loops"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Radiation-TechnoProductionPackbyJohannesMenzel_PML306_700x.png?v=1700224238"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/RadiationPlaybackDemo.mp3?v=1700239685"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Want to Produce Better Techno? About this Pack Introducing Radiation - the brand new Production Pack for Techno by Johannes Menzel. Get a full length course and techno sample pack."
          }
        }
      }
    ],
    "styleGuide": [
      {
        "cursor": "eyJsYXN0X2lkIjo4Njc4MDgyMzgwMDQzLCJsYXN0X3ZhbHVlIjo4Njc4MDgyMzgwMDQzLCJvZmZzZXQiOjU4fQ==",
        "node": {
          "title": "Afro House Sound Pack",
          "handle": "afro-house-sound-pack",
          "createdAt": "2024-06-24T12:37:07Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "4 Project Files, 300+ Samples, 60 MIDIs, 60 Serum Presets"
          },
          "enhancedDescription": {
            "value": "Dive into the sound of the summer, vibrant rhythms, grooves and mesmerizing soundscapes. Including 340+ Samples, Vocals, 75+ Serum Presets, 75+ MIDI files and optionally 4 fully produced Tracks as Ableton Projects."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/New_Afro_House_Box_700x.png?v=1719329896"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/AfroHouse_Play_button.mp3?v=1719305213"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Afro House Sound Pack for Ableton and Serum. Dive into vibrant rhythms and mesmerizing soundscapes inspired by Keinemusik, Black Coffee, Rampa, Adam Port, &me, Alan Dixon, Arabic Piano, Rufus du Sol, and more."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4ODcwNzQ1NTM4ODI3LCJsYXN0X3ZhbHVlIjo4ODcwNzQ1NTM4ODI3LCJvZmZzZXQiOjQ3fQ==",
        "node": {
          "title": "Afro House Sound Pack Vol.2",
          "handle": "afro-house-sound-pack-vol-2",
          "createdAt": "2024-10-22T14:25:58Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "5 Project Files, 450+ Samples, 45 MIDIs, 45 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/afrovol2-2_700x.png?v=1729696525"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/AfroHouseDemoSnippet.mp3?v=1729610944"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Afro House Sound Pack for Ableton and Serum. Dive into vibrant rhythms and mesmerizing soundscapes inspired by Keinemusik, Black Coffee, Rampa, Adam Port, &me, Alan Dixon, Arabic Piano, Rufus du Sol, and more."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTgzNjM4ODAyNjk5LCJsYXN0X3ZhbHVlIjo4OTgzNjM4ODAyNjk5LCJvZmZzZXQiOjM1fQ==",
        "node": {
          "title": "Afro House Sound Pack Vol.3",
          "handle": "afro-house-sound-pack-vol-3",
          "createdAt": "2025-01-07T11:28:33Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "5 Project Files, 440+ Samples, 71 MIDIs, 71 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/afro_vol_3-updated2_700x.png?v=1738319816"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/AfroHouseVol3_Mini_Mix_342a8104-e972-480d-86ff-f3df1da91b36.mp3?v=1736250008"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Instant Afro House! Dive into 5 fully produced and educational Ableton Project Files. Includes 440+ premium samples, 70+ Serum presets, and matching MIDI files!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDY1NjE4NzM4NDA3NSwibGFzdF92YWx1ZSI6MTA2NTYxODczODQwNzUsIm9mZnNldCI6Nn0=",
        "node": {
          "title": "Afro House Sound Pack Vol.4",
          "handle": "afro-house-sound-pack-vol-4",
          "createdAt": "2025-07-31T13:53:11Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "8 Project Files, 530+ Samples, 70+ MIDIs, 70+ Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/afrohousesoundpack4productbox_700x.png?v=1754306721"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1753970179407-Dj_Mix.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Dive into the groove of modern Afro House with 8 fully arranged Ableton Project Files, 500+ premium samples, 70+ inspiring Serum 2 presets, and soulful vocal loops! Everything you need to ignite your next track."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjAyMTM3MDE4NDMzLCJsYXN0X3ZhbHVlIjo0NjAyMTM3MDE4NDMzLCJvZmZzZXQiOjI0MH0=",
        "node": {
          "title": "Classic House - Sound Pack",
          "handle": "vintage-house-sample-pack-drum-samples-instruments",
          "createdAt": "2020-10-19T17:49:20Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "400+ Samples, 2 Project Files, 5 Racks"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/8-3classichouse-purp_700x.png?v=1649937568"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/VintageHouseDemo.mp3?v=1623752147"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Classic Vintage House Sample Pack - filled with Drum Samples, Loops & Ableton Instrument Racks in the style of Oldschool / Jacking House like Kerri Chandler, Carl Craig or Black Loops."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4ODk2NTE0NDkwNjM1LCJsYXN0X3ZhbHVlIjo4ODk2NTE0NDkwNjM1LCJvZmZzZXQiOjQ1fQ==",
        "node": {
          "title": "Deep House - Sound Pack - Reflections",
          "handle": "deep-house-sound-pack-reflections",
          "createdAt": "2024-11-12T16:49:13Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "5 Project Files, 300+ Samples, 50 MIDIs, 50 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-DeepHouse-SoundPack-Reflections_PML347_700x.png?v=1731430258"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DeepHouseReflection_DemosSnippet.mp3?v=1731514961"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Dive into state-of-the-art Deep House sound with 5 fully arranged tracks as (educational)\nAbleton Project Files, 240+ Deep House Samples, 50+ Serum Presets and inspiring MIDI!\nLet’s make some music!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NTg0ODkyMzk5NjgxLCJsYXN0X3ZhbHVlIjo0NTg0ODkyMzk5NjgxLCJvZmZzZXQiOjI0Nn0=",
        "node": {
          "title": "Deep Vibes - Progressive House - Sound Pack",
          "handle": "deep-melodic-house-sound-pack",
          "createdAt": "2020-09-18T18:06:43Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "4 Project Files, 150+ Samples, 50 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/DeepVibesSoundpack-newProductV2_700x.png?v=1652214044"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DeepVibesProgressiveHouseSoundPack.mp3?v=1623670581"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Progressive House Sound Pack for Ableton. MIDIs, Samples and Construction Kits in style of Anjunadeep. Includes 4 fully produced templates as Ableton Project files, ready to breakdown and use as a starting point for your own productions!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTg3MTk3NzAyNDExLCJsYXN0X3ZhbHVlIjo4OTg3MTk3NzAyNDExLCJvZmZzZXQiOjM0fQ==",
        "node": {
          "title": "House - Sound Pack - Fun Times",
          "handle": "house-sound-pack-fun-times",
          "createdAt": "2025-01-08T15:32:15Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "5 Ableton Project Files, 420+ Samples, 75 MIDIs, 75 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/house3_700x.png?v=1736792730"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_House_Pack_Demo_Mix_for_Collections_Page.mp3?v=1736855743"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Heat up the dancefloor with 5 fully produced Ableton Project Files, vibrant 75 Serum presets and 420+ samples in the styles of Peggy Gou, Mark Knight, and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NTkxNTcyODQ0NjA5LCJsYXN0X3ZhbHVlIjo0NTkxNTcyODQ0NjA5LCJvZmZzZXQiOjI0NX0=",
        "node": {
          "title": "Masquerade Pack - High Tech Minimal Techno Sound Pack",
          "handle": "masquerade-pack-high-tech-minimal-techno-sound-pack",
          "createdAt": "2020-09-30T14:20:42Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "3 Project Files, 135+ Samples, 50 MIDIs"
          },
          "enhancedDescription": {
            "value": "Get massive inspiration for your next High Tech Minimal Techno track using this Ableton pack including MIDIs, Samples and Construction Kits as well as 3 fully arranged and mastered Ableton project files. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/41-MasqueradePackV1_edfa22d7-3d8e-4182-ba80-8ffaebac2316_700x.png?v=1651597123"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Everything_Pack_Demo_-_PurpleDiver_37d1ab06-bf9f-44fc-9fd9-36f6654dd528.mp3?v=1633011944"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "High Tech Minimal Techno Sound Pack for Ableton. MIDIs, Samples and Construction Kits in style of Brejcha, Boris. Download 3 fully arranged and mastered Ableton project files, samples, midi and more."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5NzQ2OTA5NDYyNzk1LCJsYXN0X3ZhbHVlIjo5NzQ2OTA5NDYyNzk1LCJvZmZzZXQiOjI5fQ==",
        "node": {
          "title": "Melodic Bass House - Sound Pack - Vibes",
          "handle": "melodic-bass-house-sound-pack-vibes",
          "createdAt": "2025-02-19T14:46:57Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "6 Project Files, 330+ Samples, 77 MIDIs, 77 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-SoundPack-Vibe-MelodicBassHouse_PML363-darker_700x.png?v=1740501605"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Melodic_Bass_House_Dj_Mix.mp3?v=1739976322"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Step into the vibrant world of Melodic Bass House inspired by Fred again, Nimino, Sebastian Ingrosso and more. Featuring 180+ groove-infused loops, 150 crisp one-shots, 77+ Serum presets + matching MIDI files, and 6 fully produced Ableton Project files!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjAyMTE2OTMxNjQ5LCJsYXN0X3ZhbHVlIjo0NjAyMTE2OTMxNjQ5LCJvZmZzZXQiOjI0Mn0=",
        "node": {
          "title": "Melodic Deep - Ableton Sound Pack",
          "handle": "melodic-deep-ableton-production-pack-by-francois-rengere",
          "createdAt": "2020-10-19T16:56:52Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "7 Project Files, 150+ Samples, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/24.1-melodic-deep-pack-francois_700x.png?v=1652358646"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/MelodicDeepAbletonSoundPack.mp3?v=1623671709"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Deep Sound Pack for Ableton. MIDIs, Samples and Construction Kits in style of Francois Rengere."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5MDExMzE5MDEzNjQzLCJsYXN0X3ZhbHVlIjo5MDExMzE5MDEzNjQzLCJvZmZzZXQiOjMzfQ==",
        "node": {
          "title": "Melodic House - Sound Pack - Beyond Life",
          "handle": "melodic-house-sound-pack-beyond-life",
          "createdAt": "2025-01-24T16:52:42Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "6 Project Files, 340+ Samples, 70 MIDIs, 70 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MelodicHouse-SoundPack-BeyondLife_PML359_700x.png?v=1737984847"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/BeyondLife_MiniMix.mp3?v=1737982001"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Dive into the dreamy soundscapes of Melodic House. Including 340+ Samples, 70+ Serum\nPresets and 70+ MIDI files and 6 fully produced tracks as Ableton Projects."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDUzNjE5MDI3OTk0NywibGFzdF92YWx1ZSI6MTA1MzYxOTAyNzk5NDcsIm9mZnNldCI6MTB9",
        "node": {
          "title": "Melodic House - Sound Pack - Fragments",
          "handle": "melodic-house-sound-pack-fragments",
          "createdAt": "2025-06-27T12:38:52Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "9 Project Files, 520+ Samples, 80 Serum Presets & MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/FragmentsBox2_700x.png?v=1751288044"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1751293309560-PML379_FragmentsDemoMixv2.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Uncover the sound of today's leading Melodic House artists with 9 full Ableton projects, 300+ emotive loops, 80+ pro-grade Serum presets, and 130+ inspiring MIDI files—all designed for expressive, club-ready production."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NTE5MzEwNDQyNzYzLCJsYXN0X3ZhbHVlIjo4NTE5MzEwNDQyNzYzLCJvZmZzZXQiOjY5fQ==",
        "node": {
          "title": "Melodic House Sound Pack - Twilight Rhythms",
          "handle": "melodic-house-production-kit-twilight-rhythms",
          "createdAt": "2024-03-21T06:26:09Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "5+ Ableton Templates, 50+ Serum Presets, 60+ Samples, 50+ MIDI Files"
          },
          "enhancedDescription": {
            "value": "Jump start your next Melodic Deep House production. Get 5 Fully Produced Ableton project files, 60+ Samples, 50 MIDI Files, 50 Serum Presets, professionally produced for Melodic House!"
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/twilight-update_700x.png?v=1726309011"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Melodic-House-Twilight-v1.3.Demo.mp3?v=1726232056"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This sound pack includes everything you need to jump start your next Melodic Deep House production. Get 5 Fully Produced Ableton project files, 60+ Samples, 50 MIDI Files, 50 Serum Presets, professionally produced for modern Melodic House!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTQyNDgzNDM5ODgzLCJsYXN0X3ZhbHVlIjo4OTQyNDgzNDM5ODgzLCJvZmZzZXQiOjQyfQ==",
        "node": {
          "title": "Melodic Techno - Analog Rooms - Sound Pack",
          "handle": "melodic-techno-analog-rooms-sound-pack",
          "createdAt": "2024-12-10T14:11:10Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "6 Project Files, 170+ Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/analog_rooms_700x.png?v=1734690190"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DJ_Mix.mp3?v=1733838840"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Jumpstart your next production with 6 fully produced Ableton Project Files in the style of Stephan Bodzin,  Raphael Hoffmann, Rodriguez Jr., and more.  Powerful analog inspired patches at your fingertips!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTQzMTgyMDUzNjQzLCJsYXN0X3ZhbHVlIjo4OTQzMTgyMDUzNjQzLCJvZmZzZXQiOjQxfQ==",
        "node": {
          "title": "Melodic Techno - Axon Terminals - Sound Pack",
          "handle": "melodic-techno-axon-terminals-sound-pack",
          "createdAt": "2024-12-11T09:46:59Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "6 Project Files, 25 Diva Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/axon1_700x.png?v=1734537537"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/AxonTerminals_DJ_Mix.mp3?v=1733848704"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "State-of-the-art Melodic Techno Ableton template collection. Download fully arranged, customizable, mastered project files. All samples and presets included!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTQxNjQ5Mjk3Njc1LCJsYXN0X3ZhbHVlIjo4OTQxNjQ5Mjk3Njc1LCJvZmZzZXQiOjQzfQ==",
        "node": {
          "title": "Melodic Techno - Deep Dynamic - Sound Pack",
          "handle": "deep-dynamics-sound-pack",
          "createdAt": "2024-12-09T16:11:49Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "9 Project Files, 200+ Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/deep_dynamic_700x.png?v=1734690203"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DeepDynamics_DJMix_256.mp3?v=1733826869"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Explore the sound of the mid 2010s with 9 fully produced and educational Ableton Project files in the styles of ANNA, NTO, Stephan Bodzin, Moderat, Solomun, Ten Walls, Francois Rengere and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDEyMDc1MzgwNzYyNywibGFzdF92YWx1ZSI6MTAxMjA3NTM4MDc2MjcsIm9mZnNldCI6MjR9",
        "node": {
          "title": "Melodic Techno - Sound Pack - Mesmerize",
          "handle": "melodic-techno-sound-pack-mesmerize",
          "createdAt": "2025-04-07T11:50:38Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "8 Project Files, 440+ Samples, 75 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MelodicTechno-SoundPack-Mesmerize_PML369_700x.png?v=1744027125"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/MT3_Demo_Mix_shorter.mp3?v=1744101866"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Capture the spirit of Modern Melodic Techno—featuring 440+ samples, 75+ Serum presets,\nand 75+ MIDI files. Inspired by Morten, Artbat, Hollt, Mind Against, and Stephan Bodzin.\nPlus, 8 fully produced Ableton Project files to kickstart your creativity!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4ODQyNTk0NDE4OTU1LCJsYXN0X3ZhbHVlIjo4ODQyNTk0NDE4OTU1LCJvZmZzZXQiOjQ5fQ==",
        "node": {
          "title": "Melodic Techno - Sound Pack - Mirage",
          "handle": "melodic-techno-sound-pack-mirage",
          "createdAt": "2024-09-30T15:28:54Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "8 Project Files, 400+ Samples, 95 MIDIs, 70 Serum Presets"
          },
          "enhancedDescription": {
            "value": "Start your next track with this absolute killer pack including State of the art Melodic Techno sound with 8 fully arranged tracks as (educational) Ableton Project Files, 400+ Melodic Techno Samples, 75+ Serum Presets with inspiring MIDIs for each. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MelodicTechno-SoundPack-Mirage_PML341_v1.1_700x.png?v=1727710211"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Melodic_Techno_-_Find_Love_Ableton_11.1_and_Serum_v1.02.mp3?v=1728236792"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This is an absolute killer pack and deal! State of the art Melodic Techno sound with 8 fully arranged tracks as (educational) Ableton Project Files, 400+ Melodic Techno Samples, 75+ Serum Presets with inspiring MIDIs for each. Start your next track now!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTc2NDI4MzY4MTM5LCJsYXN0X3ZhbHVlIjo4OTc2NDI4MzY4MTM5LCJvZmZzZXQiOjM2fQ==",
        "node": {
          "title": "Melodic Techno - Sound Pack - Mystique",
          "handle": "melodic-techno-sound-pack-mystique",
          "createdAt": "2025-01-02T15:14:14Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "8 Project Files, 350+ Samples, 75 MIDIs, 75 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/MTMystiqueUpdated1_700x.png?v=1737649111"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Mystique-MT-DemoMix2.mp3?v=1736433287"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Dive into the powerful soundscapes of Melodic Techno. Includes 350+ Samples, 75+ Serum Presets and 75 MIDI files and 8 fully produced tracks as Ableton Projects."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5MDI1MzM2NTQxNDUxLCJsYXN0X3ZhbHVlIjo5MDI1MzM2NTQxNDUxLCJvZmZzZXQiOjMyfQ==",
        "node": {
          "title": "Minimal Melodic Techno - Sound Pack - Voyager",
          "handle": "minimal-melodic-techno-sound-pack-voyager",
          "createdAt": "2025-02-03T14:36:05Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "6 Project Files, 300+ Samples, 70 MIDIs, 70 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/VoyagerProductBox3_700x.png?v=1738675499"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Voyage_DJ_mix_Minimal_Melodic_Techno.mp3?v=1738592054"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Immerse yourself in the hypnotic vibes of Minimal Melodic Techno inspired by Boris Brejcha, NTO, Worakls, and more. Featuring 300+ Samples, 70+ Serum Presets, 70+ MIDI files, and 6 fully produced Ableton Project files."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDY5MjAyMTQ4NTgzNSwibGFzdF92YWx1ZSI6MTA2OTIwMjE0ODU4MzUsIm9mZnNldCI6MX0=",
        "node": {
          "title": "Organic House - Sound Pack - Woodlands",
          "handle": "organic-house-sound-pack-woodlands",
          "createdAt": "2025-09-01T19:01:23Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "8 Project Files, 500+ Samples,  77+ Serum 2 Presets 77+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Organic_House_Box_Woodlands_Sound_Pack_Edition_Gradient_Curve_700x.png?v=1756908464"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1756753382806.1487-Woodlands_SoundPack_DjMix.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Discover the Sound Pack Edition of Woodlands! Explore 8 Ableton projects, brand new sample library, and 70 Serum presets crafted for inspiration. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjU5Mjg1MjI5NjMzLCJsYXN0X3ZhbHVlIjo0NjU5Mjg1MjI5NjMzLCJvZmZzZXQiOjIyNX0=",
        "node": {
          "title": "Percussive Afro House - Full Ableton Production Suite",
          "handle": "percussive-afro-house",
          "createdAt": "2021-02-15T09:32:13Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "3 Project Files, 250+ Samples, 60 MIDIs, 100 Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/Afrohousenew_700x.png?v=1651610620"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PercussiveAfroHouse.mp3?v=1623661308"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Percussive Afro House Sound Pack for Ableton. This pack brings you closer to the sound of artists like Rampa, Dixon, Ame, Black Coffee or &me. The groovy loops and organic one shots will elevate static tracks and give them the rhythm and feel you might be missing."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTQzNTE4Mzg0Mzk1LCJsYXN0X3ZhbHVlIjo4OTQzNTE4Mzg0Mzk1LCJvZmZzZXQiOjQwfQ==",
        "node": {
          "title": "Progressive Melodic Techno - Sound Pack",
          "handle": "progressive-melodic-techno-sound-pack",
          "createdAt": "2024-12-11T15:22:32Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "5 Project Files, 2 Sample Packs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/prog-mel-tech1_700x.png?v=1734537520"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/ProgressiveMelodicTechnoSoundPack_DJMix.mp3?v=1733930345"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Deep and progressive Melodic Techno Ableton template collection. Download fully arranged, customizable, mastered project files. All samples and presets included!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjozOTU1NTU2Njc5NzQ1LCJsYXN0X3ZhbHVlIjozOTU1NTU2Njc5NzQ1LCJvZmZzZXQiOjI2OX0=",
        "node": {
          "title": "Sunset Vibes - Melodic House Sound Pack",
          "handle": "sunset-vibes-melodic-house-sound-pack",
          "createdAt": "2019-08-31T20:18:15Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "4 Project Files, 150+ Samples, 40 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/SunsetVibesBenBohmerPacknew2025_700x.png?v=1752840043"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1752679716912.9958-DJ_Mix_2_Sunset_Vibes.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Sunset Vibes captures the warm, emotional sound of Ben Böhmer with 8 full Ableton projects, 350+ samples, 30+ Serum 2 presets, and 90+ MIDI files – perfect for crafting deep, progressive tracks. Fully compatible with Serum 2."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDIyOTI1NzYwMTI5MSwibGFzdF92YWx1ZSI6MTAyMjkyNTc2MDEyOTEsIm9mZnNldCI6MTV9",
        "node": {
          "title": "Tech House - Sound Pack - Pulse",
          "handle": "tech-house-sound-pack-pulse",
          "createdAt": "2025-06-10T11:33:23Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "8 Project Files, 560+ Samples, 75 Serum Presets & Matching MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Box_700x.png?v=1749555368"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DJ_Mix_4.mp3?v=1749570161"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Tech House Sound Pack featuring 560+ samples, 75+ Serum presets,\nand 75+ MIDI files & 8 fully produced Ableton Project files to kickstart your creativity!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjkwODA1MDg4NTIzLCJsYXN0X3ZhbHVlIjo4MjkwODA1MDg4NTIzLCJvZmZzZXQiOjkzfQ==",
        "node": {
          "title": "Tech House Start to Finish - Bundle",
          "handle": "tech-house-start-to-finish-bundle",
          "createdAt": "2023-07-19T08:37:47Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "1 Start to Finish Masterclass, 10+ Ableton Project Files, 600+ Samples, Serum Presets, Midi and more."
          },
          "enhancedDescription": {
            "value": "Everything you need to produce festival-ready music. A full Start to Finish Masterclass, 600 samples, more than 80 presets with accompanying MIDI files and 10+ Ableton Templates to jump start your next track."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/TechHouseBundleStartToFinishPML2--3_700x.png?v=1689765503"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-TechHouse-2Drive_01_demo.mp3?v=1700590070"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This is the most complete program for Tech House on PML including a Start to Finish Masterclass, 600+ Tech House Samples, Serum Presets, MIDI and more!\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTQ1OTY3NTYzMDE5LCJsYXN0X3ZhbHVlIjo4OTQ1OTY3NTYzMDE5LCJvZmZzZXQiOjM5fQ==",
        "node": {
          "title": "Techno - Berlin - Sound Pack",
          "handle": "techno-berlin-2010s-sound-pack",
          "createdAt": "2024-12-12T09:22:31Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "5 Project Files, 1 Techno Kick Sample Pack"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/berlin_2010_700x.png?v=1734690171"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/TechnoBerlin2010s_DJ_Mix_Techno.mp3?v=1733934325"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional collection of dark, powerful Ableton Techno Project Files. Download fully arranged, mastered tracks inspired by Panorama Bar, Amelie Lens, and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDE4NzMzMTA0MzU5NSwibGFzdF92YWx1ZSI6MTAxODczMzEwNDM1OTUsIm9mZnNldCI6MTl9",
        "node": {
          "title": "Techno - Sound Pack - Energy",
          "handle": "techno-sound-pack-energy",
          "createdAt": "2025-05-19T15:52:04Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "8 Project Files, 540+ Samples, 90 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Techno-SoundPack-Energy_PML373_700x.png?v=1747670534"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Dj_Mix_Techno_Sound_Pack_V2.mp3?v=1750757601"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Techno Sound Pack featuring 540+ samples, 90+ Serum presets,\nand 90+ MIDI files & 8 fully produced Ableton Project files to kickstart your creativity!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDQ5MjkxNTUwOTg3LCJsYXN0X3ZhbHVlIjo4NDQ5MjkxNTUwOTg3LCJvZmZzZXQiOjc0fQ==",
        "node": {
          "title": "Techno Sound Pack - Antithesis",
          "handle": "antithesis-techno-sound-pack",
          "createdAt": "2024-01-29T15:31:06Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "2 Ableton Project Files, 50+ Samples, 30 Serum Presets, 30 MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-TechnoProductionPack-Antithesis_PML316_700x.png?v=1706542378"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Antithesis_-_Collection_Player.mp3?v=1706542410"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This sound pack includes everything you need to jump start your next Techno production. Get 2 Fully Produced Ableton project files, 50+ Samples, 30 MIDI Files, 30 Serum Presets, professionally produced for modern Techno!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzMyNzYxNzI3MjQzLCJsYXN0X3ZhbHVlIjo4MzMyNzYxNzI3MjQzLCJvZmZzZXQiOjg2fQ==",
        "node": {
          "title": "Techno Sound Pack - Overdrive",
          "handle": "techno-production-pack-overdrive",
          "createdAt": "2023-10-01T15:59:12Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "2hr Walkthrough Course, 10+ Ableton Templates, 40+ Serum Presets, 400+ Samples, 15+ MIDI Files"
          },
          "enhancedDescription": {
            "value": "Everything you need to jump start your next Techno production. Get a production course, 10 Fully Produced Ableton project files, 40+ Serum Presets, 400+ Samples professionally produced for modern Techno!"
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/TechnoProductionKitPML288B_700x.png?v=1696846518"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Techno_OD2_-_Mini_Mix.mp3?v=1696928176"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "With an album worth of Techno Ableton templates, samples, Serum Presets, and MIDI, this sound pack includes everything you need to jump start your next track."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4OTEzNzY4ODA4NzE1LCJsYXN0X3ZhbHVlIjo4OTEzNzY4ODA4NzE1LCJvZmZzZXQiOjQ0fQ==",
        "node": {
          "title": "Timeless Vol. 1 - Sound Pack - Electronic Classics",
          "handle": "timeless-vol-1-sound-pack-electronic-classics",
          "createdAt": "2024-11-22T10:52:39Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "5 Project Files, 360+ Samples, 20 MIDIs, 20 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-ElectronicClassics-SoundPack-TimelessVol.1_PML348_700x.png?v=1732286047"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/TimelessVol1_Snippet_V2.mp3?v=1732625129"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Create timeless electronic music with 5 fully arranged Ableton Project Files, 360+ premium samples, 20+ inspiring Serum presets + evocative MIDI! Let’s craft something unforgettable!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDY0NzkxMjkwNzAxOSwibGFzdF92YWx1ZSI6MTA2NDc5MTI5MDcwMTksIm9mZnNldCI6OH0=",
        "node": {
          "title": "Timeless Vol. 2 - Sound Pack - Electronic Classics",
          "handle": "timeless-vol-2-sound-pack-electronic-classics",
          "createdAt": "2025-07-23T12:21:09Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "8 Project Files, 490+ Samples, 100 MIDIs, 100 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Timless_Vol._2_-PML382_700x.png?v=1753802909"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1753282342589-DJ_Mix.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Step into the era of classics with 8 fully arranged Ableton Project Files, 490+ premium samples, 100+ inspiring Serum 2 presets, and inspiring MIDI! Everything you need to spark your next timeless masterpiece!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDY4NDg3MTA0OTQ4MywibGFzdF92YWx1ZSI6MTA2ODQ4NzEwNDk0ODMsIm9mZnNldCI6Mn0=",
        "node": {
          "title": "Trance & Hard Dance - Sound Pack - Supersonic",
          "handle": "trance-hard-dance-sound-pack",
          "createdAt": "2025-08-27T18:35:57Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "7 Project Files, 330+ Samples,  50+ Serum 2 Presets 50+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Trance_04_Supersonic_darkersat_700x.png?v=1756381990"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1756382137913-PML388_DjMix_V2.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Step into the euphoric world of Trance & Hard Dance with 7 fully arranged Ableton Project Files, 300+ high-energy loops & one-shots, 50+ cutting-edge Serum presets, and driving grooves that will light up any dancefloor. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5NzY4ODIxOTQ4NjgzLCJsYXN0X3ZhbHVlIjo5NzY4ODIxOTQ4NjgzLCJvZmZzZXQiOjI4fQ==",
        "node": {
          "title": "Trance - Sound Pack - Eternity",
          "handle": "trance-sound-pack-eternity",
          "createdAt": "2025-02-28T09:44:19Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "8 Project Files, 320+ Samples, 79 MIDIs, 79 Serum Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/TranceEternity_-7-7_700x.png?v=1740991363"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Trance_Dj_Mix_v2.mp3?v=1740996270"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Step into the euphoric world of Trance. Inspired by artists like Armin van Buuren, Above & Beyond, PUSH, Lange, Alessandra Roncone, Protoculture, David Forbes, Airbase and more. Packed with 320+ Samples, 75+ Serum presets, and 8 fully produced Ableton Project files to elevate your productions."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MTg1NTA5MjgyMDU5LCJsYXN0X3ZhbHVlIjo4MTg1NTA5MjgyMDU5LCJvZmZzZXQiOjExNX0=",
        "node": {
          "title": "UK House Sound Pack - Actual Life",
          "handle": "uk-house-actual-life",
          "createdAt": "2023-03-17T15:38:50Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "2 Ableton Project Files, 70+ Samples, 30 Serum Presets, 30 Midi"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-UKHouse_700x.png?v=1679069421"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Wait_For_The_Night_Again_Preview.mp3?v=1679073217"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Sound Pack With their unique styles and innovative sounds, producers like Fred Again, Skrillex and Four Tet are taking the UK House Scene by storm. Get two fully produced Ableton Project files where we've captured their essence, including Samples and Serum Presets to kick off your next production session."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzI4ODg5MzM2MDc1LCJsYXN0X3ZhbHVlIjo4MzI4ODg5MzM2MDc1LCJvZmZzZXQiOjg3fQ==",
        "node": {
          "title": "Ultra: Progressive House EDM Sound Pack",
          "handle": "ultra-progressive-house-edm-bundle",
          "createdAt": "2023-09-22T14:57:23Z",
          "pmlProductCategory": {
            "value": "samplePacks--styleGuide"
          },
          "catalogDescription": {
            "value": "11+ Ableton Templates, 105+ Serum Presets, 140+ Samples, 120+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Edm-ultra-chat_test_700x.png?v=1752059863"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Ultra_EDM_-_DEMOCollection.mp3?v=1695807457"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "With an album worth of EDM / Progressive House Ableton templates, samples, Serum Presets, and MIDI, this sound pack includes everything you need to jump start your next track."
          }
        }
      }
    ]
  },
  "legacy": {
    "samplePacks": [
      {
        "cursor": "eyJsYXN0X2lkIjo4MDgzNzI4ODkyMTcxLCJsYXN0X3ZhbHVlIjo4MDgzNzI4ODkyMTcxLCJvZmZzZXQiOjEyMX0=",
        "node": {
          "title": "Artist Kicks Vol. 2 by Bound to Divide",
          "handle": "artist-kicks-vol-2-by-bound-to-divide",
          "createdAt": "2023-01-13T11:35:51Z",
          "pmlProductCategory": {
            "value": "legacy--samplePacks"
          },
          "catalogDescription": {
            "value": "20+ Perfectly recreated artist kicks"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-BoundToDivide-ArtistKicksVol.2_700x.png?v=1673626761"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/BoundToDivide_Vocal_LaurenL.mp3?v=1674738134"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "21 Meticulously Crafted Kick samples inspired by famous Organic House tracks."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzQ3MDUxNzg2MzA1LCJsYXN0X3ZhbHVlIjo2NzQ3MDUxNzg2MzA1LCJvZmZzZXQiOjE4MX0=",
        "node": {
          "title": "Artist Kicks by Bound to Divide",
          "handle": "artist-kicks-by-bound-to-divide",
          "createdAt": "2022-02-14T09:31:45Z",
          "pmlProductCategory": {
            "value": "legacy--samplePacks"
          },
          "catalogDescription": {
            "value": "15+ Perfectly recreated artist kicks"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/Kicks_700x.png?v=1645021543"
          },
          "music": null,
          "musicPersists": {
            "value": "0"
          },
          "seo": {
            "description": "15 Meticulously Crafted Kick samples based on some of the biggest tracks in Melodic House and Techno today."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDgzNzI0MjM5MTE1LCJsYXN0X3ZhbHVlIjo4MDgzNzI0MjM5MTE1LCJvZmZzZXQiOjEyNH0=",
        "node": {
          "title": "PML - Bound to Divide - Lauren L'aimant Vocal Hooks",
          "handle": "pml-bound-to-divide-laurent-laiment-vocal-hooks",
          "createdAt": "2023-01-13T11:31:03Z",
          "pmlProductCategory": {
            "value": "legacy--samplePacks"
          },
          "catalogDescription": {
            "value": "395 Vocal Samples Dry and Wet"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/laurenlaimant_vocals_700x.png?v=1675171252"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Lauren_L_aimant_-_Vocal_Hooks_Demo.mp3?v=1674740455"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Get nearly 400 vocal samples by Lauren L'aimant, produced by Bound to Divide. Royalty-Free and ready-to-use in your next production!"
          }
        }
      }
    ],
    "presetPacks": [
      {
        "cursor": "eyJsYXN0X2lkIjo4MDgzNzI4MjY5NTc5LCJsYXN0X3ZhbHVlIjo4MDgzNzI4MjY5NTc5LCJvZmZzZXQiOjEyMn0=",
        "node": {
          "title": "Bass Lab - Serum Bass Presets by Bound to Divide",
          "handle": "bass-lab-serum-bass-presets-by-bound-to-divide",
          "createdAt": "2023-01-13T11:34:58Z",
          "pmlProductCategory": {
            "value": "legacy--presetPacks"
          },
          "catalogDescription": {
            "value": "64 Serum Bass Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-BoundToDivide-BassLab_700x.png?v=1673626643"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Dreams_-_Melodic_House_Techno_Presets_for_Serum_01.mp3?v=1645027040"
          },
          "musicPersists": {
            "value": "0"
          },
          "seo": {
            "description": "Serum Preset Pack for Melodic House and Techno. Pack designed by Bound to Divide."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjY2MzQ5MjQ4Nzc5LCJsYXN0X3ZhbHVlIjo4MjY2MzQ5MjQ4Nzc5LCJvZmZzZXQiOjk5fQ==",
        "node": {
          "title": "Diva Presets Collection Vol.2",
          "handle": "diva-preset-bundle-vol-2",
          "createdAt": "2023-06-13T12:10:20Z",
          "pmlProductCategory": {
            "value": "legacy--presetPacks"
          },
          "catalogDescription": {
            "value": "500+ Diva Presets, 500+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/diva_bundle2-3_700x.png?v=1694514502"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Diva_Bundle_V2_Demo_01.mp3?v=1686668350"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "From 7+ Professional Packs get 500+ Diva Presets produced by house and melodic techno artists made for Organic, Melodic, Deep, House, Techno and Underground and more. 500+ MIDI files, ready-to-use, and tailor-made for these presets. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzQ1MjE5NDMyNTEzLCJsYXN0X3ZhbHVlIjo2NzQ1MjE5NDMyNTEzLCJvZmZzZXQiOjE4M30=",
        "node": {
          "title": "Dreams - Melodic House Serum Presets by Bound to Divide",
          "handle": "dreams-melodic-house-serum-presets-by-bound-to-divide",
          "createdAt": "2022-02-11T14:13:27Z",
          "pmlProductCategory": {
            "value": "legacy--presetPacks"
          },
          "catalogDescription": {
            "value": "79 Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/dreams_700x.png?v=1645023237"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Dreams_-_Melodic_House_Techno_Presets_for_Serum_01.mp3?v=1645027040"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Serum Preset Pack for Melodic House and Techno. Pack designed by Bound to Divide."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDgzNzI3NDE3NjExLCJsYXN0X3ZhbHVlIjo4MDgzNzI3NDE3NjExLCJvZmZzZXQiOjEyM30=",
        "node": {
          "title": "Dreams Vol. 2 - Melodic House & Techno Serum Presets by Bound to Divide",
          "handle": "dreams-vol-2-melodic-house-techno-serum-presets-by-bound-to-divide",
          "createdAt": "2023-01-13T11:34:15Z",
          "pmlProductCategory": {
            "value": "legacy--presetPacks"
          },
          "catalogDescription": {
            "value": "124 Serum Presets, 91 Midis, 93 Melodic Loops (WAVE Files)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-BoundToDivide-DreamsVol.2_700x.png?v=1673626551"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Dreams_-_Melodic_House_Techno_Presets_for_Serum_01.mp3?v=1645027040"
          },
          "musicPersists": {
            "value": "0"
          },
          "seo": {
            "description": "Serum Preset Pack for Melodic House and Techno. Pack designed by Bound to Divide."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzQ0NTE3NzM4NTYxLCJsYXN0X3ZhbHVlIjo2NzQ0NTE3NzM4NTYxLCJvZmZzZXQiOjE4NH0=",
        "node": {
          "title": "Purity - Melodic House Serum Presets by Bound to Divide",
          "handle": "purity-melodic-house-serum-presets-by-bound-to-divide",
          "createdAt": "2022-02-10T13:03:12Z",
          "pmlProductCategory": {
            "value": "legacy--presetPacks"
          },
          "catalogDescription": {
            "value": "84 Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/purity_700x.png?v=1645023239"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Purity_-_Melodic_House_Techno_Presets_for_Serum_01.mp3?v=1645027040"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Serum Preset Pack for Melodic House and Techno in the style of Purified. Pack designed by Bound to Divide and CallumCantSleep."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzIyMjQ0OTY4NzE1LCJsYXN0X3ZhbHVlIjo4MzIyMjQ0OTY4NzE1LCJvZmZzZXQiOjg5fQ==",
        "node": {
          "title": "Serum Presets Collection Vol. 2",
          "handle": "serum-presets-collection-vol-2",
          "createdAt": "2023-09-11T10:27:49Z",
          "pmlProductCategory": {
            "value": "legacy--presetPacks"
          },
          "catalogDescription": {
            "value": "765+ Serum Presets, 495+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-SerumPresetCollectionVol.2_700x.png?v=1694428127"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/SerumTechnoVol3Playbutton.mp3?v=1693583716"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "From 11+ Packs get 765+ Serum Presets produced by melodic techno and house artists made for Melodic, Deep, House, Techno and Underground music. 495+ MIDI files, ready-to-use, and tailor made for these presets. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzQ1MzMxMDA3NTUzLCJsYXN0X3ZhbHVlIjo2NzQ1MzMxMDA3NTUzLCJvZmZzZXQiOjE4Mn0=",
        "node": {
          "title": "Visions - Melodic House Diva Presets by Bound to Divide",
          "handle": "visions-melodic-house-diva-presets-by-bound-to-divide",
          "createdAt": "2022-02-11T16:53:32Z",
          "pmlProductCategory": {
            "value": "legacy--presetPacks"
          },
          "catalogDescription": {
            "value": "85 Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/visions_700x.png?v=1645023224"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/VISIONS_-_Melodic_House_Techno_presets_for_Diva_01.mp3?v=1645027040"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Diva Preset Pack for Melodic House and Techno. Presets designed by Bound to Divide."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzQ0NDg5NTU4MDgxLCJsYXN0X3ZhbHVlIjo2NzQ0NDg5NTU4MDgxLCJvZmZzZXQiOjE4NX0=",
        "node": {
          "title": "Vital Presets for Melodic House and Techno",
          "handle": "melodic-house-for-vital",
          "createdAt": "2022-02-10T12:15:42Z",
          "pmlProductCategory": {
            "value": "legacy--presetPacks"
          },
          "catalogDescription": {
            "value": "60+ Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/VitalpresetPack-melodichouseandtechno-oceans_700x.png?v=1645023288"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Oceans_-_Melodic_House_Techno_Presets_For_Vital_01.mp3?v=1645027041"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Vital Preset Pack for Melodic House and Techno in the style of Anjuna. Pack designed by Bound to Divide."
          }
        }
      }
    ],
    "template-house": [
      {
        "cursor": "eyJsYXN0X2lkIjo2Nzg2MDIzMDYzNjE3LCJsYXN0X3ZhbHVlIjo2Nzg2MDIzMDYzNjE3LCJvZmZzZXQiOjE2OH0=",
        "node": {
          "title": "Classic Soulful House - Touch - Ableton Project File",
          "handle": "touch-classic-house-ableton-project-file",
          "createdAt": "2022-04-13T15:10:15Z",
          "pmlProductCategory": {
            "value": "legacy--template-house"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/7.1touch_700x.png?v=1649945352"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Touch_01_demopage_d3874d8f-3793-413c-9988-959aff2b14b7.mp3?v=1649864064"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Download Classic House template designed for Ableton Live 10 incl. MIDI, presets, drum samples."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjozOTUwMzEwODUwNjI1LCJsYXN0X3ZhbHVlIjozOTUwMzEwODUwNjI1LCJvZmZzZXQiOjI3M30=",
        "node": {
          "title": "Sun Vibes - Melodic House Ableton Template",
          "handle": "anjuna-vibes-melodic-house-ableton-template",
          "createdAt": "2019-08-20T11:15:51Z",
          "pmlProductCategory": {
            "value": "legacy--template-house"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/SunVibesTempPng_700x.png?v=1615394338"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/2019_PML_-_Anjuna_Vibes_pre.mp3?3039"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Melodic Deep House Template (Ableton Live 10). Download fully arranged mastered project file in the style of Rodriguez Jr. and Ben Bohmer."
          }
        }
      }
    ],
    "midiPacks": [
      {
        "cursor": "eyJsYXN0X2lkIjo4MDA5NDc3MjI2NzYzLCJsYXN0X3ZhbHVlIjo4MDA5NDc3MjI2NzYzLCJvZmZzZXQiOjEzOX0=",
        "node": {
          "title": "MIDI Pack Melodic House - Inner Lights",
          "handle": "inner-lights-melodic-house-midi-pack-vol-1",
          "createdAt": "2022-10-10T10:09:44Z",
          "pmlProductCategory": {
            "value": "legacy--midiPacks"
          },
          "catalogDescription": {
            "value": "130+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PACK_258_MIDI_Mel-House_700x.png?v=1665483701"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/InnerLights-MelodicHouse-Midi_Demo.mp3?v=1665411576"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Melodic House MIDI Pack featuring more than 135+ quality MIDI files created for writing warm, deep and moody tracks.\nSave valuable production time and get inspired with these ready to use arpeggios, progressions, leads and bass midis designed at 120-126 bpm."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjI5MDU5MTY2NDc1LCJsYXN0X3ZhbHVlIjo4MjI5MDU5MTY2NDc1LCJvZmZzZXQiOjEwOX0=",
        "node": {
          "title": "MIDI Pack Melodic House Vol. 2 - White Glow",
          "handle": "midi-pack-melodic-house-white-glow",
          "createdAt": "2023-04-25T17:09:42Z",
          "pmlProductCategory": {
            "value": "legacy--midiPacks"
          },
          "catalogDescription": {
            "value": "100+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_MidiPack_MelodicHouseVol2_700x.png?v=1682442750"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Midi-Pack2-DJMix_MidiPack_WhiteGlowV2.mp3?v=1682507591"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Melodic House MIDI Pack featuring more than 100+ quality MIDI files created for writing warm, deep and moody tracks.\nSave valuable production time and get inspired with these ready to use arpeggios, progressions, leads and bass midis designed at 120-126 bpm."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNDM4MzYzODQ0NjczLCJsYXN0X3ZhbHVlIjoxNDM4MzYzODQ0NjczLCJvZmZzZXQiOjMyNn0=",
        "node": {
          "title": "Melodic Techno MIDI Pack (Melodies, Arpeggios (Arps), Plucks and more)",
          "handle": "melodic-techno-midi-pack-melodies-arpeggios-arps-plucks-and-more",
          "createdAt": "2018-08-10T15:12:40Z",
          "pmlProductCategory": {
            "value": "legacy--midiPacks"
          },
          "catalogDescription": {
            "value": "100+ MIDI FIles"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PACK_230_MIDI_Mel-Techno_700x.png?v=1665410493"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Melodic_Techno_Midi_Pre.mp3?3052"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Techno MIDI Files Pack - Chord Progressions, Melodies, Amazing Arpeggios, Leads ready to use in your own productions. Download 100+ Midi Files."
          }
        }
      }
    ]
  },
  "presetPack": {
    "other": [
      {
        "cursor": "eyJsYXN0X2lkIjo5NzU4NDYxOTA2LCJsYXN0X3ZhbHVlIjo5NzU4NDYxOTA2LCJvZmZzZXQiOjM2MX0=",
        "node": {
          "title": "Arturia Mini V3 Sound Pack - Melodic Techno",
          "handle": "melodic-techno-arturia-mini-v3-sound-pack",
          "createdAt": "2017-06-13T10:43:36Z",
          "pmlProductCategory": {
            "value": "presetPack--other"
          },
          "catalogDescription": {
            "value": "100+ Presets, 100+ MIDIs + Samples, 8 Beat Kits"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/16arturiapresets_700x.png?v=1652714919"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_SoundPack_MTArturia.mp3?8348326358963473875"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Berlin Melodic Techno Sound Pack for Arturia Mini: Presets, MIDIs, Samples and Construction Kits in underground style of adriatique, maceo plex, stephan bodzin."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTQ2NjU1NTEwNTkzLCJsYXN0X3ZhbHVlIjo2NTQ2NjU1NTEwNTkzLCJvZmZzZXQiOjIxOH0=",
        "node": {
          "title": "Deep Sounds - Ableton Wavetable Preset Pack",
          "handle": "deep-sounds-ableton-wavetable-preset-pack",
          "createdAt": "2021-04-08T12:30:18Z",
          "pmlProductCategory": {
            "value": "presetPack--other"
          },
          "catalogDescription": {
            "value": "65+ Presets, 65+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/deepsounds_wavetablepresets_700x.png?v=1648819824"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DeepSoundAbletonWaveTableDemo.mp3?v=1623420796"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Beautifully Crafted Sounds for Ableton Wavetable 2 Full New Ableton Project Files, Custom Diva Presets, Samples, Midi and More!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjozOTMxMzQ4OTkyMDY1LCJsYXN0X3ZhbHVlIjozOTMxMzQ4OTkyMDY1LCJvZmZzZXQiOjI4MH0=",
        "node": {
          "title": "MASSIVE X Techno Pack",
          "handle": "massive-x-techno-pack",
          "createdAt": "2019-07-17T20:37:18Z",
          "pmlProductCategory": {
            "value": "presetPack--other"
          },
          "catalogDescription": {
            "value": "60 Presets, 130+ Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/15technomassivex_700x.png?v=1652714883"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Plurality_preview128.mp3?2994"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A brilliant Techno Sound Pack with 60 presets for MASSIVE X, 80 Loops and 55 Melodic One Shots, inspired by the style of labels like Drumcode, Tronic, Kompakt Extra, Hotflush Recordings. Royalty free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTQyOTkwMzQ0MjU3LCJsYXN0X3ZhbHVlIjo2NTQyOTkwMzQ0MjU3LCJvZmZzZXQiOjIyMH0=",
        "node": {
          "title": "Pigments Preset Pack -  by Tim Engelhardt",
          "handle": "pigments-preset-pack-deep-progressive-by-tim-engelhardt",
          "createdAt": "2021-03-23T10:07:44Z",
          "pmlProductCategory": {
            "value": "presetPack--other"
          },
          "catalogDescription": {
            "value": "120+ Presets, 1 Ableton Project File"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/18_pigments_700x.png?v=1652715046"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PigmentsPresetsTimEngelhardt.mp3?v=1623420412"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Pigments Preset Pack - Deep & Progressive by Tim Engelhardt\nOver 100 presets for Pigments 2 and 25 outstanding presets for the brand new update Pigments 3 - push the boundaries of modern sound design! BONUS: Template File produced by Tim Engelhardt using Pigments for Drums, Bass, Pads, Leads and more"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTcwODg2OTIyMzA1LCJsYXN0X3ZhbHVlIjo2NTcwODg2OTIyMzA1LCJvZmZzZXQiOjIwOH0=",
        "node": {
          "title": "Repro-5 Preset Pack - Analog & Melodic",
          "handle": "repro-5-preset-pack-analog-melodic",
          "createdAt": "2021-06-30T09:26:31Z",
          "pmlProductCategory": {
            "value": "presetPack--other"
          },
          "catalogDescription": {
            "value": "120+ Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/7repro_700x.png?v=1652362890"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Demo_Track_Repro-5.mp3?v=1636736261"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A ready to use selection of warm & analog sounding presets for Repro-5 inspired by the style of labels like Afterlife, Steyoyoke or Anjunadeep and artists like Tale of Us, Stefan Bodzin and Lane 8. These presets where created by Tim Engelhardt in the past months, while working on new Melodic Techno material."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoyNzUwNTkyMDA1LCJsYXN0X3ZhbHVlIjoyNzUwNTkyMDA1LCJvZmZzZXQiOjQzOX0=",
        "node": {
          "title": "SYLENTH1 Presets Vol. 1: Melodic Ultra",
          "handle": "sylenth1-presets-vol-1-pml-future-essentials",
          "createdAt": "2015-11-06T00:10:35Z",
          "pmlProductCategory": {
            "value": "presetPack--other"
          },
          "catalogDescription": {
            "value": "85+ Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/22_sylenth_presets_700x.png?v=1652786224"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/pml_pre_presets_sylenths_futurebass.mp3?11772813035781691771"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Download Melodic Ultra, Future Essentials x Future Bass and Future House 75+ presets designed for Sylenth1 2.2.1x (and higher). "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzM0NjkyMDg5OTIxLCJsYXN0X3ZhbHVlIjo2NzM0NjkyMDg5OTIxLCJvZmZzZXQiOjE4OX0=",
        "node": {
          "title": "Sub 37 - Soundbank for Techno",
          "handle": "sub-37-techno-presets",
          "createdAt": "2022-01-26T12:29:46Z",
          "pmlProductCategory": {
            "value": "presetPack--other"
          },
          "catalogDescription": {
            "value": "100+ Presets, 100+ MIDIs, 200 Samples"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/sub-37-2-warm_700x.png?v=1645024261"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Demo_coll_MS37_Techno_Sound_Bank_Demo_Track_1__01.mp3?v=1645807916"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Moog Sub37 and Subsequent 37 Presets crafted for expressive sound and instant inspiration. Audio / MIDI available for anyone wanting to add true analog warmth to their tracks!"
          }
        }
      }
    ],
    "diva": [
      {
        "cursor": "eyJsYXN0X2lkIjozNDk1MjAyMTkzNDczLCJsYXN0X3ZhbHVlIjozNDk1MjAyMTkzNDczLCJvZmZzZXQiOjI4NX0=",
        "node": {
          "title": "Cercle Sounds - Diva Preset Pack for Melodic House + Techno",
          "handle": "melodic-techno-diva-preset-pack",
          "createdAt": "2019-04-30T09:10:04Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/cercle-1_700x.png?v=1673522558"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/pml_diva_presets_track_demo1.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Berlin Melodic Techno Sound Pack for U-He Diva DMT: Presets, MIDIs, Samples and Loops in underground style of adriatique, maceo plex, stephan bodzin. Royalty Free!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NTI4ODI4NTE0MzY5LCJsYXN0X3ZhbHVlIjo0NTI4ODI4NTE0MzY5LCJvZmZzZXQiOjI1Mn0=",
        "node": {
          "title": "Cercle Sounds Vol 2 - Diva Preset Pack for Techno",
          "handle": "cercle-sounds-vol-2-diva-preset-pack-for-techno",
          "createdAt": "2020-06-30T13:30:55Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/cercle-2_700x.png?v=1673522578"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DivaCercleVol2_demo.mp3?v=1623751767"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "100+ Diva Presets, Midi files, and Samples crafted over months by professional producers. Download royalty free audio, midi, and Diva Presets inspired by Cercle, Berlin clubs & labels and Fabric & Boiler Room Dj sets. State-of-the-art sound."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDU2MzE4MDM0MTg3LCJsYXN0X3ZhbHVlIjo4MDU2MzE4MDM0MTg3LCJvZmZzZXQiOjEyOH0=",
        "node": {
          "title": "Cercle Sounds Vol 3 - Diva Preset Pack for Techno and Melodic House",
          "handle": "cercle-sounds-vol-3-diva-preset-pack-for-techno",
          "createdAt": "2022-12-21T15:07:40Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-CercleVol.3_700x.png?v=1671635329"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Cercle3Demo.mp3?v=1671636875"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "100+ Diva Presets, Midi files, and Samples crafted over months by professional producers. Download royalty free audio, midi, and Diva Presets inspired by Cercle, Berlin clubs & labels and Fabric & Boiler Room Dj sets. State-of-the-art sound."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4ODEwMDc4MjA4MjY3LCJsYXN0X3ZhbHVlIjo4ODEwMDc4MjA4MjY3LCJvZmZzZXQiOjUyfQ==",
        "node": {
          "title": "Cercle Sounds Vol 4 - Diva Preset Pack for Techno and Melodic House",
          "handle": "cercle-sounds-vol-4-diva-preset-pack",
          "createdAt": "2024-09-09T13:13:35Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDIs, 100 Wavs"
          },
          "enhancedDescription": {
            "value": "The series returns with 100+ state-of-the art Diva Presets, Midi files, and samples crafted by legendary Melodic Techno, Techno and House sound designer João Apell inspired by Cercle, Berlin clubs & labels and Fabric & Boiler Room Dj sets."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-DivaPresets-CercleVol.4_PML340_700x.png?v=1725887768"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Cercle4Demo.mp3?v=1725963938"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "100+ Diva Presets, Midi files, and Samples crafted over months by professional producers. Download royalty free audio, midi, and Diva Presets inspired by Cercle, Berlin clubs & labels and Fabric & Boiler Room Dj sets. State-of-the-art sound."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjE2NzUwMDM5MTA1LCJsYXN0X3ZhbHVlIjo0NjE2NzUwMDM5MTA1LCJvZmZzZXQiOjIzNX0=",
        "node": {
          "title": "Diva Preset Pack - Melodic House by Bound To Divide",
          "handle": "bound-to-divide-diva-preset-pack-for-melodic-house",
          "createdAt": "2020-11-17T19:04:38Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "77 Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/19_diva_btd_700x.png?v=1652794793"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/MelodicHouseDivaPackDemo.mp3?v=1623665586"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Diva Preset Pack for Melodic House and Techno in the style of Anjuna. Pack designed by Bound to Divide."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTUwMTE1OTc1MjMzLCJsYXN0X3ZhbHVlIjo2NTUwMTE1OTc1MjMzLCJvZmZzZXQiOjIxNn0=",
        "node": {
          "title": "Diva Preset Pack - Melodics by Tim Engelhardt",
          "handle": "diva-presets-by-tim-engelhardt",
          "createdAt": "2021-04-21T10:22:58Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "95 Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/17timmelodicsdiva_700x.png?v=1652714961"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DivaPresetPack_MelodicsByTimEngelHardt.mp3?v=1623751150"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Techno Production preset pack created by Tim Engelhardt exclusively for Production Music Live. With this 95 presets strong pack you can dive deep into not only his sounds, but also deconstruct his elaborate sound designing techniques in u-he's DIVA VST synth."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDQ3Nzk2MjQ2MTQ1MSwibGFzdF92YWx1ZSI6MTA0Nzc5NjI0NjE0NTEsIm9mZnNldCI6MTN9",
        "node": {
          "title": "Diva Presets - Deep Melodics Vol.1",
          "handle": "diva-presets-deep-melodics-vol-1",
          "createdAt": "2025-06-17T13:39:51Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "110+ Presets, 110+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Deep_Melodics_Vol_1_-_Diva_Presets_PML294D_700x.png?v=1750168390"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Diva_Bundle_V2_Demo_01.mp3?v=1686668350"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "110+ analog-style Diva presets and MIDI files inspired by Ben Böhmer, Rüfüs du Sol, Bodzin, Tim Engelhardt, Adriatique, Rezident & more. Emotive leads, warm basses, lush keys, and beautiful plucks"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDQ3Nzg3OTY1NjcxNSwibGFzdF92YWx1ZSI6MTA0Nzc4Nzk2NTY3MTUsIm9mZnNldCI6MTR9",
        "node": {
          "title": "Diva Presets - Deep Melodics Vol.2",
          "handle": "diva-presets-deep-melodics-vol-2",
          "createdAt": "2025-06-17T12:18:57Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "110+ Presets, 110+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Deep_Melodics_Vol._2_-_Diva_Presets_PML378_700x.png?v=1750163127"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/DJ_MIX_Deep_Melodics_Vol_2.mp3?v=1750168688"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "110+ analog-style Diva presets and MIDI files inspired by Ben Böhmer, Rüfüs du Sol, Bodzin, Tim Engelhardt, Adriatique, Rezident & more. Emotive leads, warm basses, lush keys, and beautiful plucks."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzM5OTYwNzkxMTA1LCJsYXN0X3ZhbHVlIjo2NzM5OTYwNzkxMTA1LCJvZmZzZXQiOjE4N30=",
        "node": {
          "title": "Melodic & Organic Diva Presets by Felix Raphael",
          "handle": "organic-melodic-diva-presets-by-felix-raphael",
          "createdAt": "2022-02-03T10:30:38Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "120 Presets, 120 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/felix-diva-presets-4_700x.png?v=1643919570"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/FelixRaphael-DivaPresets-OrganicMelodic-Demo.mp3?v=1643884864"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "These natural sounding Diva presets help you make your arps, leads, pads and bass lines come to life! Over 120 presets + MIDI for Organic & Melodic House."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4Mjc2NjE5NjkwMjUxLCJsYXN0X3ZhbHVlIjo4Mjc2NjE5NjkwMjUxLCJvZmZzZXQiOjk4fQ==",
        "node": {
          "title": "Melodic Techno and Trance - Diva Presets by Aiyn Zahev",
          "handle": "melodic-techno-and-trance-diva-presets-by-aiyn-zahev",
          "createdAt": "2023-06-27T10:29:44Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "130+ Presets, 130+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Diva_Presets_-_Melodic_Techno_Trance_Vol._1_700x.png?v=1708951964"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Preview_Tracks_Final.mp3?v=1687869026"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "130+ Diva Presets and Midi files crafted by sound designer Aiyn Zahev. Download royalty free midi and Diva presets made for Melodic Techno and Trance. State-of-the-art sound."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDgzMzY4NDY4NzQ3LCJsYXN0X3ZhbHVlIjo4NDgzMzY4NDY4NzQ3LCJvZmZzZXQiOjcwfQ==",
        "node": {
          "title": "Melodic Techno and Trance - Diva Presets by Aiyn Zahev Vol.2",
          "handle": "melodic-techno-and-trance-diva-presets-by-aiyn-zahev-vol-2",
          "createdAt": "2024-02-26T12:42:06Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "120+ Presets, 120+ MIDIs"
          },
          "enhancedDescription": {
            "value": "Legendary sound designer Aiyn Zahev takes you on a journey to the analog and digital side of Diva: 120+ Deep basses, FM/Cross-mod, massive leads, dreamy plucks, modulated arps, mesmerizing pads, gnarly stabs and sequences including midi files for each sound. "
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-DivaPresets-MelodicTechno_TranceVol.2_700x.png?v=1708951774"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/MelodicTechnoTranceVol2.mp3?v=1708951416"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "120+ Diva Presets and Midi files crafted by sound designer Aiyn Zahev. Download royalty free midi and Diva presets made for Melodic Techno and Trance. State-of-the-art sound."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MjY2MjM2NjU3OTMxLCJsYXN0X3ZhbHVlIjo4MjY2MjM2NjU3OTMxLCJvZmZzZXQiOjEwMH0=",
        "node": {
          "title": "Organic House - Diva Presets by Yannek Maunz",
          "handle": "organic-house-diva-presets-by-yannek-maunz",
          "createdAt": "2023-06-13T09:32:48Z",
          "pmlProductCategory": {
            "value": "presetPack--diva"
          },
          "catalogDescription": {
            "value": "80 Presets, 80 MIDIs"
          },
          "enhancedDescription": {
            "value": "Brought to you by Yannek Maunz, 80+ Diva presets are carefully crafted to add an unmistakably organic quality to your mix. Access buttery basses, creamy plucks, and gritty leads to get your sound to the next level. Each preset comes with a corresponding MIDI to kickstart your next session."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Organic_House_Diva_Presetsred1_700x.png?v=1686663375"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/organic_house_diva_byyannek.mp3?v=1686750000"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "80+ Diva Presets and Midi files crafted by artist/producer Yannek Maunz. Download royalty free midi and Diva presets made to sound warm and organic. State-of-the-art sound."
          }
        }
      }
    ],
    "serum": [
      {
        "cursor": "eyJsYXN0X2lkIjo4MDEwMTgxNDExMDgzLCJsYXN0X3ZhbHVlIjo4MDEwMTgxNDExMDgzLCJvZmZzZXQiOjEzOH0=",
        "node": {
          "title": "Dimensions - Serum Presets: Melodic Techno Vol.2",
          "handle": "dimensions-serum-presets-melodic-techno-vol-2",
          "createdAt": "2022-10-13T13:28:26Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100+ Serum Presets, 100+ MIDI Files, 100+ WAV Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/serumpresetsdimensionsmelodictechnopmlbright_700x.png?v=1665694296"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Dimensions_Serum-MT2.mp3?v=1665674577"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "100+ Professionally Crafted Serum Presets, 100+ MIDI Files and 100+ WAV Files (One for each preset, 100% Royalty-Free) inspired sound of artists like Massano, Innellea, Cassian, Fideles, Yubik, Boris Brejcha, Koman, Bodzin, Tinlicker, Ben Bohmer and labels such as Afterlife and Radikon."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0MzkxNzgwMjg2NTI5LCJsYXN0X3ZhbHVlIjo0MzkxNzgwMjg2NTI5LCJvZmZzZXQiOjI1OX0=",
        "node": {
          "title": "SERUM Presets: Techno",
          "handle": "serum-presets-techno",
          "createdAt": "2020-02-02T16:29:59Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/techno-vol-1_700x.png?v=1742469983"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_STP_-_cut_Demo_Track.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Berlin Techno Sound Pack for Serum: Presets and MIDIs in underground style of Labels like Afterlife, Drumcode, Systematic, Outta Limits, 1605 an Artists like Spektre, Woo York, Tale Of Us, Pan-Pot, Stan Kolev, Matan Caspi and Umek among others. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDY2NzA2MzIxNDM0NywibGFzdF92YWx1ZSI6MTA2NjcwNjMyMTQzNDcsIm9mZnNldCI6M30=",
        "node": {
          "title": "Serum 2 - Afro House Presets",
          "handle": "serum-2-afro-house-presets",
          "createdAt": "2025-08-11T15:48:51Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "70 Serum2 Presets, 70 MIDIs, 70 Audio Previews"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/image2_f74a60f4-f4f7-46c2-8250-f992274bc4cd_700x.png?v=1754930114"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1754927460474.6316-AfroHouseSerum2_DJ_Mix.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "This powerful preset pack by Cape Town producer Pierre Johnson brings you 70+ Afro House-ready Serum 2 presets with textured basses, soulful plucks, colorful keys, and organic leads. Paired with matching MIDI and full support for Serum 2’s new features."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDU4Nzc4NDg3MjIwMywibGFzdF92YWx1ZSI6MTA1ODc3ODQ4NzIyMDMsIm9mZnNldCI6OX0=",
        "node": {
          "title": "Serum 2 - Melodic Progressive Presets",
          "handle": "serum-2-melodic-progressive-presets",
          "createdAt": "2025-07-08T09:50:45Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100 Serum2 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML381_Serum2_Box_Logo_700x.png?v=1752578148"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1751973585711.1826-PML381_DemoMix_v1.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Progressive by Jack Willard brings you 100+ deep, emotional Serum 2 presets inspired by artists like Ben Böhmer and Sébastien Léger. Including  matching MIDI files, audio previews, and full support for Serum 2’s powerful new features."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDEzMzEwNDkxODc5NSwibGFzdF92YWx1ZSI6MTAxMzMxMDQ5MTg3OTUsIm9mZnNldCI6MjJ9",
        "node": {
          "title": "Serum 2 - Techno Presets",
          "handle": "serum-2-techno-presets",
          "createdAt": "2025-04-14T15:03:44Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100 Serum2 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Serum2-Techno_700x.png?v=1744643455"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Serum_2_-_Techno_-_Demo_Track.mp3?v=1744645405"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Techno Sound Pack for Serum 2: Presets and MIDIs in the style of artists like  Space92, Enrico Sangiuliano, Jay Lumen, Elevn, TH;EN,  and many more."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDA5MjI4MzIzMjUyMywibGFzdF92YWx1ZSI6MTAwOTIyODMyMzI1MjMsIm9mZnNldCI6MjZ9",
        "node": {
          "title": "Serum 2 Presets - Feelings Vol.2",
          "handle": "serum-2-presets-feelings-2",
          "createdAt": "2025-03-23T11:50:57Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100 Serum2 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/feelings-2-updated_99e00887-c0c8-4efd-b49d-3515f5668dd8_700x.png?v=1746542427"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Serum2-Feelings2-DEMO2.mp3?v=1746544303"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic House Pack for Serum: Presets and MIDIs. Inspired by artists & labels like Ben Böhmer, Tinlicker, Anjunadeep, Colorize, Armada Music, and Selected."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzY2NzQ4ODkzNDUxLCJsYXN0X3ZhbHVlIjo4MzY2NzQ4ODkzNDUxLCJvZmZzZXQiOjgyfQ==",
        "node": {
          "title": "Serum Modern Melodic Techno Presets",
          "handle": "serum-modern-melodic-techno-presets",
          "createdAt": "2023-11-13T15:52:42Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/modern-melodic-techno-serum-presets_700x.png?v=1742469396"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/ModernSerumPresets_Snippet.mp3?v=1699968705"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Techno Sound Pack for Serum: Presets and MIDIs in the style of artists like Olivier Giacomotto, Final Request, Fur Coat, Jos & Eli and many more."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NjE0NDM5NjI0NzY5LCJsYXN0X3ZhbHVlIjo2NjE0NDM5NjI0NzY5LCJvZmZzZXQiOjE5OX0=",
        "node": {
          "title": "Serum Preset Pack - Innerbloom",
          "handle": "serum-preset-pack-innerbloom",
          "createdAt": "2021-09-25T19:33:27Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "70+ Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/innerbloom-serum_700x.png?v=1742468691"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-SerumPresets-Innerbloom-Pack_Demo_Short.mp3?v=1632599672"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Deep Sound Pack for Serum: Presets in underground style of Labels like Anjuna and artists like Rufus Du Sol, Yotto, Lane 8, Nils Hoffmann and Nora En Pure among others. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTYzMzkyMTkyNTc3LCJsYXN0X3ZhbHVlIjo2NTYzMzkyMTkyNTc3LCJvZmZzZXQiOjIxMX0=",
        "node": {
          "title": "Serum Preset Pack - Melodic House by Furcloud",
          "handle": "serum-presets-melodic-house",
          "createdAt": "2021-06-03T10:49:08Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "70+ Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/melodic-house-furcloud_700x.png?v=1742468807"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Serum_Presets_Melodic_House_Midi_Pre.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic House Sound Pack for Serum: Presets in underground style of Labels like Anjuna and artists like Ben Böhmer, Yotto, Lane 8, Nils Hoffmann and Nora En Pure among others. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDU2ODM4MTg1MjI3LCJsYXN0X3ZhbHVlIjo4NDU2ODM4MTg1MjI3LCJvZmZzZXQiOjczfQ==",
        "node": {
          "title": "Serum Presets - Bass Pack Vol.1",
          "handle": "serum-presets-bass-pack-vol-1",
          "createdAt": "2024-02-06T11:31:18Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "120+ Presets, 120+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-BassPackVol.1_PML317_700x.png?v=1707219175"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/SerumBassPackVol1_CollectionPreview.mp3?v=1707225441"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Serum Bass Sound Pack: Presets and MIDIs in the style of artists like Afterlife, Fucking Serious, Atlant, Tale of Us, Cassian, Agents of Time, Boris Brejcha and many more"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NDU2ODg0Mzg4MTA3LCJsYXN0X3ZhbHVlIjo4NDU2ODg0Mzg4MTA3LCJvZmZzZXQiOjcyfQ==",
        "node": {
          "title": "Serum Presets - Melodic House - Feelings",
          "handle": "serum-presets-melodic-house-feelings",
          "createdAt": "2024-02-06T12:42:51Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-Serum-MelodicHouseFeelings-Presets2_700x.png?v=1707368797"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/FeelingsCollectionPreview.mp3?v=1707225442"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic House Sound Pack for Serum: Presets and MIDIs. Inspired by artists and labels like Ben Böhmer, Tinlicker, Avoure, Avaion, Anjunadeep, Armada Music, This Never Happened, Colorize and Selected."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDE5Nzg1NTE1Mjc1LCJsYXN0X3ZhbHVlIjo4MDE5Nzg1NTE1Mjc1LCJvZmZzZXQiOjEzNH0=",
        "node": {
          "title": "Serum Presets: Essentials",
          "handle": "serum-presets-essentials",
          "createdAt": "2022-11-11T14:38:39Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "80+ Presets, 80+ Midi"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/Serumessentials_700x.png?v=1668189844"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/BS_Shortsupport.mp3?v=1668175744"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Serum Preset Pack: Presets and MIDIs in the styles of Deep House, Progressive House, Future House, Future Bass and general EDM among others."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTc0NjQ1MzY3MDUxLCJsYXN0X3ZhbHVlIjo3OTc0NjQ1MzY3MDUxLCJvZmZzZXQiOjE1Nn0=",
        "node": {
          "title": "Serum Presets: House",
          "handle": "serum-presets-house",
          "createdAt": "2022-06-21T09:34:09Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "79 Presets, 79 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/house-vol-1_700x.png?v=1742468618"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Demo_-_House_Presets_by_Abstrakt_Music_Lab_01.mp3?v=1655825304"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Serum House Preset Pack: Presets and MIDIs in the style of artists like Joel Corry, Meduza, Kream, Sofi Tukker, Martin Ikin, Sidepiece, Gorgon City, Jonas Blue, Diplo and labels like Selected, Defected, Mad Decent among others."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNDM3MzY0NTE4OTc3LCJsYXN0X3ZhbHVlIjoxNDM3MzY0NTE4OTc3LCJvZmZzZXQiOjMyN30=",
        "node": {
          "title": "Serum Presets: Melodic Techno",
          "handle": "serum-presets-melodic-techno",
          "createdAt": "2018-08-09T21:52:14Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/melodic-echno-vol-1_700x.png?v=1742468732"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Serum_Presets_Melodic_Techno_Pre.mp3?12845007007806203320"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "100+ Professionally Crafted Serum Presets and MIDI Files inspired by the style of artists like Rodriguez Jr., Olander, Bodzin, Afterlife."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDE5Nzg2NDAwMDExLCJsYXN0X3ZhbHVlIjo4MDE5Nzg2NDAwMDExLCJvZmZzZXQiOjEzM30=",
        "node": {
          "title": "Serum Presets: Ultra",
          "handle": "serum-presets-ultra",
          "createdAt": "2022-11-11T14:41:45Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100+ Presets, 100+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/SerumUltra_700x.png?v=1668189685"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PL_Sapir.mp3?v=1668176567"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Serum Preset Pack: Presets and MIDIs in the styles of Deep House, Progressive House, Future House, Future Bass and general EDM among others."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDE5Nzg0MDQwNzE1LCJsYXN0X3ZhbHVlIjo4MDE5Nzg0MDQwNzE1LCJvZmZzZXQiOjEzNX0=",
        "node": {
          "title": "Serum Presets: Vibes",
          "handle": "serum-presets-vibes",
          "createdAt": "2022-11-11T14:33:36Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "75+ Presets, 75+ MIDIs "
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/Serumvibes_700x.png?v=1668189508"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/BS_Pluckbass.mp3?v=1668168045"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Serum Preset Pack: Presets and MIDIs in the styles of Deep House, Progressive House, Future House, Future Bass and general EDM among others."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTkzNDAwNTA0Mzg1LCJsYXN0X3ZhbHVlIjo2NTkzNDAwNTA0Mzg1LCJvZmZzZXQiOjIwMH0=",
        "node": {
          "title": "Serum Techno Presets Vol.2",
          "handle": "serum-techno-pack-vol-2",
          "createdAt": "2021-08-26T15:35:38Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/techno-vol-2_700x.png?v=1742470286"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_SerumTechnoPreset2.mp3?v=1631092427"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Berlin Techno Sound Pack for Serum: Presets and MIDIs in underground style of Labels like Afterlife, Drumcode, Systematic, Outta Limits, 1605 an Artists like Spektre, Woo York, Tale Of Us, Pan-Pot, Stan Kolev, Matan Caspi and Umek among others. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MzE3MDU1MzAzOTQ3LCJsYXN0X3ZhbHVlIjo4MzE3MDU1MzAzOTQ3LCJvZmZzZXQiOjkwfQ==",
        "node": {
          "title": "Serum Techno Presets Vol.3",
          "handle": "serum-techno-presets-vol-3",
          "createdAt": "2023-09-01T14:23:52Z",
          "pmlProductCategory": {
            "value": "presetPack--serum"
          },
          "catalogDescription": {
            "value": "100 Presets, 100 MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/techno-vol-3_700x.png?v=1742471002"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/SerumTechnoVol3Playbutton.mp3?v=1693583716"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Techno Sound Pack for Serum: Presets and MIDIs in the style of artists like Yubik, Massano, Anyma, Olivier Giacomotto, Silver Panda, Adriatique and many more."
          }
        }
      }
    ],
    "vital": [
      {
        "cursor": "eyJsYXN0X2lkIjo3OTkzNjEyNTk5NTYzLCJsYXN0X3ZhbHVlIjo3OTkzNjEyNTk5NTYzLCJvZmZzZXQiOjE1MH0=",
        "node": {
          "title": "Vital Preset Pack - Melodic House by Furcloud",
          "handle": "vital-preset-pack-melodic-house-by-furcloud",
          "createdAt": "2022-08-22T16:03:59Z",
          "pmlProductCategory": {
            "value": "presetPack--vital"
          },
          "catalogDescription": {
            "value": "70+ Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/vital-melodc-house3_700x.png?v=1661184651"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Melodic_House_Vital_Presets_by_Furcloud_PML_Demo.mp3?v=1661184941"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic House Sound Pack for Vital: Presets in underground style of Labels like Anjuna and artists like Ben Böhmer, Yotto, Lane 8, Nils Hoffmann and Nora En Pure among others. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzQ4OTExODYxODI1LCJsYXN0X3ZhbHVlIjo2NzQ4OTExODYxODI1LCJvZmZzZXQiOjE4MH0=",
        "node": {
          "title": "Vital Preset Pack for Melodic Techno and Techno",
          "handle": "melodic-techno-vital-presets",
          "createdAt": "2022-02-17T10:14:38Z",
          "pmlProductCategory": {
            "value": "presetPack--vital"
          },
          "catalogDescription": {
            "value": "60+ Presets"
          },
          "enhancedDescription": {
            "value": "Energize your sound through next-generation sonic feels, with 60+ expertly crafted Vital presets and MIDIs, detail-oriented, mapped and moving sounds offering width and richness that truly resonate."
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/VitalPresets-MelodicTechno_700x.png?v=1645092940"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Oceans_-_Melodic_House_Techno_Presets_For_Vital_01.mp3?v=1645027041"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Vital Preset Pack for Melodic Techno and Techno drawing inspiration from labels like Afterlife, Stil vor Talent, Sprout, Tronic, Diynamic, Anjunadeep, Embassy One and artists like Mind Against, Hidden Empire, Victor Ruiz, Artbat, Noir, Thomas Schumacher, Animal Picnic, ANNA, Alex Niggemann, Tale of us, CamelPhat, Denis Horvat, Fabrikation, Ben Böhmer, Widerberg, Charlotte de Witte, Oliver Huntemann, Amelie Lens, Keith Carnal,  Oxia, Olivier Giacomotto,  UMEK and labels like Afterlife, Stil vor Talent, Sprout, Tronic, Diynamic, Anjunadeep, Embassy One."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTY2MjE5MjA2OTIzLCJsYXN0X3ZhbHVlIjo3OTY2MjE5MjA2OTIzLCJvZmZzZXQiOjE2MX0=",
        "node": {
          "title": "Vital Presets: Afterlight - Melodic Deep, Techno",
          "handle": "vital-presets-afterlight-melodic-deep-techno",
          "createdAt": "2022-05-31T12:00:42Z",
          "pmlProductCategory": {
            "value": "presetPack--vital"
          },
          "catalogDescription": {
            "value": "60+ Presets"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/afterlight1_b61658f8-4cf6-4d83-a536-70ff671f844c_700x.png?v=1654016449"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Vital_Afterlight_PresetsDemo.mp3?v=1654251659"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A melodic techno & house preset pack for the all-powerful new synth on the market, Vital. These presets were created by Yion artist Yannek Maunz in the process of producing label released tracks."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2Nzc3NTA1NzEwMTQ1LCJsYXN0X3ZhbHVlIjo2Nzc3NTA1NzEwMTQ1LCJvZmZzZXQiOjE3Mn0=",
        "node": {
          "title": "Vital Presets: Cercle Deep Sounds (Melodic Techno, Deep, Underground)",
          "handle": "vital-presets-boiler-production",
          "createdAt": "2022-04-03T10:31:39Z",
          "pmlProductCategory": {
            "value": "presetPack--vital"
          },
          "catalogDescription": {
            "value": "80 Presets, 70+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/VitalPresetsCercleDeepvol1_700x.png?v=1654695375"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_FloorControl.mp3?256322585129784541"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "80 Deep House presets made for free VST synth Vital. Presets made for Deep House, Techno and Underground Genres. Inspired by artists like Boris Brechja, Solomun, Richie Hawtin, Maceo Plex, Stephan Bodzin and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTY2MzkwODQ1NzA3LCJsYXN0X3ZhbHVlIjo3OTY2MzkwODQ1NzA3LCJvZmZzZXQiOjE2MH0=",
        "node": {
          "title": "Vital Techno Presets",
          "handle": "vital-techno",
          "createdAt": "2022-05-31T14:26:53Z",
          "pmlProductCategory": {
            "value": "presetPack--vital"
          },
          "catalogDescription": {
            "value": "100+ Presets, 100+ MIDIs"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/vital_techno_700x.png?v=1654011977"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/VitalTechnoPresets.mp3?v=1654251659"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A melodic techno & house preset pack for the all-powerful new synth on the market, Vital. These presets were created by Yion artist Yannek Maunz in the process of producing label released tracks."
          }
        }
      }
    ]
  },
  "templates": {
    "templates": [
      {
        "cursor": "eyJsYXN0X2lkIjo3OTc0NjY5MzIwNDU5LCJsYXN0X3ZhbHVlIjo3OTc0NjY5MzIwNDU5LCJvZmZzZXQiOjE1NX0=",
        "node": {
          "title": "Breakbeat - Getting Away -  Ableton Template",
          "handle": "getting-away-breakbeat-ableton-template",
          "createdAt": "2022-06-21T10:29:48Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/abletonprojectfilebreakbeat2022-2_700x.png?v=1655933040"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Demo_Breakbeat_-_Bound_to_Divide_-_Getting_Away_01.mp3?v=1655825512"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Breakbeat, breaks Ableton Template. Download full arranged customizable mastered project file. All samples included!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2Nzg2MDE0NTQzOTM3LCJsYXN0X3ZhbHVlIjo2Nzg2MDE0NTQzOTM3LCJvZmZzZXQiOjE2OX0=",
        "node": {
          "title": "Classic Piano House - La Pianista - Ableton Project File",
          "handle": "la-pianista-classic-house-ableton-project-file",
          "createdAt": "2022-04-13T14:55:53Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/7pianista_700x.png?v=1649945373"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_La_Pianista_01_demopage_b7f76719-c5c0-47f1-a2de-ba40eda1a264.mp3?v=1649864064"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Download Classic House template designed for Ableton Live 10 incl. MIDI, presets, drum samples."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNDU5NTk5NTQwMjg5LCJsYXN0X3ZhbHVlIjoxNDU5NTk5NTQwMjg5LCJvZmZzZXQiOjMyNH0=",
        "node": {
          "title": "Classic Uplifting Trance - Taking You Back - Ableton Template",
          "handle": "classic-state-of-trance-ableton-template",
          "createdAt": "2018-08-19T16:35:08Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Classic_Uplifting_Trance_-_Ableton_Template_PML166_700x.png?v=1734361455"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre-Trance-Taking_You_Back_template.mp3?10632300211577066436"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "How to sound like Above and Beyond, A State Of Trance, Armada and Thrillseekers style. Download Uplifting trance template designed for Ableton Live 9 & Serum. "
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxODg1NTc5NTA5ODI1LCJsYXN0X3ZhbHVlIjoxODg1NTc5NTA5ODI1LCJvZmZzZXQiOjMwOH0=",
        "node": {
          "title": "Dark Progressive Techno - Darkside - Techno Ableton Template",
          "handle": "darkside-techno-ableton-template",
          "createdAt": "2018-11-21T15:20:44Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/darkside_700x.png?v=1603799293"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_Darkside_FknSrs_01.mp3?3127669378200489135"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Minimal Techno Template (Ableton Live 10 Suite). Download full arranged mastered project file in the style of Boris Brejcha and fcking serious."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNDAxMTAzMTIyNDk3LCJsYXN0X3ZhbHVlIjoxNDAxMTAzMTIyNDk3LCJvZmZzZXQiOjMzMX0=",
        "node": {
          "title": "Dark Progressive Techno - Desert - Ableton Template",
          "handle": "desert-ethereal-techno-ableton-template",
          "createdAt": "2018-07-26T11:06:56Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/EtherealTechnoDesert_700x.png?v=1615385849"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_Deserts_Template.mp3?11038040525979508711"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Deep Techno Template (Ableton Live 9, Massive, Moog bass). Download full arranged mastered project file in the style of Steyoyoke and Afterlife."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo0NjE0OTQzNjA0ODAxLCJsYXN0X3ZhbHVlIjo0NjE0OTQzNjA0ODAxLCJvZmZzZXQiOjIzNn0=",
        "node": {
          "title": "Dark Progressive Techno - Interstellar - Ableton Template",
          "handle": "interstellar-techno-ableton-template",
          "createdAt": "2020-11-12T14:53:10Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/interstellar-techno-product-box_700x.png?v=1615888738"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/InterstellarTechnoTemplateDemo.mp3?v=1623669781"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": null
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoyMDMyNDcxMDE1NDg5LCJsYXN0X3ZhbHVlIjoyMDMyNDcxMDE1NDg5LCJvZmZzZXQiOjI5MX0=",
        "node": {
          "title": "House - DIABLO EDM - Ableton Live Template",
          "handle": "diablo-edm-ableton-live-template",
          "createdAt": "2019-02-14T18:32:08Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/DonDiablo_box_700x.png?v=1621942496"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": "Deconstruct a ready-to-release Future House track produced with Ableton Live 10 + Serum. Download a fully arranged and mastered Ableton Project file inspired by the style of labels like Armada and Spinnin' Records."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNzQ2ODU1MTk4OTAsImxhc3RfdmFsdWUiOjE3NDY4NTUxOTg5MCwib2Zmc2V0IjozNDZ9",
        "node": {
          "title": "House - Voorn Style - Ableton Template",
          "handle": "voorn-style-ableton-house-template",
          "createdAt": "2018-02-08T20:52:13Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/HouseVoornStyle_700x.png?v=1615391136"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Joris_Voorn_Style_Ableton_Meta_Preview.mp3?4927295503089063782"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "A professionally produced House track using Ableton Live + Vital. Download the samples, midi and fully arranged and mastered Ableton project made in the style of Joris Voorn.\n\n\n\n\n\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTY3ODA2MDYyODU5LCJsYXN0X3ZhbHVlIjo3OTY3ODA2MDYyODU5LCJvZmZzZXQiOjE1N30=",
        "node": {
          "title": "Melodic House - Together Again - Ableton Template by Solanca",
          "handle": "together-again-melodic-house-ableton-template-by-solanca",
          "createdAt": "2022-06-03T09:54:00Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/solanca82_700x.png?v=1655973387"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Solanca_TogetherAgain_demo.mp3?v=1654257598"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Melodic House Ableton Template. Download full arranged customizable mastered project file. All samples included!\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5NzMxOTk1ODU4LCJsYXN0X3ZhbHVlIjo5NzMxOTk1ODU4LCJvZmZzZXQiOjM2Mn0=",
        "node": {
          "title": "Melodic Techno - Analog Moods - Ableton Template",
          "handle": "analog-moods-ableton-template",
          "createdAt": "2017-06-08T18:21:36Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/Deepanalogmoods_700x.png?v=1615389637"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_Analog_Moods_Template.mp3?14887017311874516038"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Deep Techno Template (Ableton Live 10 + Vital). Download full arranged mastered project file in the style of Rodriguez Jr. Stephan Bodzin"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTk3MzQ4OTM3OTk1LCJsYXN0X3ZhbHVlIjo3OTk3MzQ4OTM3OTk1LCJvZmZzZXQiOjE0Nn0=",
        "node": {
          "title": "Melodic Techno - Become One - Ableton Template by Solanca",
          "handle": "become-one-melodic-techno-ableton-template-by-solanca",
          "createdAt": "2022-09-05T11:15:18Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PML-MelodicTechnoTemplate-BecomeOnebySolanca_PML253_700x.png?v=1662376574"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Solanca_-_Become_1_PREVIEW.mp3?v=1662376603"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Melodic Techno Ableton Template. Download a fully arranged, customizable, mastered project file. All samples and presets included!\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTY3NTI4ODQ1NTc5LCJsYXN0X3ZhbHVlIjo3OTY3NTI4ODQ1NTc5LCJvZmZzZXQiOjE1OH0=",
        "node": {
          "title": "Melodic Techno - Centuries - Ableton Template (by Dahu)",
          "handle": "centuries-modern-melodic-techno-ableton-template-by-dahu",
          "createdAt": "2022-06-02T15:43:41Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/dahu22_700x.png?v=1654266026"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Dahu_Centuries_Demo.mp3?v=1654257598"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Melodic Techno Ableton Template. Download full arranged customizable mastered project file. All samples included!\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTc1MzE2ODI4MjI1LCJsYXN0X3ZhbHVlIjo2NTc1MzE2ODI4MjI1LCJvZmZzZXQiOjIwN30=",
        "node": {
          "title": "Melodic Techno - Empire of Afterlife - Ableton Template",
          "handle": "empire-of-afterlife-melodic-techno-ableton-template",
          "createdAt": "2021-07-14T08:42:38Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/Templatemelodictechnoempireofafterlife_700x.png?v=1626253077"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Demo-PML_-_Empire_of_Afterlife_-_Ableton_Template.mp3?v=1626253539"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Techno Template (Ableton Live, Serum, Diva). Download full arranged customizable mastered project file in style of Afterlife. Samples inside.\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo1OTI2NTQ2NzU3LCJsYXN0X3ZhbHVlIjo1OTI2NTQ2NzU3LCJvZmZzZXQiOjQxMX0=",
        "node": {
          "title": "Melodic Techno - Giants - Ableton Template",
          "handle": "melodic-techno-francois-giants-ableton-template",
          "createdAt": "2016-07-16T21:24:57Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/MelodicTechno-FrancoisGiants-AbletonTemplate_PML141_700x.png?v=1734348707"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_Giants.mp3?7690710370681891083"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Club ready ableton live melodic techno template using Ableton Live and Native instruments only. Step by step production course available."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNDg5NTMyMjIzNTUzLCJsYXN0X3ZhbHVlIjoxNDg5NTMyMjIzNTUzLCJvZmZzZXQiOjMyMX0=",
        "node": {
          "title": "Melodic Techno - Godzin - Ableton Template",
          "handle": "godzin-bass-techno-ableton-template",
          "createdAt": "2018-09-10T18:57:00Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/godzin_700x.png?v=1615392375"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_Godzin_Sound_Design_Preview_01.mp3?6406463343983945463"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Melodic Techno Template (Ableton Live 9, Diva). Download full arranged mastered project file in the style of Rodriguez Jr. Stephan Bodzin"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NzQ5MTU2OTk5MjMzLCJsYXN0X3ZhbHVlIjo2NzQ5MTU2OTk5MjMzLCJvZmZzZXQiOjE3OX0=",
        "node": {
          "title": "Melodic Techno - Odyssey - Ableton Project File by Johannes Menzel",
          "handle": "odyssey-melodic-techno-ableton-project-file",
          "createdAt": "2022-02-17T19:02:52Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/odyseey_700x.png?v=1645198134"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Odyssey_MelodicTechno.mp3?v=1645189845"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Download Melodic Techno template designed for Ableton Live 11 Suite and Diva incl. MIDI, presets, drum samples."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo3OTk3ODYxODU1NDk5LCJsYXN0X3ZhbHVlIjo3OTk3ODYxODU1NDk5LCJvZmZzZXQiOjE0NX0=",
        "node": {
          "title": "Melodic Techno - Substances - Ableton Template",
          "handle": "substances-melodic-techno-ableton-template",
          "createdAt": "2022-09-06T09:32:11Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PACK_Mel-techno-franz3_700x.png?v=1662458107"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-DEMO-Melodic-Techno-Substances_snippet__01new.mp3?v=1662456879"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Melodic Techno Ableton Template. Download a fully arranged, customizable, mastered project file. All samples and presets included!\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTQzNTY5ODQ2MzM3LCJsYXN0X3ZhbHVlIjo2NTQzNTY5ODQ2MzM3LCJvZmZzZXQiOjIxOX0=",
        "node": {
          "title": "Progressive Melodic Techno - Equinox - Ableton Template",
          "handle": "equinox-progressive-melodic-techno-ableton-template",
          "createdAt": "2021-03-25T09:48:04Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/equinox-techno_700x.png?v=1616665720"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/EquinoxTemplate.mp3?v=1623664346"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "See Inside A Professionally Produced Melodic Progressive Techno Project. Full New Ableton Project File, Custom Diva Presets, Samples, Midi and More!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxODIzMDQ3MzUyNTAsImxhc3RfdmFsdWUiOjE4MjMwNDczNTI1MCwib2Zmc2V0IjozNDR9",
        "node": {
          "title": "Psytrance - Mantra - Vini Vici Style",
          "handle": "psytrance-mantra-vini-vici-style-ableton-template",
          "createdAt": "2018-02-15T17:00:09Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/Mantra_35b9bca3-3bd2-4305-b4be-67b8f8b51470_700x.jpg?v=1586363468"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Psy-Trance_Mantra_Template_Final_3.2_Meta_Preview.mp3?10033389498902836702"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Vini Vici  Hilight Tribe, Vini Vici Infected Mushroom Eat Static Ace Ventura & Lish Eat Static Etnica Transwave Shpongle Astrix Juno Reactor Skazi GMS Astral Projection Cosma Cosma X-Dream Hallucinogen Union Timmy Trumpet Psychedelic Psytechno Psybreaks Progressive Tribal Nitzhonot Psychill Goa Psy Tech-Trance\n\n\n\n\n\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxOTQ5MjkwODIzNzQ1LCJsYXN0X3ZhbHVlIjoxOTQ5MjkwODIzNzQ1LCJvZmZzZXQiOjI5N30=",
        "node": {
          "title": "Psytrance - Van Burn - Ableton EDM Template",
          "handle": "van-burn-ableton-edm-template",
          "createdAt": "2019-01-05T16:07:26Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/vanburn_f0505b9c-e2d2-4ec8-8667-0d973a3dbf5c_700x.png?v=1638789273"
          },
          "music": null,
          "musicPersists": null,
          "seo": {
            "description": null
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjozOTIzNDU2NzUzNzI5LCJsYXN0X3ZhbHVlIjozOTIzNDU2NzUzNzI5LCJvZmZzZXQiOjI4Mn0=",
        "node": {
          "title": "Synthwave - Good Intentions - Ableton Template",
          "handle": "good-intentions-synthwave-ableton-template",
          "createdAt": "2019-07-04T12:35:29Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/GoodIntentions_700x.png?v=1603793852"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Nervz_-_Good_Intentions_feat._Alex_Bleiziffer_preview.mp3?1550"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional SYNTHWAVE Ableton project file with original vocals. In the style of Daft Punk, Muse, Justice and synth-heavy 80s Italo Dance."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxNTMxMjM1MTA2ODgxLCJsYXN0X3ZhbHVlIjoxNTMxMjM1MTA2ODgxLCJvZmZzZXQiOjMyMH0=",
        "node": {
          "title": "Techno - Amelie - Ableton Template",
          "handle": "amelie-dark-techno-ableton-template",
          "createdAt": "2018-10-10T16:08:21Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/amelie2_700x.png?v=1615219601"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/Pre_PML_Amelie_Techno_Template.mp3?2629716106244060684"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional Dark Techno Template (Ableton Live 10, Optional: Serum). Download full arranged mastered project file in the style of Amelie from Second State"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo1NzgyOTE0NjkzLCJsYXN0X3ZhbHVlIjo1NzgyOTE0NjkzLCJvZmZzZXQiOjQxNX0=",
        "node": {
          "title": "Techno - Floor Control - Ableton Template",
          "handle": "floor-control-techno-ableton-template",
          "createdAt": "2016-06-15T19:01:26Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/TechnoFloorControl_700x.png?v=1614177708"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_FloorControl.mp3?2109375435302803108"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Berlin Techno Template (Ableton Live, NI Massive). Download full arranged customizable mastered project file in style of ANNA, Boris Brejcha. Samples inside.\n\n\n"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5NjM1MTQ0Nzg2LCJsYXN0X3ZhbHVlIjo5NjM1MTQ0Nzg2LCJvZmZzZXQiOjM2NH0=",
        "node": {
          "title": "Techno - Moon Rocks - Ableton Template",
          "handle": "moon-rocks-ableton-techno-template",
          "createdAt": "2017-05-27T14:38:12Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Moon_Rocks_-_Ableton_Techno_Template_153_700x.png?v=1734353525"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_Pre_Template_MoonRocks.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Download Techno template designed for Ableton Live 10 & Vital. Making Deep Techno beats like Enrico Sanguiliano, Drumcode, ANNA, Boris Brejcha, Oliver Huntemann, Extrawelt, Dusty Kid, Pan Pot, Microtrauma, Gabriel Ananda, Gregor Tresher, Anja Schneider, Solee,  Einmusik and more!"
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjozOTMxMzE1ODk2Mzg1LCJsYXN0X3ZhbHVlIjozOTMxMzE1ODk2Mzg1LCJvZmZzZXQiOjI4MX0=",
        "node": {
          "title": "Techno - Plurality - Ableton Template",
          "handle": "plurality-techno-template",
          "createdAt": "2019-07-17T18:44:06Z",
          "pmlProductCategory": {
            "value": "templates--templates"
          },
          "catalogDescription": {
            "value": "Ableton Project File (fully editable)"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/plurality_700x.png?v=1603799066"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Plurality_preview128.mp3?2994"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Deconstruct a Ready to Release Track! Download a fully arranged and mastered Ableton Project file in the style of labels like Kompakt Extra, Drumcode, Hotflush Recordings and artists like ANNA, Hidden Empire, Joyhauser, Wehbba, UMEK, Victor Ruiz."
          }
        }
      }
    ]
  },
  "midiPacks": {
    "midiPacks": [
      {
        "cursor": "eyJsYXN0X2lkIjo4NjUzNzI3MTA1MjkxLCJsYXN0X3ZhbHVlIjo4NjUzNzI3MTA1MjkxLCJvZmZzZXQiOjU5fQ==",
        "node": {
          "title": "Infinite Dreams - MIDI Pack by Francois",
          "handle": "infinite-dreams-midi-pack",
          "createdAt": "2024-06-11T09:07:51Z",
          "pmlProductCategory": {
            "value": "midiPacks--midiPacks"
          },
          "catalogDescription": {
            "value": "100+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML335-InfiniteDreams-MIDIPackbyFrancois_700x.png?v=1718096917"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/InfiniteDreamsDemo.mp3?v=1718105434"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional MIDI Pack featuring more than 100+ quality MIDI files. Each file offers a complete track idea, whether theme-based, pluck-driven, or stab-focused. Designed for House, Melodic House, Progressive House, Melodic Deep, and Melodic Techno at 120-128 bpm. 100% Royalty-Free."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo5MDQ3NjE4ODE0MjE5LCJsYXN0X3ZhbHVlIjo5MDQ3NjE4ODE0MjE5LCJvZmZzZXQiOjMwfQ==",
        "node": {
          "title": "Infinite Dreams Vol.2 - MIDI Pack",
          "handle": "infinite-dreams-vol-2-midi-pack",
          "createdAt": "2025-02-17T16:00:42Z",
          "pmlProductCategory": {
            "value": "midiPacks--midiPacks"
          },
          "catalogDescription": {
            "value": "100+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MIDIThemes-InfiniteDreamsVol.2_PML362_700x.png?v=1739808064"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MIDI_2_-_DEMO_MIX_New_v2.1.mp3?v=1741615762"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Struggling to start your next track? This professional MIDI pack is packed with inspiring\nmelodies, themes, and plucks—designed to spark creativity and break through writer’s block instantly. 100% Royalty-Free."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDE5ODYzODE2NjI4MywibGFzdF92YWx1ZSI6MTAxOTg2MzgxNjYyODMsIm9mZnNldCI6MTh9",
        "node": {
          "title": "Infinite Dreams Vol.3 - MIDI Pack",
          "handle": "infinite-dreams-vol-3-midi-pack",
          "createdAt": "2025-05-26T13:13:16Z",
          "pmlProductCategory": {
            "value": "midiPacks--midiPacks"
          },
          "catalogDescription": {
            "value": "120+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Infiinite-dreams-midi-3_700x.png?v=1748265233"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MIDI-InfiniteDreams3-Demo1_01-256.mp3?v=1748273698"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Struggling to start your next track? This professional MIDI pack is packed with inspiring\nmelodies, themes, and plucks—designed to spark creativity and break through writer’s block instantly. 100% Royalty-Free."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjoxMDcxNTUwNDUwOTE5NSwibGFzdF92YWx1ZSI6MTA3MTU1MDQ1MDkxOTUsIm9mZnNldCI6MH0=",
        "node": {
          "title": "Infinite Dreams Vol.4 - MIDI Pack",
          "handle": "infinite-dreams-vol-4-midi-pack",
          "createdAt": "2025-09-09T08:35:27Z",
          "pmlProductCategory": {
            "value": "midiPacks--midiPacks"
          },
          "catalogDescription": {
            "value": "130+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_MIDI_Themes_-_Infinite_Dreams_Vol._4_PML390_700x.png?v=1757406950"
          },
          "music": {
            "value": "https://public.productionmusiclive.com/audio/gem-1757407360960.2969-InfiniteDreamsVol4_DJMix_v1.mp3"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Struggling to start your next track? This professional MIDI pack is packed with inspiring\nmelodies, themes, and plucks—designed to spark creativity and break through writer’s block instantly. 100% Royalty-Free."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4MDA1NzY2NTQ1Njc1LCJsYXN0X3ZhbHVlIjo4MDA1NzY2NTQ1Njc1LCJvZmZzZXQiOjE0MH0=",
        "node": {
          "title": "MIDI Pack - Chords Vibes (Melodies, Chord Progressions, Stab Loops)",
          "handle": "midi-pack-chord-vibes",
          "createdAt": "2022-09-29T18:33:00Z",
          "pmlProductCategory": {
            "value": "midiPacks--midiPacks"
          },
          "catalogDescription": {
            "value": "500+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/products/PACK_MIDI_chords_v3_700x.png?v=1664872733"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML_-_Midi_Pack_PreviewPRE.mp3?3049"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Beautiful MIDI Files Pack - Amazing Chord Progressions, Melodies, Bass, Plucks and Leads ready to use in your own productions. Download 610+ Midi Files."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo4NjgyNjM2OTY4MjAzLCJsYXN0X3ZhbHVlIjo4NjgyNjM2OTY4MjAzLCJvZmZzZXQiOjU3fQ==",
        "node": {
          "title": "MIDI Pack - Inner Glow - Melodic House and Techno",
          "handle": "inner-glow-midi-pack",
          "createdAt": "2024-06-26T13:33:14Z",
          "pmlProductCategory": {
            "value": "midiPacks--midiPacks"
          },
          "catalogDescription": {
            "value": "300+ MIDI Files, Bonus Inspirational Ableton File"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/PML-MIDIPack-InnerGlow_700x.png?v=1719408861"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/InnerGlowMidiPackDemo.mp3?v=1719581358"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Professional MIDI Pack featuring more than 500+ quality MIDI files created for writing warm, deep and moody tracks.\nSave valuable production time and get inspired with these ready to use arpeggios, progressions, leads and bass midis designed at 120-126 bpm."
          }
        }
      },
      {
        "cursor": "eyJsYXN0X2lkIjo2NTYzMTQxOTQzMzYxLCJsYXN0X3ZhbHVlIjo2NTYzMTQxOTQzMzYxLCJvZmZzZXQiOjIxMn0=",
        "node": {
          "title": "Melodic Techno MIDI Pack Vol. 2 (Melodies, Arpeggios (Arps), Plucks and more)",
          "handle": "melodic-techno-midi-pack-vol-2-melodies-arpeggios-arps-plucks-and-more",
          "createdAt": "2021-06-02T14:09:09Z",
          "pmlProductCategory": {
            "value": "midiPacks--midiPacks"
          },
          "catalogDescription": {
            "value": "100+ MIDI Files"
          },
          "enhancedDescription": null,
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0993/3800/files/Mind_Escape_700x.png?v=1719390338"
          },
          "music": {
            "value": "https://cdn.shopify.com/s/files/1/0993/3800/files/MelodicTechnoMidiPackVol2Demo.mp3?v=1623422225"
          },
          "musicPersists": {
            "value": "1"
          },
          "seo": {
            "description": "Melodic Techno MIDI Files Pack - Chord Progressions, Melodies, Amazing Arpeggios, Leads ready to use in your own productions. Download 100+ Midi Files."
          }
        }
      }
    ]
  }
}
